import React, { useEffect, useState, useCallback, useRef } from "react";
import axios from "axios";
import { Space } from "antd";
import { useNavigate } from "react-router-dom";
import { Bars } from "react-loader-spinner";
import movementicon from "../assets/average_tradeall.png";
import eye_btn_tooltip from "../assets/IBUTTON.png";
import color1 from "../assets/highest_average.png";
import color2 from "../assets/second_highest_average.png";
import color3 from "../assets/third_highest_average.png";
import livegraph_icon from "../assets/line_chart.png";
import color4 from "../assets/color4.png";
import color5 from "../assets/color5.png";
import color6 from "../assets/color6.png";
import { IoArrowBack } from "react-icons/io5";
import color7 from "../assets/color7.png";
import color8 from "../assets/color8.png";
import color9 from "../assets/color9.png";

import crossicon from "../assets/cross1.png";
import refresh_icon from "../assets/refresh.png";
import logout_eye_btn from "../assets/IBUTTON.png";
import dateicon from "../assets/date.png";
import eventicon from "../assets/event.png";
import timeicon from "../assets/time1).png";
import locationicon from "../assets/location(1).png";
import impacticon from "../assets/impact(1).png";
import frequencyicon from "../assets/calendar(1).png";
import RingLoader from "react-spinners/RingLoader";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import UserNavbar from "../components/user/userNavbar";
import styles from "../components/tradeall.module.css";
import moment from "moment";
const EventshistoryUser_AfterRelease = () => {
  const navigate = useNavigate();
  const [off_minutebuttons1, setoff_minutebuttons1] = useState(true);
  const [off_minutebuttons2, setoff_minutebuttons2] = useState(true);
  const [off_minutebuttons3, setoff_minutebuttons3] = useState(true);
  const [off_minutebuttons4, setoff_minutebuttons4] = useState(true);

  const [run_modalloader, setRun_modalloader] = useState(true);
  const [run_clickedevent_dateapi, setRunclickedevent_dateapi] =
    useState(false);
  const [run_clickedevent_dateapi2, setRunclickedevent_dateapi2] =
    useState(false);
  const [runclickedevent_dateapi3, setRunclickedevent_dateapi3] =
    useState(false);
  const [Loading_3rdtable, setLoading_3rdtable] = useState(false);

  const [timeclickedurl_state, setTimeclickedurl_state] = useState(1);

  const [isgraphbuttonDisabled, setIsgraphbuttonDisbled] = useState(false);
  const [optionValue, setOptionValue] = useState("Last 6");
  const [avgOfThirdTable, setAvgOfThirdTable] = useState(0);

  const [variance_Color, setvariance_Color] = useState("");
  const [avg_ofthirdtable_usd, setAvg_ofthirdtable_usd] = useState(null);
  const [avg_ofthirdtable_jpy, setAvg_ofthirdtable_jpy] = useState(null);
  const [avg_ofthirdtable_nzd, setAvg_ofthirdtable_nzd] = useState(null);
  const [avg_ofthirdtable_eur, setAvg_ofthirdtable_eur] = useState(null);
  const [avg_ofthirdtable_chf, setAvg_ofthirdtable_chf] = useState(null);
  const [avg_ofthirdtable_aud, setAvg_ofthirdtable_aud] = useState(null);
  const [avg_ofthirdtable_cad, setAvg_ofthirdtable_cad] = useState(null);

  // <-----5 min H-l ------>
  const [finalAvg_ofmaxof5min_usd, setfinalAvg_ofmaxof5min_usd] =
    useState(null);
  const [finalAvg_ofmaxof5min_jpy, setfinalAvg_ofmaxof5min_jpy] =
    useState(null);
  const [finalAvg_ofmaxof5min_nzd, setfinalAvg_ofmaxof5min_nzd] =
    useState(null);
  const [finalAvg_ofmaxof5min_eur, setfinalAvg_ofmaxof5min_eur] =
    useState(null);
  const [finalAvg_ofmaxof5min_chf, setfinalAvg_ofmaxof5min_chf] =
    useState(null);
  const [finalAvg_ofmaxof5min_aud, setfinalAvg_ofmaxof5min_aud] =
    useState(null);
  const [finalAvg_ofmaxof5min_cad, setfinalAvg_ofmaxof5min_cad] =
    useState(null);

  const [eventname_forerror, seteventname_forerror] = useState("");

  // <----------------here is the final averge of flat points---------->
  const [finalAvg_ofmaxof5min_usd_flat0, setfinalAvg_ofmaxof5min_usd_flat0] =
    useState(null);
  const [finalAvg_ofmaxof5min_jpy_flat0, setfinalAvg_ofmaxof5min_jpy_flat0] =
    useState(null);
  const [finalAvg_ofmaxof5min_nzd_flat0, setfinalAvg_ofmaxof5min_nzd_flat0] =
    useState(null);
  const [finalAvg_ofmaxof5min_eur_flat0, setfinalAvg_ofmaxof5min_eur_flat0] =
    useState(null);
  const [finalAvg_ofmaxof5min_chf_flat0, setfinalAvg_ofmaxof5min_chf_flat0] =
    useState(null);
  const [finalAvg_ofmaxof5min_aud_flat0, setfinalAvg_ofmaxof5min_aud_flat0] =
    useState(null);
  const [finalAvg_ofmaxof5min_cad_flat0, setfinalAvg_ofmaxof5min_cad_flat0] =
    useState(null);

  // <----5min H-l---->
  const [avg_ofthirdtable_usd_flat0, setAvg_ofthirdtable_usd_flat0] =
    useState(null);
  const [avg_ofthirdtable_jpy_flat0, setAvg_ofthirdtable_jpy_flat0] =
    useState(null);
  const [avg_ofthirdtable_nzd_flat0, setAvg_ofthirdtable_nzd_flat0] =
    useState(null);
  const [avg_ofthirdtable_eur_flat0, setAvg_ofthirdtable_eur_flat0] =
    useState(null);
  const [avg_ofthirdtable_chf_flat0, setAvg_ofthirdtable_chf_flat0] =
    useState(null);
  const [avg_ofthirdtable_aud_flat0, setAvg_ofthirdtable_aud_flat0] =
    useState(null);
  const [avg_ofthirdtable_cad_flat0, setAvg_ofthirdtable_cad_flat0] =
    useState(null);

  const [isReloadLoading, setIsReloadLoading] = useState(false);
  const [averageHighLow_usddata, setAverageHighLow_usddata] = useState([]);
  const [averageHighLow_jpydata, setAverageHighLow_jpydata] = useState([]);
  const [averageHighLow_nzddata, setAverageHighLow_nzddata] = useState([]);
  const [averageHighLow_eurdata, setAverageHighLow_eurdata] = useState([]);
  const [averageHighLow_chfdata, setAverageHighLow_chfdata] = useState([]);
  const [averageHighLow_auddata, setAverageHighLow_auddata] = useState([]);
  const [averageHighLow_caddata, setAverageHighLow_caddata] = useState([]);

  const [maxHighLow_usddata_3rdcol, setmaxHighLow_usddata_3rdcol] = useState(
    []
  );
  const [maxHighHighLow_jpydata_3rdcol, setmaxHighHighLow_jpydata_3rdcol] =
    useState([]);
  const [maxHighHighLow_nzddata_3rdcol, setmaxHighHighLow_nzddata_3rdcol] =
    useState([]);
  const [maxHighHighLow_eurdata_3rdcol, setmaxHighHighLow_eurdata_3rdcol] =
    useState([]);
  const [maxHighHighLow_chfdata_3rdcol, setmaxHighHighLow_chfdata_3rdcol] =
    useState([]);
  const [maxHighHighLow_auddata_3rdcol, setmaxHighHighLow_auddata_3rdcol] =
    useState([]);
  const [maxHighHighLow_caddata_3rdcol, setmaxHighHighLow_caddata_3rdcol] =
    useState([]);

  // <-----2nd table---->
  // <----2nd block--->
  const [setmaxCloseOpen_3rdcol_2ndtable] = useState([]);

  const [
    maxCloseOpen_usddata_3rdcol_2ndtable,
    setmaxHighLow_usddata_3rdcol_2ndtable,
  ] = useState([]);
  const [
    maxCloseOpen_jpydata_3rdcol_2ndtable,
    setmaxCloseOpen_jpydata_3rdcol_2ndtable,
  ] = useState([]);
  const [
    maxCloseOpen_nzddata_3rdcol_2ndtable,
    setmaxCloseOpen_nzddata_3rdcol_2ndtable,
  ] = useState([]);
  const [
    maxCloseOpen_eurdata_3rdcol_2ndtable,
    setmaxCloseOpen_eurdata_3rdcol_2ndtable,
  ] = useState([]);
  const [
    maxCloseOpen_chfdata_3rdcol_2ndtable,
    setmaxCloseOpen_chfdata_3rdcol_2ndtable,
  ] = useState([]);
  const [
    maxCloseOpen_auddata_3rdcol_2ndtable,
    setmaxCloseOpen_auddata_3rdcol_2ndtable,
  ] = useState([]);
  const [
    maxCloseOpen_caddata_3rdcol_2ndtable,
    setmaxCloseOpen_caddata_3rdcol_2ndtable,
  ] = useState([]);

  const [errorMessage, setErrorMessage] = useState("");
  const [eventHistory, setEventHistory] = useState([]);
  const [eventHistory2, setEventHistory2] = useState([]);
  const [clickedtimeButton, setClickedtimeButton] = useState("1min");
  const [country, setCountry] = useState("");
  const [event, setEvent] = useState("");
  const [impact, setimpact] = useState("");
  const [date, setdate] = useState("");
  const [time, settime] = useState("");

  const [impacthighlow, setimpacthighlow] = useState([]);
  const [impacthighlowbeforethis, setimpacthighlowbeforethis] = useState([]);
  const [modalimpactdatabeforetime, setmodalimpactdatabeforetime] = useState(
    []
  );
  const [modalimpactdataontime, setmodalimpactdataontime] = useState([]);
  const [usddata, setusddata] = useState([]);
  const [jpydata, setjpydata] = useState([]);
  const [gbpnzddata, setgbpnzddata] = useState([]);
  const [eurgbpdata, seteurgbpdata] = useState([]);
  const [gbpchfdata, setgbpchfdata] = useState([]);
  const [gbpauddata, setgbpauddata] = useState([]);
  const [gbpcaddata, setgbpcaddata] = useState([]);

  const [usddata_avg, setusddata_avg] = useState([]);
  const [jpydata_avg, setjpydata_avg] = useState([]);
  const [gbpnzddata_avg, setgbpnzddata_avg] = useState([]);
  const [eurgbpdata_avg, seteurgbpdata_avg] = useState([]);
  const [gbpchfdata_avg, setgbpchfdata_avg] = useState([]);
  const [gbpauddata_avg, setgbpauddata_avg] = useState([]);
  const [gbpcaddata_avg, setgbpcaddata_avg] = useState([]);

  const [usddata_5minadd, setusddata_5minadd] = useState([]);
  const [jpydata_5minadd, setjpydata_5minadd] = useState([]);
  const [gbpnzddata_5minadd, setgbpnzddata_5minadd] = useState([]);
  const [eurgbpdata_5minadd, seteurgbpdata_5minadd] = useState([]);
  const [gbpchfdata_5minadd, setgbpchfdata_5minadd] = useState([]);
  const [gbpauddata_5minadd, setgbpauddata_5minadd] = useState([]);
  const [gbpcaddata_5minadd, setgbpcaddata_5minadd] = useState([]);

  // <----2nd table---->
  const [usddata_5minadd_2ndtable, setusddata_5minadd_2ndtable] = useState([]);
  const [jpydata_5minadd_2ndtable, setjpydata_5minadd_2ndtable] = useState([]);
  const [gbpnzddata_5minadd_2ndtable, setgbpnzddata_5minadd_2ndtable] =
    useState([]);
  const [eurgbpdata_5minadd_2ndtable, seteurgbpdata_5minadd_2ndtable] =
    useState([]);
  const [gbpchfdata_5minadd_2ndtable, setgbpchfdata_5minadd_2ndtable] =
    useState([]);
  const [gbpauddata_5minadd_2ndtable, setgbpauddata_5minadd_2ndtable] =
    useState([]);
  const [gbpcaddata_5minadd_2ndtable, setgbpcaddata_5minadd_2ndtable] =
    useState([]);

  const [frequency_date, setFrequency_date] = useState();
  const [Loading, setLoading] = useState(false);
  const [sumActualEstimate, setSumActualEstimate] = useState(0);
  const [sumActualEstimatebyo, setSumActualEstimatebyo] = useState(0);

  const [sumActualPrevious, setSumActualPrevious] = useState(0);
  const [sumActualPreviousbyo, setSumActualPreviousbyo] = useState(0);

  const [sumfinalmovement, setSumfinalmovement] = useState(0);
  const [sumfinalmovementbyo, setSumfinalmovementbyo] = useState(0);

  const [selectedTime, setSelectedTime] = useState(1);
  const [allEventHistory, setAllEventHistory] = useState([]);
  const [allEventHistory2, setAllEventHistory2] = useState([]);

  const [averagegbpusddiff1, setAverageDiff] = useState(0);
  const [averagegbpusddiff2, setAverageDiff2] = useState(0);
  const [averagegbpusddiff3, setAverageDiff3] = useState(0);

  const [averagegbpjpydiff1, setavgjpydiff] = useState(0);
  const [averagegbpjpydiff2, setavgjpydiff2] = useState(0);
  const [averagegbpjpydiff3, setavgjpydiff3] = useState(0);

  const [averagegbpcaddiff1, setaveragegbpcaddiff1] = useState(0);
  const [averagegbpcaddiff2, setaveragegbpcaddiff2] = useState(0);
  const [averagegbpcaddiff3, setaveragegbpcaddiff3] = useState(0);

  const [averagegbpauddiff1, setaveragegbpauddiff1] = useState(0);
  const [averagegbpauddiff2, setaveragegbpauddiff2] = useState(0);
  const [averagegbpauddiff3, setaveragegbpauddiff3] = useState(0);

  const [averagegbpchfdiff1, setaveragegbpchfdiff1] = useState(0);
  const [averagegbpchfdiff2, setaveragegbpchfdiff2] = useState(0);
  const [averagegbpchfdiff3, setaveragegbpchfdiff3] = useState(0);

  const [averagegbpeurdiff1, setaveragegbpeurdiff1] = useState(0);
  const [averagegbpeurdiff2, setaveragegbpeurdiff2] = useState(0);
  const [averagegbpeurdiff3, setaveragegbpeurdiff3] = useState(0);

  const [averagegbpnzddiff1, setaveragegbpnzddiff1] = useState(0);
  const [averagegbpnzddiff2, setaveragegbpnzddiff2] = useState(0);
  const [averagegbpnzddiff3, setaveragegbpnzddiff3] = useState(0);

  // <<--------for flat 0 averages----->
  const [averagegbpusddiff1_flat0, setAverageDiff_flat0] = useState(0);
  const [averagegbpusddiff2_flat0, setAverageDiff2_flat0] = useState(0);
  const [averagegbpusddiff3_flat0, setAverageDiff3_flat0] = useState(0);

  const [averagegbpjpydiff1_flat0, setavgjpydiff_flat0] = useState(0);
  const [averagegbpjpydiff2_flat0, setavgjpydiff2_flat0] = useState(0);
  const [averagegbpjpydiff3_flat0, setavgjpydiff3_flat0] = useState(0);

  const [averagegbpcaddiff1_flat0, setaveragegbpcaddiff1_flat0] = useState(0);
  const [averagegbpcaddiff2_flat0, setaveragegbpcaddiff2_flat0] = useState(0);
  const [averagegbpcaddiff3_flat0, setaveragegbpcaddiff3_flat0] = useState(0);

  const [averagegbpauddiff1_flat0, setaveragegbpauddiff1_flat0] = useState(0);
  const [averagegbpauddiff2_flat0, setaveragegbpauddiff2_flat0] = useState(0);
  const [averagegbpauddiff3_flat0, setaveragegbpauddiff3_flat0] = useState(0);

  const [averagegbpchfdiff1_flat0, setaveragegbpchfdiff1_flat0] = useState(0);
  const [averagegbpchfdiff2_flat0, setaveragegbpchfdiff2_flat0] = useState(0);
  const [averagegbpchfdiff3_flat0, setaveragegbpchfdiff3_flat0] = useState(0);

  const [averagegbpeurdiff1_flat0, setaveragegbpeurdiff1_flat0] = useState(0);
  const [averagegbpeurdiff2_flat0, setaveragegbpeurdiff2_flat0] = useState(0);
  const [averagegbpeurdiff3_flat0, setaveragegbpeurdiff3_flat0] = useState(0);

  const [averagegbpnzddiff1_flat0, setaveragegbpnzddiff1_flat0] = useState(0);
  const [averagegbpnzddiff2_flat0, setaveragegbpnzddiff2_flat0] = useState(0);
  const [averagegbpnzddiff3_flat0, setaveragegbpnzddiff3_flat0] = useState(0);

  const [averageDifff, setAverageDifff] = useState(0);
  const [averageDifff2, setAverageDifff2] = useState(0);
  const [averageDifff3, setAverageDifff3] = useState(0);
  const [avgjpydifff, setavgjpydifff] = useState(0);
  const [avgjpydifff2, setavgjpydifff2] = useState(0);
  const [avgjpydifff3, setavgjpydifff3] = useState(0);

  const [averagegbpcadbyodiff1, setaveragegbpcadbyodiff1] = useState(0);
  const [averagegbpcadbyodiff2, setaveragegbpcadbyodiff2] = useState(0);
  const [averagegbpcadbyodiff3, setaveragegbpcadbyodiff3] = useState(0);

  const [averagegbpaudbyodiff1, setaveragegbpaudbyodiff1] = useState(0);
  const [averagegbpaudbyodiff2, setaveragegbpaudbyodiff2] = useState(0);
  const [averagegbpaudbyodiff3, setaveragegbpaudbyodiff3] = useState(0);

  const [averagegbpchfbyodiff1, setaveragegbpchfbyodiff1] = useState(0);
  const [averagegbpchfbyodiff2, setaveragegbpchfbyodiff2] = useState(0);
  const [averagegbpchfbyodiff3, setaveragegbpchfbyodiff3] = useState(0);

  const [averagegbpeurbyodiff1, setaveragegbpeurbyodiff1] = useState(0);
  const [averagegbpeurbyodiff2, setaveragegbpeurbyodiff2] = useState(0);
  const [averagegbpeurbyodiff3, setaveragegbpeurbyodiff3] = useState(0);

  const [averagegbpnzdbyodiff1, setaveragegbpnzdbyodiff1] = useState(0);
  const [averagegbpnzdbyodiff2, setaveragegbpnzdbyodiff2] = useState(0);
  const [averagegbpnzdbyodiff3, setaveragegbpnzdbyodiff3] = useState(0);

  // <000000>
  const [averageDifff_flat0, setAverageDifff_flat0] = useState(0);
  const [averageDifff2_flat0, setAverageDifff2_flat0] = useState(0);
  const [averageDifff3_flat0, setAverageDifff3_flat0] = useState(0);
  const [avgjpydifff_flat0, setavgjpydifff_flat0] = useState(0);
  const [avgjpydifff2_flat0, setavgjpydifff2_flat0] = useState(0);
  const [avgjpydifff3_flat0, setavgjpydifff3_flat0] = useState(0);

  const [averagegbpcadbyodiff1_flat0, setaveragegbpcadbyodiff1_flat0] =
    useState(0);
  const [averagegbpcadbyodiff2_flat0, setaveragegbpcadbyodiff2_flat0] =
    useState(0);
  const [averagegbpcadbyodiff3_flat0, setaveragegbpcadbyodiff3_flat0] =
    useState(0);

  const [averagegbpaudbyodiff1_flat0, setaveragegbpaudbyodiff1_flat0] =
    useState(0);
  const [averagegbpaudbyodiff2_flat0, setaveragegbpaudbyodiff2_flat0] =
    useState(0);
  const [averagegbpaudbyodiff3_flat0, setaveragegbpaudbyodiff3_flat0] =
    useState(0);

  const [averagegbpchfbyodiff1_flat0, setaveragegbpchfbyodiff1_flat0] =
    useState(0);
  const [averagegbpchfbyodiff2_flat0, setaveragegbpchfbyodiff2_flat0] =
    useState(0);
  const [averagegbpchfbyodiff3_flat0, setaveragegbpchfbyodiff3_flat0] =
    useState(0);

  const [averagegbpeurbyodiff1_flat0, setaveragegbpeurbyodiff1_flat0] =
    useState(0);
  const [averagegbpeurbyodiff2_flat0, setaveragegbpeurbyodiff2_flat0] =
    useState(0);
  const [averagegbpeurbyodiff3_flat0, setaveragegbpeurbyodiff3_flat0] =
    useState(0);

  const [averagegbpnzdbyodiff1_flat0, setaveragegbpnzdbyodiff1_flat0] =
    useState(0);
  const [averagegbpnzdbyodiff2_flat0, setaveragegbpnzdbyodiff2_flat0] =
    useState(0);
  const [averagegbpnzdbyodiff3_flat0, setaveragegbpnzdbyodiff3_flat0] =
    useState(0);

  const [eventimpactontimespecificdate, seteventimpactontimespecificdate] =
    useState();
  const [
    eventimpactbeforetimespecificdate,
    seteventimpactbeforetimespecificdate,
  ] = useState();

  // <----------------third table averge states---------------->
  const [averagegbpusddiff1_thirdtable, SetAveragegbpusddiff1_thirdtable] =
    useState(0);
  const [averagegbpjpydiff1_thirdtable, SetAveragegbpjpydiff1_thirdtable] =
    useState(0);
  const [averagegbpnzddiff1_thirdtable, SetAveragegbpnzddiff1_thirdtable] =
    useState(0);
  const [averagegbpeurdiff1_thirdtable, SetAveragegbpeurdiff1_thirdtable] =
    useState(0);
  const [averagegbpchfdiff1_thirdtable, SetAveragegbpchfdiff1_thirdtable] =
    useState(0);
  const [averagegbpauddiff1_thirdtable, SetAveragegbpauddiff1_thirdtable] =
    useState(0);
  const [averagegbpcaddiff1_thirdtable, SetAveragegbpcaddiff1_thirdtable] =
    useState(0);

  // <--------------third table flat 0 values----------->
  const [
    averagegbpusddiff1_flat0_thirdtable,
    setaveragegbpusddiff1_flat0_thirdtable,
  ] = useState(0);
  const [
    averagegbpjpydiff1_flat0_thirdtable,
    setaveragegbpjpydiff1_flat0_thirdtable,
  ] = useState(0);
  const [
    averagegbpnzddiff1_flat0_thirdtable,
    setaveragegbpnzddiff1_flat0_thirdtable,
  ] = useState(0);
  const [
    averagegbpeurdiff1_flat0_thirdtable,
    setaveragegbpeurdiff1_flat0_thirdtable,
  ] = useState(0);
  const [
    averagegbpchfdiff1_flat0_thirdtable,
    setaveragegbpchfdiff1_flat0_thirdtable,
  ] = useState(0);
  const [
    averagegbpauddiff1_flat0_thirdtable,
    setaveragegbpauddiff1_flat0_thirdtable,
  ] = useState(0);
  const [
    averagegbpcaddiff1_flat0_thirdtable,
    setaveragegbpcaddiff1_flat0_thirdtable,
  ] = useState(0);

  const [clickeddate_Loading, setclickeddate_Loading] = useState(true);
  const [modalShow, setModalshow] = useState(false);

  const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltip2, setShowTooltip2] = useState(false);
  const [showTooltip3, setShowTooltip3] = useState(false);
  const tooltipRef = useRef(null);

  const handleImageClick = (event) => {
    event.stopPropagation(); // Prevent immediate closing on click
    setShowTooltip((prev) => !prev);
  };
  const handleImageClick2 = (event) => {
    event.stopPropagation(); // Prevent immediate closing on click
    setShowTooltip2((prev) => !prev);
  };
  const handleImageClick3 = (event) => {
    event.stopPropagation(); // Prevent immediate closing on click
    setShowTooltip3((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      setShowTooltip(false);
      setShowTooltip2(false);
      setShowTooltip3(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  });

  const averageactual_minus_estimate = () => {
    const filteredEventHistory = eventHistory.filter((item) => {
      const difference = Math.abs(item.actual - item.estimate);
      return (
        item.estimate !== null && item.estimate !== "" && difference !== 0.0
      );
    });
    if (filteredEventHistory.length === 0) {
      setSumActualEstimate("Data Unavailable");
      return;
    }

    const sum = filteredEventHistory.reduce((total, item) => {
      return total + Math.abs(item.actual - item.estimate);
    }, 0);

    const average = sum / filteredEventHistory.length;

    const maxDecimalPlaces = Math.max(
      ...filteredEventHistory.map((item) =>
        item.actual?.toString().includes(".")
          ? item.actual.toString().split(".")[1].length
          : item.estimate?.toString()?.split(".")[1]?.length || 0
      )
    );
    setSumActualEstimate(average.toFixed(maxDecimalPlaces));
    // setSumActualEstimate(average.toFixed(1));
  };
  const averageactual_minus_estimatebyo = () => {
    const filteredEventHistory = eventHistory.filter((item) => {
      const difference = Math.abs(item.actual - item.estimate);
      return (
        item.estimate !== null && item.estimate !== "" && difference !== 0.0
      );
    });

    if (filteredEventHistory.length === 0) {
      setSumActualEstimatebyo("Data Unavailable");
      return;
    }
    const sum = filteredEventHistory.reduce((total, item) => {
      return (
        total + Math.abs((item.actual - item.estimate) / item.estimate) * 100
      );
    }, 0);

    const average = sum / filteredEventHistory.length;
    setSumActualEstimatebyo(average.toFixed(1));
  };

  // <--final----->

  const averagefinalmovement = () => {
    const filteredEventHistory = eventHistory.filter((item) => {
      return item.estimate !== null && item.estimate !== "";
    });

    if (filteredEventHistory.length === 0) {
      setSumfinalmovement("Data Unavailable");
      return;
    }
    const sum = filteredEventHistory.reduce((total, item) => {
      const difference =
        item.actual - item.estimate === 0 ||
        item.estimate === null ||
        item.estimate === ""
          ? item.actual - item.previous
          : item.actual - item.estimate;

      return total + Math.abs(difference);
    }, 0);

    const average = sum / filteredEventHistory.length;

    const maxDecimalPlaces = Math.max(
      ...filteredEventHistory.map((item) =>
        item.actual?.toString().includes(".")
          ? item.actual.toString().split(".")[1].length
          : item.previous?.toString()?.split(".")[1]?.length || 0
      )
    );

    setSumfinalmovement(average.toFixed(maxDecimalPlaces));
    // setSumfinalmovement(average.toFixed(1));
  };
  const averagefinalmovementbyo = () => {
    const filteredEventHistory = eventHistory.filter((item) => {
      return item.estimate !== null && item.estimate !== "";
    });

    if (filteredEventHistory.length === 0) {
      setSumfinalmovementbyo("Data Unavailable");
      return;
    }
    const sum = filteredEventHistory.reduce((total, item) => {
      const difference =
        item.actual - item.estimate === 0 ||
        item.estimate === null ||
        item.estimate === ""
          ? item.actual - item.previous
          : item.actual - item.estimate;
      const base =
        item.actual - item.estimate === 0 ||
        item.estimate === null ||
        item.estimate === ""
          ? item.previous
          : item.estimate;

      return total + Math.abs((difference / base) * 100);
    }, 0);

    const average = sum / filteredEventHistory.length;
    setSumfinalmovementbyo(average.toFixed(1));
  };

  const averageactual_minus_previous = () => {
    const filteredEventHistory = eventHistory.filter((item) => {
      const difference = Math.abs(item.actual - item.previous);
      return (
        item.previous !== null && item.previous !== "" && difference !== 0.0
      );
    });
    if (filteredEventHistory.length === 0) {
      setSumActualPrevious("Data Unavailable");
      return;
    }
    const sum = filteredEventHistory.reduce((total, item) => {
      return total + Math.abs(item.actual - item.previous);
    }, 0);

    const average = sum / filteredEventHistory.length;
    // setSumActualPrevious(average.toFixed(1));
    const maxDecimalPlaces = Math.max(
      ...filteredEventHistory.map((item) =>
        item.actual?.toString().includes(".")
          ? item.actual.toString().split(".")[1].length
          : item.previous?.toString()?.split(".")[1]?.length || 0
      )
    );
    setSumActualPrevious(average.toFixed(maxDecimalPlaces));
  };

  const averageactual_minus_previousbyo = () => {
    const filteredEventHistory = eventHistory.filter((item) => {
      const difference = Math.abs(item.actual - item.previous);
      return (
        item.previous !== null &&
        item.previous !== "" &&
        difference !== 0.0 &&
        item.previous !== 0
      );
    });

    if (filteredEventHistory.length === 0) {
      setSumActualPreviousbyo("Data Unavailable");
      return;
    }
    const sum = filteredEventHistory.reduce((total, item) => {
      return (
        total + Math.abs((item.actual - item.previous) / item.previous) * 100
      );
    }, 0);

    // console.log("filteredEventHistory.length" , filteredEventHistory.length)
    const average = sum / filteredEventHistory.length;
    setSumActualPreviousbyo(average.toFixed(1));
  };

  useEffect(() => {
    averageactual_minus_estimate();
    averageactual_minus_estimatebyo();
    averageactual_minus_previous();
    averageactual_minus_previousbyo();
    averagefinalmovement();
    averagefinalmovementbyo();
  }, [eventHistory]);

  const UKHeaders = [
    { name: "GBP/AUD", id: "gbpaud" },
    { name: "GBP/CAD", id: "gbpcad" },
    { name: "GBP/CHF", id: "gbpchf" },
    { name: "EUR/GBP", id: "eurgbp" },
    { name: "GBP/JPY", id: "gbpjpy" },
    { name: "GBP/NZD", id: "gbpnzd" },
    { name: "GBP/USD", id: "gbpusd" },
  ];
  const USHeaders = [
    { name: "AUD/USD", id: "audusd" },
    { name: "USD/CAD", id: "usdcad" },
    { name: "USD/CHF", id: "usdchf" },
    { name: "EUR/USD", id: "eurusd" },
    { name: "GBP/USD", id: "gbpusd" },
    { name: "USD/JPY", id: "usdjpy" },
    { name: "NZD/USD", id: "nzdusd" },
  ];
  const JPHeaders = [
    { name: "AUD/JPY", id: "audjpy" },
    { name: "CAD/JPY", id: "cadjpy" },
    { name: "CHF/JPY", id: "chfjpy" },
    { name: "EUR/JPY", id: "eurjpy" },
    { name: "GBP/JPY", id: "gbpjpy" },
    { name: "NZD/JPY", id: "nzdjpy" },
    { name: "USD/JPY", id: "usdjpy" },
  ];
  const CAHeaders = [
    { name: "AUD/CAD", id: "audcad" },
    { name: "CAD/CHF", id: "cadchf" },
    { name: "EUR/CAD", id: "eurcad" },
    { name: "GBP/CAD", id: "gbpcad" },
    { name: "CAD/JPY", id: "cadjpy" },
    { name: "NZD/CAD", id: "nzdcad" },
    { name: "USD/CAD", id: "usdcad" },
  ];
  const CHEHeaders = [
    { name: "AUD/CHF", id: "audchf" },
    { name: "CAD/CHF", id: "cadchf" },
    { name: "EUR/CHF", id: "eurchf" },
    { name: "GBP/CHF", id: "gbpchf" },
    { name: "CHF/JPY", id: "chfjpy" },
    { name: "NZD/CHF", id: "nzdchf" },
    { name: "USD/CHF", id: "usdchf" },
  ];
  const EUHeaders = [
    { name: "EUR/AUD", id: "euraud" },
    { name: "EUR/CAD", id: "eurcad" },
    { name: "EUR/CHF", id: "eurchf" },
    { name: "EUR/GBP", id: "eurgbp" },
    { name: "EUR/JPY", id: "eurjpy" },

    { name: "EUR/NZD", id: "eurnzd" },
    { name: "EUR/USD", id: "eurusd" },
  ];
  const AUHeaders = [
    { name: "AUD/CAD", id: "audcad" },
    { name: "AUD/CHF", id: "audchf" },
    { name: "EUR/AUD", id: "euraud" },
    { name: "GBP/AUD", id: "gbpaud" },
    { name: "AUD/JPY", id: "audjpy" },
    { name: "AUD/NZD", id: "audnzd" },
    { name: "AUD/USD", id: "audusd" },
  ];
  const NZHeaders = [
    { name: "AUD/NZD", id: "audnzd" },
    { name: "NZD/CAD", id: "nzdcad" },
    { name: "NZD/CHF", id: "nzdchf" },
    { name: "EUR/NZD", id: "eurnzd" },
    { name: "GBP/NZD", id: "gbpnzd" },

    { name: "NZD/JPY", id: "nzdjpy" },
    { name: "NZD/USD", id: "nzdusd" },
  ];

  const headers =
    country === "UK"
      ? UKHeaders
      : country === "US"
      ? USHeaders
      : country === "JP"
      ? JPHeaders
      : country === "CA"
      ? CAHeaders
      : country === "CH"
      ? CHEHeaders
      : country === "EU" ||
        country === "DE" ||
        country === "IT" ||
        country === "FR"
      ? EUHeaders
      : country === "AU"
      ? AUHeaders
      : NZHeaders;

  const handlegeneratechart = () => {
    // window.open("/user/graphdata", "_blank");
    // navigate("/admin/graphdata");
    const url = new URL(window.location.origin + "/user/graphdata");
    url.searchParams.set("eventName", event);
    url.searchParams.set("eventcountry", country);

    const newTab = window.open(url.toString(), "_blank");
  };

  const handlelivechart = () => {
    const url = new URL(window.location.origin + "/user/livecharts");
    const newTab = window.open(url.toString(), "_blank");
  };

  const historydata_table = async (timeclicked) => {
    try {
      // console.log("timeclicked" , timeclicked)
      // console.log("timeclicked:-------->", typeof timeclicked, timeclicked);

      if (timeclicked === 1) {
        setoff_minutebuttons1(true);
        setoff_minutebuttons2(false);
        setoff_minutebuttons3(false);
        setoff_minutebuttons4(false);
      } else if (timeclicked === 2) {
        setoff_minutebuttons1(true);
        setoff_minutebuttons2(true);
        setoff_minutebuttons3(false);
        setoff_minutebuttons4(false);
      } else if (timeclicked === 5) {
        setoff_minutebuttons1(true);
        setoff_minutebuttons2(true);
        setoff_minutebuttons3(true);
        setoff_minutebuttons4(false);
      } else {
        setoff_minutebuttons1(true);
        setoff_minutebuttons2(true);
        setoff_minutebuttons3(true);
        setoff_minutebuttons4(true);
      }

      // const eventandcountrydata = localStorage.getItem("eventnameandcountry:");
      // const eventDataObj = JSON.parse(eventandcountrydata);

      // const { eventName, eventcountry, eventimpact, eventtime, eventdate } =eventDataObj;
      const urlParams = new URLSearchParams(window.location.search);
      const eventName = decodeURIComponent(urlParams.get("eventName"));

      const eventcountry = decodeURIComponent(urlParams.get("eventcountry"));
      seteventname_forerror(eventName);
      const eventimpact = decodeURIComponent(urlParams.get("eventimpact"));
      const eventtime = decodeURIComponent(urlParams.get("eventtime"));
      const eventdate = decodeURIComponent(urlParams.get("eventdate"));

      setLoading(true);
      const tokenfromls = localStorage.getItem("usertoken");
      const h = { authorization: tokenfromls };

      const response7 = await axios.post(
        `${process.env.REACT_APP_URL}/geteventhistory2_FirstTable_AfterRelease`,
        { eventName, eventcountry, selectedTime: timeclicked },
        { headers: h }
      );

      if (response7 != null) {
        setLoading(false);
      }

      const average_historydata = response7.data;
      // console.log("hlo ashi am 1st api , ", response7.data);
      // console.log("eventcountry" , eventcountry , country)
      setCountry(eventcountry);
      setEvent(eventName);
      setimpact(eventimpact);
      settime(eventtime);
      setdate(eventdate);

      setAllEventHistory2(average_historydata.eventdata2);
      setEventHistory2(average_historydata.eventdata2);

      if (eventcountry === "US" || eventcountry === "NZ") {
        setusddata_avg(average_historydata.usddata2);
        setjpydata_avg(average_historydata.nzddata2);
        setgbpnzddata_avg(average_historydata.jpydata2);
        seteurgbpdata_avg(average_historydata.eurdata2);
        setgbpchfdata_avg(average_historydata.chfdata2);
        setgbpauddata_avg(average_historydata.auddata2);
        setgbpcaddata_avg(average_historydata.caddata2);

        setusddata_5minadd(average_historydata.usddataAdd5min);
        setjpydata_5minadd(average_historydata.nzddataAdd5min);
        setgbpnzddata_5minadd(average_historydata.jpydataAdd5min);
        seteurgbpdata_5minadd(average_historydata.eurdataAdd5min);
        setgbpchfdata_5minadd(average_historydata.chfdataAdd5min);
        setgbpauddata_5minadd(average_historydata.auddataAdd5min);
        setgbpcaddata_5minadd(average_historydata.caddataAdd5min);
      } else {
        setusddata_avg(average_historydata.usddata2);
        setjpydata_avg(average_historydata.jpydata2);
        setgbpnzddata_avg(average_historydata.nzddata2);
        seteurgbpdata_avg(average_historydata.eurdata2);
        setgbpchfdata_avg(average_historydata.chfdata2);
        setgbpauddata_avg(average_historydata.auddata2);
        setgbpcaddata_avg(average_historydata.caddata2);

        setusddata_5minadd(average_historydata.usddataAdd5min);
        setjpydata_5minadd(average_historydata.jpydataAdd5min);
        setgbpnzddata_5minadd(average_historydata.nzddataAdd5min);
        seteurgbpdata_5minadd(average_historydata.eurdataAdd5min);
        setgbpchfdata_5minadd(average_historydata.chfdataAdd5min);
        setgbpauddata_5minadd(average_historydata.auddataAdd5min);
        setgbpcaddata_5minadd(average_historydata.caddataAdd5min);
      }

      setLoading(false);
      setLoading_3rdtable(true);

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/geteventshistorySecondTable_AfterRelease`,
        { eventName, eventcountry, selectedTime: timeclicked },
        { headers: h }
      );

      const historydata = response.data;
      // console.log("historydata", historydata);
      setAllEventHistory(historydata.eventdata);
      setEventHistory(historydata.eventdata);

      if (eventcountry === "US" || eventcountry === "NZ") {
        setusddata(historydata.usddata);
        setjpydata(historydata.nzddata);
        setgbpnzddata(historydata.jpydata);
        seteurgbpdata(historydata.eurdata);
        setgbpchfdata(historydata.chfdata);
        setgbpauddata(historydata.auddata);
        setgbpcaddata(historydata.caddata);

        setusddata_5minadd_2ndtable(historydata.usddataAdd5min);
        setjpydata_5minadd_2ndtable(historydata.nzddataAdd5min);
        setgbpnzddata_5minadd_2ndtable(historydata.jpydataAdd5min);
        seteurgbpdata_5minadd_2ndtable(historydata.eurdataAdd5min);
        setgbpchfdata_5minadd_2ndtable(historydata.chfdataAdd5min);
        setgbpauddata_5minadd_2ndtable(historydata.auddataAdd5min);
        setgbpcaddata_5minadd_2ndtable(historydata.caddataAdd5min);
      } else {
        setusddata(historydata.usddata);
        setjpydata(historydata.jpydata);
        setgbpnzddata(historydata.nzddata);
        seteurgbpdata(historydata.eurdata);
        setgbpchfdata(historydata.chfdata);
        setgbpauddata(historydata.auddata);
        setgbpcaddata(historydata.caddata);

        setusddata_5minadd_2ndtable(historydata.usddataAdd5min);
        setjpydata_5minadd_2ndtable(historydata.jpydataAdd5min);
        setgbpnzddata_5minadd_2ndtable(historydata.nzddataAdd5min);
        seteurgbpdata_5minadd_2ndtable(historydata.eurdataAdd5min);
        setgbpchfdata_5minadd_2ndtable(historydata.chfdataAdd5min);
        setgbpauddata_5minadd_2ndtable(historydata.auddataAdd5min);
        setgbpcaddata_5minadd_2ndtable(historydata.caddataAdd5min);
      }

      setLoading_3rdtable(false);
      setRunclickedevent_dateapi(true);
      setRunclickedevent_dateapi2(true);
      // setoff_minutebuttons(true)

      setoff_minutebuttons1(true);
      setoff_minutebuttons2(true);
      setoff_minutebuttons3(true);
      setoff_minutebuttons4(true);
    } catch (error) {
      setLoading(false);
      setLoading_3rdtable(false);
      if (error.response && error.response.status === 400) {
        setLoading(false);
        setLoading_3rdtable(false);
        // console.log("hlo am here");
        const errorMessage = "No data available for ";
        setErrorMessage(errorMessage);
        setIsgraphbuttonDisbled(false);
      } else {
        setLoading(false);
        setLoading_3rdtable(false);
        const errorMessage = "Error fetching data. Please try again later.";
        setErrorMessage(errorMessage);
        setIsgraphbuttonDisbled(false);
      }
      console.error("Error showing data:", error);
    }
  };

  useEffect(() => {
    historydata_table(selectedTime);
  }, [selectedTime]);

  // <---------------headers------------>
  const getheaderscount_highlow = async () => {
    // console.log("hi am in header code now ");
    setclickeddate_Loading(true);
    if (run_clickedevent_dateapi) {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const eventName = decodeURIComponent(urlParams.get("eventName"));
        const eventcountry = decodeURIComponent(urlParams.get("eventcountry"));
        const eventimpact = decodeURIComponent(urlParams.get("eventimpact"));
        const eventtime = decodeURIComponent(urlParams.get("eventtime"));
        const eventdate = decodeURIComponent(urlParams.get("eventdate"));

        const uniqueKey = `${eventName}-${eventcountry}-${eventdate}-${eventtime}`;

        const tokenfromls = localStorage.getItem("usertoken");
        const headers = { authorization: tokenfromls };

        // Fetch specific date impact data
        const response5 = await axios.post(
          `${process.env.REACT_APP_URL}/eventsimpactonaspecificdate`,
          { eventName, eventcountry, eventdate, eventtime },
          { headers }
        );

        const specificdateimpactontime = response5.data;
        // console.log("specificdateimpactontime", specificdateimpactontime);

        // Fetch before specific date impact data
        const response6 = await axios.post(
          `${process.env.REACT_APP_URL}/eventsimpactbeforeaspecificdate`,
          { eventName, eventcountry, eventdate, eventtime },
          { headers }
        );

        const specificdateimpactbeforetime = response6.data;
        // console.log(
        //   "specificdateimpactbeforetime",
        //   specificdateimpactbeforetime
        // );
        setRunclickedevent_dateapi2(true);

        seteventimpactontimespecificdate(specificdateimpactontime);
        seteventimpactbeforetimespecificdate(specificdateimpactbeforetime);
        setclickeddate_Loading(false);
      } catch (error) {
        console.error("Error fetching specific date impact data:", error);
        setclickeddate_Loading(false);
      }
    }
  };

  useEffect(() => {
    if (run_clickedevent_dateapi) {
      getheaderscount_highlow();
    }
  }, [run_clickedevent_dateapi]);

  // <-----------modal high low count------------>
  const handlegetmodaldata_fromApi = async () => {
    if (run_clickedevent_dateapi2) {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const eventName = decodeURIComponent(urlParams.get("eventName"));
        const eventcountry = decodeURIComponent(urlParams.get("eventcountry"));
        // const eventimpact = decodeURIComponent(urlParams.get('eventimpact'));
        const eventtime = decodeURIComponent(urlParams.get("eventtime"));
        const eventdate = decodeURIComponent(urlParams.get("eventdate"));

        // // <---------------data first time run and setting into local------------->

        const tokenfromls = localStorage.getItem("usertoken");
        const h = { authorization: tokenfromls };

        const response2 = await axios.post(
          `${process.env.REACT_APP_URL}/findhighlowhistoryevents`,
          { eventName, eventcountry },
          { headers: h }
        );

        // console.log("response2----- hi ashi here is the output", response2);
        const response3 = await axios.post(
          `${process.env.REACT_APP_URL}/highloweventbeforedate`,
          { eventName, eventcountry },
          { headers: h }
        );
        // console.log("response3", response3);

        // <-----------this code is for on time-------------->
        const gethighlowimpact = response2.data;
        const modalimpacthighlowontime = gethighlowimpact.impactdata1;
        const summaryimpacthighlow = gethighlowimpact.impactdata2;

        // <-----------this code is for before time-------------->
        const impactdata = response3.data;
        const finalimpactsummary = impactdata.impactdata2;
        const modalimpactdata2 = impactdata.impactdata1;
        // <-------------main data--------------->
        setRun_modalloader(false);
        const dataToStore3 = {
          finalimpactsummary,
          summaryimpacthighlow,
          modalimpacthighlowontime,
          modalimpactdata2,
        };
        setimpacthighlow(summaryimpacthighlow);
        setmodalimpactdataontime(modalimpacthighlowontime);
        setimpacthighlowbeforethis(finalimpactsummary);
        setmodalimpactdatabeforetime(modalimpactdata2);
      } catch (error) {
        // console.log("error", error);
        setRun_modalloader(false);
      }
    }
  };

  useEffect(() => {
    if (run_clickedevent_dateapi2) {
      handlegetmodaldata_fromApi();
    }
  }, [run_clickedevent_dateapi2]);

  const handleOptionChange = useCallback(
    (value) => {
      setOptionValue(value);

      // Map values to slicing logic
      const slices = {
        "Last 24": [allEventHistory, allEventHistory2],
        "Last 12": [
          allEventHistory.slice(0, 12),
          allEventHistory2.slice(0, 12),
        ],
        "Last 6": [allEventHistory.slice(0, 6), allEventHistory2.slice(0, 6)],
      };

      // Extract slices or default to empty arrays
      const [history, history2] = slices[value] || [[], []];
      setEventHistory(history);
      setEventHistory2(history2);
    },
    [allEventHistory, allEventHistory2]
  );
  useEffect(() => {
    handleOptionChange("Last 6");
  }, [handleOptionChange]);

  // <------calvulate average of 1st table ------>
  // <--C O --->
  const calculate_currencyaverage = () => {
    const a_minus_evalue = eventHistory.map((item) =>
      item.actual - item.estimate === 0 ||
      item.estimate === null ||
      item.estimate === ""
        ? item.actual - item.previous
        : item.actual - item.estimate
    );

    // <---here we r matching date time , bcz. length r different --->
    const eventavgtime = eventHistory.map((item) => item.time);
    const eventavgestimate = eventHistory.map((item) => item.estimate);
    const eventavgdate = eventHistory.map((item) =>
      item.date.split(".").reverse().join(".")
    );

    const calculateSumAndAverage = (data, differences) => {
      // console.log("usddata" , usddata)
      const filledData = eventavgdate.map((date, index) => {
        const time = eventavgtime[index];
        const entry = data.find(
          (item) => item.date === date && item.time === time
        );
        // <---open close ki empty value add kr rhe hum , for same length---->
        return entry || { date: date, time: time, Open: "", Close: "" };
      });

      if (filledData.some((entry) => entry.Open !== "" && entry.Close !== "")) {
        const sum = filledData.reduce((total, item, index) => {
          if (differences[index] !== 0.0 && differences[index] !== -0.0) {
            if (item.Close === "" || item.Open === "") {
              return total;
            }
            const differenceCO = item.Close - item.Open;

            let modulusCO;
            if (data === jpydata) {
              modulusCO = Math.abs(Math.round(differenceCO * 1000));
            } else {
              modulusCO = Math.abs(
                Math.round(
                  differenceCO.toFixed(country === "JP" ? 3 : 5) *
                    (country === "JP" ? 1000 : 100000)
                )
              );
            }

            // console.log("modulusCO", modulusCO)
            return total + modulusCO;
          }
          return total;
        }, 0);

        const validEntriesCount = filledData.filter((item, index) => {
          const opencloseNotEmpty = item.Open !== "" && item.Close !== "";

          // Only include the item if Low and High are not empty and the difference of A-E is not 0.0 or -0.0
          return (
            opencloseNotEmpty &&
            differences[index] !== 0.0 &&
            differences[index] !== -0.0
          );
        }).length;

        // console.log("validEntriesCount" , validEntriesCount)
        const average = validEntriesCount > 0 ? sum / validEntriesCount : 0;
        // console.log("average" , average)
        return average;
      } else {
        return null;
      }
    };

    // Calculate averages for different data sets
    const averageOC1 = calculateSumAndAverage(usddata, a_minus_evalue);
    setAverageDiff(averageOC1);
    const averageOC2 = calculateSumAndAverage(jpydata, a_minus_evalue);
    setavgjpydiff(averageOC2);
    const averageOC3 = calculateSumAndAverage(gbpnzddata, a_minus_evalue);
    setaveragegbpnzddiff1(averageOC3);
    const averageOC4 = calculateSumAndAverage(eurgbpdata, a_minus_evalue);
    setaveragegbpeurdiff1(averageOC4);
    const averageOC5 = calculateSumAndAverage(gbpchfdata, a_minus_evalue);
    setaveragegbpchfdiff1(averageOC5);
    const averageOC6 = calculateSumAndAverage(gbpauddata, a_minus_evalue);
    setaveragegbpauddiff1(averageOC6);
    const averageOC7 = calculateSumAndAverage(gbpcaddata, a_minus_evalue);
    setaveragegbpcaddiff1(averageOC7);

    // <----LO---->

    const calculateSumAndAverageLO = (data, differences) => {
      const filledData = eventavgdate.map((date, index) => {
        const time = eventavgtime[index];
        const entry = data.find(
          (item) => item.date === date && item.time === time
        );
        return entry || { date: date, time: time, Open: "", Low: "" };
      });

      // console.log("filteredData" , filteredData)
      if (filledData.some((entry) => entry.Open !== "" && entry.Low !== "")) {
        const sum = filledData.reduce((total, item, index) => {
          if (differences[index] !== 0.0 && differences[index] !== -0.0) {
            if (item.Low === "" || item.Open === "") {
              return total;
            }

            const differenceLO = item.Low - item.Open;
            //  console.log(`item.Low (${item.Low}) - item.Open (${item.Open}) = ${differenceLO}`);

            let modulusLO;
            if (data === jpydata) {
              modulusLO = Math.abs(Math.round(differenceLO * 1000));
            } else {
              modulusLO = Math.abs(
                Math.round(
                  differenceLO.toFixed(country === "JP" ? 3 : 5) *
                    (country === "JP" ? 1000 : 100000)
                )
              );
            }

            return total + modulusLO;
          }
          return total;
        }, 0);

        const validEntriesCount = filledData.filter((item, index) => {
          const openlowNotEmpty = item.Open !== "" && item.Low !== "";

          // Only include the item if Low and High are not empty and the difference of A-E is not 0.0 or -0.0
          return (
            openlowNotEmpty &&
            differences[index] !== 0.0 &&
            differences[index] !== -0.0
          );
        }).length;

        // console.log("validEntriesCount" , validEntriesCount)
        const average = validEntriesCount > 0 ? sum / validEntriesCount : 0;
        return average;
      } else {
        return null;
      }
    };

    // Calculate averages for different data sets
    const averageOL1 = calculateSumAndAverageLO(usddata, a_minus_evalue);
    setAverageDiff2(averageOL1);
    const averageOL2 = calculateSumAndAverageLO(jpydata, a_minus_evalue);
    setavgjpydiff2(averageOL2);
    const averageOL3 = calculateSumAndAverageLO(gbpnzddata, a_minus_evalue);
    setaveragegbpnzddiff2(averageOL3);
    const averageOL4 = calculateSumAndAverageLO(eurgbpdata, a_minus_evalue);
    setaveragegbpeurdiff2(averageOL4);
    const averageOL5 = calculateSumAndAverageLO(gbpchfdata, a_minus_evalue);
    setaveragegbpchfdiff2(averageOL5);
    const averageOL6 = calculateSumAndAverageLO(gbpauddata, a_minus_evalue);
    setaveragegbpauddiff2(averageOL6);
    const averageOL7 = calculateSumAndAverageLO(gbpcaddata, a_minus_evalue);
    setaveragegbpcaddiff2(averageOL7);

    // <-----HO----->

    const calculateSumAndAverageHO = (data, differences) => {
      const filledData = eventavgdate.map((date, index) => {
        const time = eventavgtime[index];
        const entry = data.find(
          (item) => item.date === date && item.time === time
        );
        return entry || { date: date, time: time, Open: "", High: "" };
      });

      if (filledData.some((entry) => entry.Open !== "" && entry.High !== "")) {
        const sum = filledData.reduce((total, item, index) => {
          if (differences[index] !== 0.0 && differences[index] !== -0.0) {
            if (item.High === "" || item.Open === "") {
              return total;
            }
            const differenceHO = item.High - item.Open;

            let modulusHO;
            if (data === jpydata) {
              modulusHO = Math.abs(Math.round(differenceHO * 1000));
            } else {
              modulusHO = Math.abs(
                Math.round(
                  differenceHO.toFixed(country === "JP" ? 3 : 5) *
                    (country === "JP" ? 1000 : 100000)
                )
              );
            }
            // const modulusHO = Math.abs(Math.round(differenceHO.toFixed(country === "JP" ? 3 : 5)*(country === "JP" ? 1000 : 100000)));
            return total + modulusHO;
          }
          return total;
        }, 0);

        const validEntriesCount = filledData.filter((item, index) => {
          const openhighNotEmpty = item.Open !== "" && item.High !== "";

          // Only include the item if Low and High are not empty and the difference of A-E is not 0.0 or -0.0
          return (
            openhighNotEmpty &&
            differences[index] !== 0.0 &&
            differences[index] !== -0.0
          );
        }).length;
        const average = validEntriesCount > 0 ? sum / validEntriesCount : 0;
        return average;
      } else {
        return null;
      }
    };

    // Calculate averages for different data sets
    const averageOH1 = calculateSumAndAverageHO(usddata, a_minus_evalue);
    setAverageDiff3(averageOH1);
    const averageOH2 = calculateSumAndAverageHO(jpydata, a_minus_evalue);
    setavgjpydiff3(averageOH2);
    const averageOH3 = calculateSumAndAverageHO(gbpnzddata, a_minus_evalue);
    setaveragegbpnzddiff3(averageOH3);
    const averageOH4 = calculateSumAndAverageHO(eurgbpdata, a_minus_evalue);
    setaveragegbpeurdiff3(averageOH4);
    const averageOH5 = calculateSumAndAverageHO(gbpchfdata, a_minus_evalue);
    setaveragegbpchfdiff3(averageOH5);
    const averageOH6 = calculateSumAndAverageHO(gbpauddata, a_minus_evalue);
    setaveragegbpauddiff3(averageOH6);
    const averageOH7 = calculateSumAndAverageHO(gbpcaddata, a_minus_evalue);
    setaveragegbpcaddiff3(averageOH7);

    /* <for 0, C-0--> */

    const calculateSumAndAverage_flat0 = (data, differences) => {
      const filledData = eventavgdate.map((date, index) => {
        const time = eventavgtime[index];
        const entry = data.find(
          (item) => item.date === date && item.time === time
        );
        return entry || { date: date, time: time, Open: "", Close: "" };
      });

      // const filteredData = filledData.filter((entry, index) => {
      //   return eventavgestimate[index] !== undefined && eventavgestimate[index] !== null;
      // });
      if (filledData.some((entry) => entry.Open !== "" && entry.Close !== "")) {
        const sum = filledData.reduce((total, item, index) => {
          if (differences[index] === 0.0 || differences[index] === -0.0) {
            if (item.Close === "" || item.Open === "") {
              return total;
            }
            const differenceCO = item.Close - item.Open;

            let modulusCO;
            if (data === jpydata) {
              modulusCO = Math.abs(Math.round(differenceCO * 1000));
            } else {
              modulusCO = Math.abs(
                Math.round(
                  differenceCO.toFixed(country === "JP" ? 3 : 5) *
                    (country === "JP" ? 1000 : 100000)
                )
              );
            }
            // console.log("differenceCO" , differenceCO)
            // const modulusCO = Math.abs(Math.round(differenceCO.toFixed(country === "JP" ? 3 : 5)*(country === "JP" ? 1000 : 100000)));
            // console.log("modulusCO" , modulusCO)
            return total + modulusCO;
          }
          return total;
        }, 0);

        const validEntriesCount = filledData.filter((item, index) => {
          const opencloseNotEmpty = item.Open !== "" && item.Close !== "";

          // Only include the item if Low and High are not empty and the difference of A-E is not 0.0 or -0.0
          return (
            opencloseNotEmpty &&
            differences[index] === 0.0 &&
            differences[index] === -0.0
          );
        }).length;
        // console.log("validEntriesCount" , validEntriesCount)

        const average = validEntriesCount > 0 ? sum / validEntriesCount : 0;
        return average;
      } else {
        return null;
      }
    };

    // Calculate averages for different data sets when actual - estimate is zero
    const averageOC1_flat0 = calculateSumAndAverage_flat0(
      usddata,
      a_minus_evalue
    );
    setAverageDiff_flat0(averageOC1_flat0);
    const averageOC2_flat0 = calculateSumAndAverage_flat0(
      jpydata,
      a_minus_evalue
    );
    setavgjpydiff_flat0(averageOC2_flat0);
    const averageOC3_flat0 = calculateSumAndAverage_flat0(
      gbpnzddata,
      a_minus_evalue
    );
    setaveragegbpnzddiff1_flat0(averageOC3_flat0);
    const averageOC4_flat0 = calculateSumAndAverage_flat0(
      eurgbpdata,
      a_minus_evalue
    );
    setaveragegbpeurdiff1_flat0(averageOC4_flat0);
    const averageOC5_flat0 = calculateSumAndAverage_flat0(
      gbpchfdata,
      a_minus_evalue
    );
    setaveragegbpchfdiff1_flat0(averageOC5_flat0);
    const averageOC6_flat0 = calculateSumAndAverage_flat0(
      gbpauddata,
      a_minus_evalue
    );
    setaveragegbpauddiff1_flat0(averageOC6_flat0);
    // console.log("averageOC6_flat0" , averageOC6_flat0)
    const averageOC7_flat0 = calculateSumAndAverage_flat0(
      gbpcaddata,
      a_minus_evalue
    );
    setaveragegbpcaddiff1_flat0(averageOC7_flat0);

    // <----------------FLAT 0 , L-O---->

    const calculateSumAndAverageLO_flat0 = (data, differences) => {
      const filledData = eventavgdate.map((date, index) => {
        const time = eventavgtime[index];
        const entry = data.find(
          (item) => item.date === date && item.time === time
        );
        return entry || { date: date, time: time, Open: "", Low: "" };
      });

      if (filledData.some((entry) => entry.Open !== "" && entry.Low !== "")) {
        const sum = filledData.reduce((total, item, index) => {
          if (differences[index] === 0.0 || differences[index] === -0.0) {
            if (item.Low === "" || item.Open === "") {
              return total;
            }
            const differenceLO = item.Low - item.Open;

            let modulusLO;
            if (data === jpydata) {
              modulusLO = Math.abs(Math.round(differenceLO * 1000));
            } else {
              modulusLO = Math.abs(
                Math.round(
                  differenceLO.toFixed(country === "JP" ? 3 : 5) *
                    (country === "JP" ? 1000 : 100000)
                )
              );
            }
            // console.log("differenceLO" , differenceLO)
            // const modulusLO = Math.abs(Math.round(differenceLO.toFixed(country === "JP" ? 3 : 5)*(country === "JP" ? 1000 : 100000)));
            // console.log("modulusLO" , modulusLO)
            return total + modulusLO;
          }
          return total;
        }, 0);

        const validEntriesCount = filledData.filter((item, index) => {
          const openlowNotEmpty = item.Open !== "" && item.Low !== "";

          // Only include the item if Low and High are not empty and the difference of A-E is not 0.0 or -0.0
          return (
            openlowNotEmpty &&
            differences[index] === 0.0 &&
            differences[index] === -0.0
          );
        }).length;
        // console.log("validEntriesCount" , validEntriesCount)

        const average = validEntriesCount > 0 ? sum / validEntriesCount : 0;
        return average;
      } else {
        return null;
      }
    };

    // Calculate averages for different data sets when actual - estimate is zero
    const averageOL1_flat0 = calculateSumAndAverageLO_flat0(
      usddata,
      a_minus_evalue
    );
    setAverageDiff2_flat0(averageOL1_flat0);
    const averageOL2_flat0 = calculateSumAndAverageLO_flat0(
      jpydata,
      a_minus_evalue
    );
    setavgjpydiff2_flat0(averageOL2_flat0);
    const averageOL3_flat0 = calculateSumAndAverageLO_flat0(
      gbpnzddata,
      a_minus_evalue
    );
    setaveragegbpnzddiff2_flat0(averageOL3_flat0);
    const averageOL4_flat0 = calculateSumAndAverageLO_flat0(
      eurgbpdata,
      a_minus_evalue
    );
    setaveragegbpeurdiff2_flat0(averageOL4_flat0);
    const averageOL5_flat0 = calculateSumAndAverageLO_flat0(
      gbpchfdata,
      a_minus_evalue
    );
    setaveragegbpchfdiff2_flat0(averageOL5_flat0);
    const averageOL6_flat0 = calculateSumAndAverageLO_flat0(
      gbpauddata,
      a_minus_evalue
    );
    setaveragegbpauddiff2_flat0(averageOL6_flat0);
    const averageOL7_flat0 = calculateSumAndAverageLO_flat0(
      gbpcaddata,
      a_minus_evalue
    );
    setaveragegbpcaddiff2_flat0(averageOL7_flat0);

    // <-----flat 0 average , H-O----->

    const calculateSumAndAverageHO_flat0 = (data, differences) => {
      const filledData = eventavgdate.map((date, index) => {
        const time = eventavgtime[index];
        const entry = data.find(
          (item) => item.date === date && item.time === time
        );
        return entry || { date: date, time: time, Open: "", High: "" };
      });

      if (filledData.some((entry) => entry.Open !== "" && entry.High !== "")) {
        const sum = filledData.reduce((total, item, index) => {
          if (differences[index] === 0.0 || differences[index] === -0.0) {
            if (item.High === "" || item.Open === "") {
              return total;
            }
            const differenceHO = item.High - item.Open;

            let modulusHO;
            if (data === jpydata) {
              modulusHO = Math.abs(Math.round(differenceHO * 1000));
            } else {
              modulusHO = Math.abs(
                Math.round(
                  differenceHO.toFixed(country === "JP" ? 3 : 5) *
                    (country === "JP" ? 1000 : 100000)
                )
              );
            }
            // const modulusHO = Math.abs(Math.round(differenceHO.toFixed(country === "JP" ? 3 : 5)*(country === "JP" ? 1000 : 100000)));
            return total + modulusHO;
          }
          return total;
        }, 0);

        const validEntriesCount = filledData.filter((item, index) => {
          const openhighNotEmpty = item.Open !== "" && item.High !== "";

          // Only include the item if Low and High are not empty and the difference of A-E is not 0.0 or -0.0
          return (
            openhighNotEmpty &&
            differences[index] === 0.0 &&
            differences[index] === -0.0
          );
        }).length;
        // console.log("validEntriesCount" , validEntriesCount)

        const average = validEntriesCount > 0 ? sum / validEntriesCount : 0;
        return average;
      } else {
        return null;
      }
    };

    // Calculate averages for different data sets when actual - estimate is zero
    const averageOH1_flat0 = calculateSumAndAverageHO_flat0(
      usddata,
      a_minus_evalue
    );
    setAverageDiff3_flat0(averageOH1_flat0);
    const averageOH2_flat0 = calculateSumAndAverageHO_flat0(
      jpydata,
      a_minus_evalue
    );
    setavgjpydiff3_flat0(averageOH2_flat0);
    const averageOH3_flat0 = calculateSumAndAverageHO_flat0(
      gbpnzddata,
      a_minus_evalue
    );
    setaveragegbpnzddiff3_flat0(averageOH3_flat0);
    const averageOH4_flat0 = calculateSumAndAverageHO_flat0(
      eurgbpdata,
      a_minus_evalue
    );
    setaveragegbpeurdiff3_flat0(averageOH4_flat0);
    const averageOH5_flat0 = calculateSumAndAverageHO_flat0(
      gbpchfdata,
      a_minus_evalue
    );
    setaveragegbpchfdiff3_flat0(averageOH5_flat0);
    const averageOH6_flat0 = calculateSumAndAverageHO_flat0(
      gbpauddata,
      a_minus_evalue
    );
    setaveragegbpauddiff3_flat0(averageOH6_flat0);
    const averageOH7_flat0 = calculateSumAndAverageHO_flat0(
      gbpcaddata,
      a_minus_evalue
    );
    setaveragegbpcaddiff3_flat0(averageOH7_flat0);
  };

  useEffect(() => {
    calculate_currencyaverage();
  }, [
    handleOptionChange,
    eventHistory2,
    allEventHistory,
    eventHistory,
    eurgbpdata,
    gbpauddata,
    gbpcaddata,
    gbpchfdata,
    gbpnzddata,
    jpydata,
    usddata,
  ]);

  // <------------calculate average in % value (1st table)----------->

  const calculate_currencyaveragebyopen = () => {
    const a_minus_evalue = eventHistory.map((item) =>
      item.actual - item.estimate === 0 ||
      item.estimate === null ||
      item.estimate === ""
        ? item.actual - item.previous
        : item.actual - item.estimate
    );
    const eventavgtime = eventHistory.map((item) => item.time);
    const eventavgdate = eventHistory.map((item) =>
      item.date.split(".").reverse().join(".")
    );
    const eventavgestimate = eventHistory.map((item) => item.estimate);

    const calculateSumAndAveragebyopen = (data, differences) => {
      const filledData = eventavgdate.map((date, index) => {
        const time = eventavgtime[index];
        const entry = data.find(
          (item) => item.date === date && item.time === time
        );
        // console.log("entry" , entry)
        return entry || { date: date, time: time, Open: "", Close: "" };
      });
      // const filteredData = filledData.filter((entry, index) => {
      //   return (
      //     eventavgestimate[index] !== undefined &&
      //     eventavgestimate[index] !== null
      //   );
      // });
      if (filledData.some((entry) => entry.Open !== "" && entry.Close !== "")) {
        const sum = filledData.reduce((total, item, index) => {
          if (differences[index] !== 0.0 && differences[index] !== -0.0) {
            if (item.Close === "" || item.Open === "") {
              return total;
            }
            const differencebyopenCO = (item.Close - item.Open) / item.Open;

            const modulusbyopenCO = (
              Math.abs(differencebyopenCO) * 100
            ).toFixed(3);

            return total + parseFloat(modulusbyopenCO);
          }
          return total;
        }, 0);

        const validEntriesCount = filledData.filter((item, index) => {
          const openclosedNotEmpty = item.Open !== "" && item.Close !== "";

          // Only include the item if Low and High are not empty and the difference of A-E is not 0.0 or -0.0
          return (
            openclosedNotEmpty &&
            differences[index] !== 0.0 &&
            differences[index] !== -0.0
          );
        }).length;

        // console.log("validEntriesCount" , validEntriesCount)
        const average = validEntriesCount > 0 ? sum / validEntriesCount : 0;
        // console.log("average" , average)
        return average;
      } else {
        return null;
      }
    };

    // Calculate averages for different data sets
    const averagebyopenOC1 = calculateSumAndAveragebyopen(
      usddata,
      a_minus_evalue
    );
    setAverageDifff(averagebyopenOC1);
    const averagebyopenOC2 = calculateSumAndAveragebyopen(
      jpydata,
      a_minus_evalue
    );
    setavgjpydifff(averagebyopenOC2);
    const averagebyopenOC3 = calculateSumAndAveragebyopen(
      gbpnzddata,
      a_minus_evalue
    );
    setaveragegbpnzdbyodiff1(averagebyopenOC3);
    const averagebyopenOC4 = calculateSumAndAveragebyopen(
      eurgbpdata,
      a_minus_evalue
    );
    setaveragegbpeurbyodiff1(averagebyopenOC4);
    const averagebyopenOC5 = calculateSumAndAveragebyopen(
      gbpchfdata,
      a_minus_evalue
    );
    setaveragegbpchfbyodiff1(averagebyopenOC5);
    const averagebyopenOC6 = calculateSumAndAveragebyopen(
      gbpauddata,
      a_minus_evalue
    );
    setaveragegbpaudbyodiff1(averagebyopenOC6);
    const averagebyopenOC7 = calculateSumAndAveragebyopen(
      gbpcaddata,
      a_minus_evalue
    );
    setaveragegbpcadbyodiff1(averagebyopenOC7);

    // <----LO---->

    const calculateSumAndAveragebyopenLO = (data, differences) => {
      const filledData = eventavgdate.map((date, index) => {
        const time = eventavgtime[index];
        const entry = data.find(
          (item) => item.date === date && item.time === time
        );
        return entry || { date: date, time: time, Open: "", Low: "" };
      });

      if (filledData.some((entry) => entry.Open !== "" && entry.Low !== "")) {
        const sum = filledData.reduce((total, item, index) => {
          if (differences[index] !== 0.0 && differences[index] !== -0.0) {
            if (item.Low === "" || item.Open === "") {
              return total;
            }
            const differencebyopenLO = (item.Low - item.Open) / item.Open;
            const modulusbyopenLO = (
              Math.abs(differencebyopenLO) * 100
            ).toFixed(3);

            return total + parseFloat(modulusbyopenLO);
          }
          return total;
        }, 0);

        const validEntriesCount = filledData.filter((item, index) => {
          const openlowwNotEmpty = item.Open !== "" && item.Low !== "";

          // Only include the item if Low and High are not empty and the difference of A-E is not 0.0 or -0.0
          return (
            openlowwNotEmpty &&
            differences[index] !== 0.0 &&
            differences[index] !== -0.0
          );
        }).length;

        const average = validEntriesCount > 0 ? sum / validEntriesCount : 0;
        return average;
      } else {
        return null;
      }
    };

    // Calculate averages for different data sets
    const averagebyopenOL1 = calculateSumAndAveragebyopenLO(
      usddata,
      a_minus_evalue
    );
    setAverageDifff2(averagebyopenOL1);
    const averagebyopenOL2 = calculateSumAndAveragebyopenLO(
      jpydata,
      a_minus_evalue
    );
    setavgjpydifff2(averagebyopenOL2);
    const averagebyopenOL3 = calculateSumAndAveragebyopenLO(
      gbpnzddata,
      a_minus_evalue
    );
    setaveragegbpnzdbyodiff2(averagebyopenOL3);
    const averagebyopenOL4 = calculateSumAndAveragebyopenLO(
      eurgbpdata,
      a_minus_evalue
    );
    setaveragegbpeurbyodiff2(averagebyopenOL4);
    const averagebyopenOL5 = calculateSumAndAveragebyopenLO(
      gbpchfdata,
      a_minus_evalue
    );
    setaveragegbpchfbyodiff2(averagebyopenOL5);
    const averagebyopenOL6 = calculateSumAndAveragebyopenLO(
      gbpauddata,
      a_minus_evalue
    );
    setaveragegbpaudbyodiff2(averagebyopenOL6);
    const averagebyopenOL7 = calculateSumAndAveragebyopenLO(
      gbpcaddata,
      a_minus_evalue
    );
    setaveragegbpcadbyodiff2(averagebyopenOL7);

    // <-----HO----->

    const calculateSumAndAveragebyopenHO = (data, differences) => {
      const filledData = eventavgdate.map((date, index) => {
        const time = eventavgtime[index];
        const entry = data.find(
          (item) => item.date === date && item.time === time
        );
        return entry || { date: date, time: time, Open: "", High: "" };
      });

      if (filledData.some((entry) => entry.Open !== "" && entry.High !== "")) {
        const sum = filledData.reduce((total, item, index) => {
          if (differences[index] !== 0.0 && differences[index] !== -0.0) {
            if (item.High === "" || item.Open === "") {
              return total;
            }
            const differencebyopenHO = (item.High - item.Open) / item.Open;
            const modulusbyopenHO = (
              Math.abs(differencebyopenHO) * 100
            ).toFixed(3);
            // return total + modulusbyopenHO;
            return total + parseFloat(modulusbyopenHO);
          }
          return total;
        }, 0);

        const validEntriesCount = filledData.filter((item, index) => {
          const openhighhNotEmpty = item.Open !== "" && item.High !== "";

          // Only include the item if Low and High are not empty and the difference of A-E is not 0.0 or -0.0
          return (
            openhighhNotEmpty &&
            differences[index] !== 0.0 &&
            differences[index] !== -0.0
          );
        }).length;
        const average = validEntriesCount > 0 ? sum / validEntriesCount : 0;
        return average;
      } else {
        return null;
      }
    };

    // Calculate averages for different data sets
    const averagebyopenOH1 = calculateSumAndAveragebyopenHO(
      usddata,
      a_minus_evalue
    );
    setAverageDifff3(averagebyopenOH1);
    const averagebyopenOH2 = calculateSumAndAveragebyopenHO(
      jpydata,
      a_minus_evalue
    );
    setavgjpydifff3(averagebyopenOH2);
    const averagebyopenOH3 = calculateSumAndAveragebyopenHO(
      gbpnzddata,
      a_minus_evalue
    );
    setaveragegbpnzdbyodiff3(averagebyopenOH3);
    const averagebyopenOH4 = calculateSumAndAveragebyopenHO(
      eurgbpdata,
      a_minus_evalue
    );
    setaveragegbpeurbyodiff3(averagebyopenOH4);
    const averagebyopenOH5 = calculateSumAndAveragebyopenHO(
      gbpchfdata,
      a_minus_evalue
    );
    setaveragegbpchfbyodiff3(averagebyopenOH5);
    const averagebyopenOH6 = calculateSumAndAveragebyopenHO(
      gbpauddata,
      a_minus_evalue
    );
    setaveragegbpaudbyodiff3(averagebyopenOH6);
    const averagebyopenOH7 = calculateSumAndAveragebyopenHO(
      gbpcaddata,
      a_minus_evalue
    );
    setaveragegbpcadbyodiff3(averagebyopenOH7);

    // <000000>
    {
      /* <for 0, C-0--> */
    }
    const calculateSumAndAveragebyopen_flat0 = (data, differences) => {
      const filledData = eventavgdate.map((date, index) => {
        const time = eventavgtime[index];
        const entry = data.find(
          (item) => item.date === date && item.time === time
        );
        return entry || { date: date, time: time, Open: "", Close: "" };
      });

      if (filledData.some((entry) => entry.Open !== "" && entry.Close !== "")) {
        const sum = filledData.reduce((total, item, index) => {
          if (differences[index] === 0.0 || differences[index] === -0.0) {
            if (item.Close === "" || item.Open === "") {
              return total;
            }
            const differencebyopenCO = (item.Close - item.Open) / item.Open;

            const modulusbyopenCO = Math.abs(differencebyopenCO * 100).toFixed(
              3
            );
            // console.log("modulusbyopenCO" ,modulusbyopenCO)
            return total + modulusbyopenCO;
          }
          return total;
        }, 0);

        const validEntriesCount = filledData.filter((item, index) => {
          const opencloseeNotEmpty = item.Open !== "" && item.Close !== "";
          // Only include the item if Low and High are not empty and the difference of A-E is not 0.0 or -0.0
          return (
            opencloseeNotEmpty &&
            differences[index] === 0.0 &&
            differences[index] === -0.0
          );
        }).length;

        // console.log("validEntriesCount" , validEntriesCount)

        const average = validEntriesCount > 0 ? sum / validEntriesCount : 0;
        return average;
      } else {
        return null;
      }
    };

    // Calculate averages for different data sets when actual - estimate is zero
    const averagebyopenOC1_flat0 = calculateSumAndAveragebyopen_flat0(
      usddata,
      a_minus_evalue
    );
    setAverageDifff_flat0(averagebyopenOC1_flat0);
    const averagebyopenOC2_flat0 = calculateSumAndAveragebyopen_flat0(
      jpydata,
      a_minus_evalue
    );
    setavgjpydifff_flat0(averagebyopenOC2_flat0);
    const averagebyopenOC3_flat0 = calculateSumAndAveragebyopen_flat0(
      gbpnzddata,
      a_minus_evalue
    );
    setaveragegbpnzdbyodiff1_flat0(averagebyopenOC3_flat0);
    const averagebyopenOC4_flat0 = calculateSumAndAveragebyopen_flat0(
      eurgbpdata,
      a_minus_evalue
    );
    setaveragegbpeurbyodiff1_flat0(averagebyopenOC4_flat0);
    const averagebyopenOC5_flat0 = calculateSumAndAveragebyopen_flat0(
      gbpchfdata,
      a_minus_evalue
    );
    setaveragegbpchfbyodiff1_flat0(averagebyopenOC5_flat0);
    const averagebyopenOC6_flat0 = calculateSumAndAveragebyopen_flat0(
      gbpauddata,
      a_minus_evalue
    );
    setaveragegbpaudbyodiff1_flat0(averagebyopenOC6_flat0);
    const averagebyopenOC7_flat0 = calculateSumAndAveragebyopen_flat0(
      gbpcaddata,
      a_minus_evalue
    );
    setaveragegbpcadbyodiff1_flat0(averagebyopenOC7_flat0);

    // <----------------FLAT 0 , L-O---->

    const calculateSumAndAverageLObyopen_flat0 = (data, differences) => {
      const filledData = eventavgdate.map((date, index) => {
        const time = eventavgtime[index];
        const entry = data.find(
          (item) => item.date === date && item.time === time
        );
        return entry || { date: date, time: time, Open: "", Low: "" };
      });

      if (filledData.some((entry) => entry.Open !== "" && entry.Low !== "")) {
        const sum = filledData.reduce((total, item, index) => {
          if (differences[index] === 0.0 || differences[index] === -0.0) {
            if (item.Low === "" || item.Open === "") {
              return total;
            }
            const differencebyopenLO = (item.Low - item.Open) / item.Open;
            const modulusbyopenLO = Math.abs(differencebyopenLO * 100).toFixed(
              3
            );
            return total + modulusbyopenLO;
          }
          return total;
        }, 0);

        // const validEntriesCount = filledData.filter(
        //   (item, index) =>
        //     differences[index] === 0.0 ||
        //     (differences[index] === -0.0 && item.Open !== "" && item.Low !== "")
        // ).length;

        const validEntriesCount = filledData.filter((item, index) => {
          const openlowwNotEmpty = item.Open !== "" && item.Low !== "";
          // Only include the item if Low and High are not empty and the difference of A-E is not 0.0 or -0.0
          return (
            openlowwNotEmpty &&
            differences[index] === 0.0 &&
            differences[index] === -0.0
          );
        }).length;

        // console.log("validEntriesCount" , validEntriesCount)

        const average = validEntriesCount > 0 ? sum / validEntriesCount : 0;
        return average;
      } else {
        return null;
      }
    };

    // Calculate averages for different data sets when actual - estimate is zero
    const averagebyopenOL1_flat0 = calculateSumAndAverageLObyopen_flat0(
      usddata,
      a_minus_evalue
    );
    setAverageDifff2_flat0(averagebyopenOL1_flat0);
    const averagebyopenOL2_flat0 = calculateSumAndAverageLObyopen_flat0(
      jpydata,
      a_minus_evalue
    );
    setavgjpydifff2_flat0(averagebyopenOL2_flat0);
    const averagebyopenOL3_flat0 = calculateSumAndAverageLObyopen_flat0(
      gbpnzddata,
      a_minus_evalue
    );
    setaveragegbpnzdbyodiff2_flat0(averagebyopenOL3_flat0);
    const averagebyopenOL4_flat0 = calculateSumAndAverageLObyopen_flat0(
      eurgbpdata,
      a_minus_evalue
    );
    setaveragegbpeurbyodiff2_flat0(averagebyopenOL4_flat0);
    const averagebyopenOL5_flat0 = calculateSumAndAverageLObyopen_flat0(
      gbpchfdata,
      a_minus_evalue
    );
    setaveragegbpchfbyodiff2_flat0(averagebyopenOL5_flat0);
    const averagebyopenOL6_flat0 = calculateSumAndAverageLObyopen_flat0(
      gbpauddata,
      a_minus_evalue
    );
    setaveragegbpaudbyodiff2_flat0(averagebyopenOL6_flat0);
    const averagebyopenOL7_flat0 = calculateSumAndAverageLObyopen_flat0(
      gbpcaddata,
      a_minus_evalue
    );
    setaveragegbpcadbyodiff2_flat0(averagebyopenOL7_flat0);

    // <-----flat 0 average , H-O----->

    const calculateSumAndAverageHObyopen_flat0 = (data, differences) => {
      const filledData = eventavgdate.map((date, index) => {
        const time = eventavgtime[index];
        const entry = data.find(
          (item) => item.date === date && item.time === time
        );
        return entry || { date: date, time: time, Open: "", High: "" };
      });

      if (filledData.some((entry) => entry.Open !== "" && entry.High !== "")) {
        const sum = filledData.reduce((total, item, index) => {
          if (differences[index] === 0.0 || differences[index] === -0.0) {
            if (item.High === "" || item.Open === "") {
              return total;
            }
            const differencebyopenHO = (item.High - item.Open) / item.Open;
            const modulusbyopenHO = Math.abs(differencebyopenHO * 100).toFixed(
              3
            );
            return total + modulusbyopenHO;
          }
          return total;
        }, 0);

        const validEntriesCount = filledData.filter((item, index) => {
          const openhighhNotEmpty = item.Open !== "" && item.High !== "";
          // Only include the item if Low and High are not empty and the difference of A-E is not 0.0 or -0.0
          return (
            openhighhNotEmpty &&
            differences[index] === 0.0 &&
            differences[index] === -0.0
          );
        }).length;

        // console.log("validEntriesCount" , validEntriesCount)

        const average = validEntriesCount > 0 ? sum / validEntriesCount : 0;
        return average;
      } else {
        return null;
      }
    };

    // Calculate averages for different data sets when actual - estimate is zero
    const averagebyopenOH1_flat0 = calculateSumAndAverageHObyopen_flat0(
      usddata,
      a_minus_evalue
    );
    setAverageDifff3_flat0(averagebyopenOH1_flat0);
    const averagebyopenOH2_flat0 = calculateSumAndAverageHObyopen_flat0(
      jpydata,
      a_minus_evalue
    );
    setavgjpydifff3_flat0(averagebyopenOH2_flat0);
    const averagebyopenOH3_flat0 = calculateSumAndAverageHObyopen_flat0(
      gbpnzddata,
      a_minus_evalue
    );
    setaveragegbpnzdbyodiff3_flat0(averagebyopenOH3_flat0);
    const averagebyopenOH4_flat0 = calculateSumAndAverageHObyopen_flat0(
      eurgbpdata,
      a_minus_evalue
    );
    setaveragegbpeurbyodiff3_flat0(averagebyopenOH4_flat0);
    const averagebyopenOH5_flat0 = calculateSumAndAverageHObyopen_flat0(
      gbpchfdata,
      a_minus_evalue
    );
    setaveragegbpchfbyodiff3_flat0(averagebyopenOH5_flat0);
    const averagebyopenOH6_flat0 = calculateSumAndAverageHObyopen_flat0(
      gbpauddata,
      a_minus_evalue
    );
    setaveragegbpaudbyodiff3_flat0(averagebyopenOH6_flat0);
    const averagebyopenOH7_flat0 = calculateSumAndAverageHObyopen_flat0(
      gbpcaddata,
      a_minus_evalue
    );
    setaveragegbpcadbyodiff3_flat0(averagebyopenOH7_flat0);
  };

  useEffect(() => {
    calculate_currencyaveragebyopen();
  }, [
    eventHistory,
    eurgbpdata,
    gbpauddata,
    gbpcaddata,
    gbpchfdata,
    gbpnzddata,
    jpydata,
    usddata,
  ]);

  const handleModalShowClick = () => {
    setModalshow(true);
  };

  const handleRefresh = () => {
    setIsReloadLoading(true);
    setLoading(false);
    // Loop through localStorage and remove any item with "Clickeddate_data_"
    Object.keys(localStorage).forEach((key) => {
      if (
        key.includes("Clickeddate_data_") ||
        key.includes("table3_historyData_") ||
        key.includes("clickedmodal_data_2ndpage_")
      ) {
        localStorage.removeItem(key);
      }
    });

    localStorage.removeItem("All_events_history");
    localStorage.removeItem("lastDeletionTime");
    localStorage.removeItem("UserId");
    localStorage.removeItem("userId");
    localStorage.removeItem("selectedtime");
    localStorage.removeItem("4GraphDataobjects");
    // localStorage.removeItem("userregisterId");
    // localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("todayDate");
    localStorage.removeItem("previousDate_u_search_history");

    localStorage.removeItem("selectedtime");

    setIsReloadLoading(false);
    setLoading(false);
    historydata_table(selectedTime);
    window.location.reload();
  };

  // <----------1,5,15,60 min click----------->
  const handletimebtnclick = (value) => {
    let timeclickedurl;
    setLoading(true);

    if (value === "1min") {
      // console.log("im inside 1min btn");
      setSelectedTime(1);
      setClickedtimeButton("1min");
      timeclickedurl = 1;

      setTimeclickedurl_state(timeclickedurl);
      // console.log("timeclickedurl" , timeclickedurl)
      setLoading(false);

      localStorage.setItem("selectedtime", JSON.stringify(1));
      // historydata(1);
    } else if (value === "2min") {
      // console.log("im inside 5min btn");
      setSelectedTime(2);
      setClickedtimeButton("2min");
      timeclickedurl = 2;
      setTimeclickedurl_state(timeclickedurl);
      // console.log("5");
      setLoading(false);
      localStorage.setItem("selectedtime", JSON.stringify(2));
      // historydata(5);
    } else if (value === "5min") {
      // console.log("im inside 15min btn");
      setSelectedTime(5);
      setClickedtimeButton("5min");
      // console.log("15");
      timeclickedurl = 5;

      setTimeclickedurl_state(timeclickedurl);
      // console.log("selectedTime", selectedTime);
      setLoading(false);
      localStorage.setItem("selectedtime", JSON.stringify(5));
      // historydata(15);
    } else if (value === "15min") {
      // console.log("im inside 60min btn");
      setSelectedTime(15);
      setClickedtimeButton("15min");
      timeclickedurl = 15;
      if (clickedtimeButton === "15min") {
        timeclickedurl = 15;
        setTimeclickedurl_state(timeclickedurl);
      }

      setTimeclickedurl_state(timeclickedurl);
      setLoading(false);
      localStorage.setItem("selectedtime", JSON.stringify(15));
    }
    const url = new URL(window.location.href);
    // url.searchParams.set("timeclickedurl", timeclickedurl); // Set the new value
    window.history.replaceState(null, "", url.toString()); // Update the URL
  };

  function roundDownToNearestMultipleOf5(time) {
    const [hours, minutes] = time.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes;
    const roundedMinutes = Math.floor(totalMinutes / 5) * 5;
    const roundedHours = Math.floor(roundedMinutes / 60);
    const finalHours = roundedHours.toString().padStart(2, "0");
    const finalMinutes = (roundedMinutes % 60).toString().padStart(2, "0");
    return `${finalHours}:${finalMinutes}:00`;
  }

  function roundDownToNearestMultipleOf15(time) {
    const [hours, minutes] = time.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes;
    const roundedMinutes = Math.floor(totalMinutes / 15) * 15;
    const roundedHours = Math.floor(roundedMinutes / 60);
    const finalHours = roundedHours.toString().padStart(2, "0");
    const finalMinutes = (roundedMinutes % 60).toString().padStart(2, "0");
    return `${finalHours}:${finalMinutes}:00`;
  }

  function roundDownToNearestMultipleOf1Hour(time) {
    const [hours] = time.split(":").map(Number);
    const roundedHours = Math.floor(hours);
    const finalHours = roundedHours.toString().padStart(2, "0");
    const finalMinutes = "00";
    return `${finalHours}:${finalMinutes}:00`;
  }

  const handlegoback = () => {
    navigate("/user/economicdata");
  };

  let arraygbpusd = [];
  let arraygbpjpy = [];
  let arraygbpaud = [];
  let arraygbpcad = [];
  let arraygbpchf = [];
  let arraygbpeur = [];
  let arraygbpnzd = [];

  let arraygbpusdlo = [];
  let arraygbpjpylo = [];
  let arraygbpaudlo = [];
  let arraygbpcadlo = [];
  let arraygbpchflo = [];
  let arraygbpeurlo = [];
  let arraygbpnzdlo = [];

  let arraygbpusdho = [];
  let arraygbpjpyho = [];
  let arraygbpaudho = [];
  let arraygbpcadho = [];
  let arraygbpchfho = [];
  let arraygbpeurho = [];
  let arraygbpnzdho = [];

  function countemp(array) {
    let positiveCountgbp = 0;
    let negativeCountgbp = 0;
    let positivepositiveCountgbp = 0;
    let empty = 0;
    let emp = 0; //emp=== N/A

    for (let num of array) {
      if (num === "+") {
        positiveCountgbp++;
      } else if (num === "-") {
        negativeCountgbp++;
      } else if (num === "++") {
        positivepositiveCountgbp++;
      } else if (num === "") {
        empty++;
      } else if (num === "N/A") {
        emp++;
      }
    }

    // console.log("N/A" , emp)
    // console.log("length" ,array.length )
    return (emp / array.length) * 100;
  }

  // console.log("countemp" , countemp(array));
  function countPositive(array) {
    let positiveCountgbp = 0;
    let positivepositiveCountgbp = 0;
    let negativenegativeCountgbpusd = 0;
    // <----------ye khali vala hai means 0 ""----->
    let empty = 0;

    let emp = 0;

    for (let num of array) {
      if (num === "+") {
        positiveCountgbp++;
      } else if (num === "--") {
        negativenegativeCountgbpusd++;
      } else if (num === "++") {
        positivepositiveCountgbp++;
      } else if (num === "") {
        empty++;
      } else if (num === "N/A") {
        emp++;
      }
    }
    const adjustedLength =
      array.length -
      (positivepositiveCountgbp + empty + emp + negativenegativeCountgbpusd);

    // console.log("negativeCountgbpusd" , negativeCountgbpusd)
    return (positiveCountgbp / adjustedLength) * 100;
  }

  function countNegative(array) {
    // let positiveCountgbp = 0;
    let negativenegativeCountgbpusd = 0;
    let positivepositiveCountgbp = 0;
    let negativeCountgbpusd = 0;
    let empty = 0;
    let emp = 0;

    for (let num of array) {
      if (num === "-") {
        negativeCountgbpusd++;
      } else if (num === "++") {
        positivepositiveCountgbp++;
      } else if (num === "") {
        empty++;
      } else if (num === "N/A") {
        emp++;
      } else if (num === "--") {
        negativenegativeCountgbpusd++;
      }
    }
    const adjustedLength =
      array.length -
      (positivepositiveCountgbp + empty + emp + negativenegativeCountgbpusd);
    return (negativeCountgbpusd / adjustedLength) * 100;
  }

  // <--------------flat positive---------->
  function countPositivePositive(array) {
    let positivepositiveCountgbp = 0;
    let empty = 0;
    let negativenegativeCountgbpusd = 0;

    for (let num of array) {
      if (num === "++") {
        positivepositiveCountgbp++;
      } else if (num === "") {
        empty++;
      } else if (num === "--") {
        negativenegativeCountgbpusd++;
      }
    }
    const adjustedLength =
      positivepositiveCountgbp + negativenegativeCountgbpusd;
    return (positivepositiveCountgbp / adjustedLength) * 100;
  }

  // <--------------flat nagative---------->
  function countNegativeNegative(array) {
    // let negativenegativegbpusd = 0;
    let positivepositiveCountgbp = 0;
    let empty = 0;
    let negativenegativeCountgbpusd = 0;

    for (let num of array) {
      if (num === "++") {
        positivepositiveCountgbp++;
      } else if (num === "") {
        empty++;
      } else if (num === "--") {
        negativenegativeCountgbpusd++;
      }
    }
    const adjustedLength =
      positivepositiveCountgbp + negativenegativeCountgbpusd;
    return (negativenegativeCountgbpusd / adjustedLength) * 100;
  }

  // <------------co------------>
  const avgdatagbpusdco =
    (averageDifff !== null ? averageDifff.toFixed(3) : "N/A") + "%";
  const avgdatagbpjpyco =
    (avgjpydifff !== null ? avgjpydifff.toFixed(3) : "N/A") + "%";
  const avgdatagbpnzdco =
    (averagegbpnzdbyodiff1 !== null
      ? averagegbpnzdbyodiff1.toFixed(3)
      : "N/A") + "%";
  const avgdatagbpeurco =
    (averagegbpeurbyodiff1 !== null
      ? averagegbpeurbyodiff1.toFixed(3)
      : "N/A") + "%";
  const avgdatagbpchfco =
    (averagegbpchfbyodiff1 !== null
      ? averagegbpchfbyodiff1.toFixed(3)
      : "N/A") + "%";
  const avgdatagbpaudco =
    (averagegbpaudbyodiff1 !== null
      ? averagegbpaudbyodiff1.toFixed(3)
      : "N/A") + "%";
  const avgdatagbpcadco =
    (averagegbpcadbyodiff1 !== null
      ? averagegbpcadbyodiff1.toFixed(3)
      : "N/A") + "%";

  const values = [
    parseFloat(avgdatagbpusdco),
    parseFloat(avgdatagbpjpyco),
    parseFloat(avgdatagbpnzdco),
    parseFloat(avgdatagbpeurco),
    parseFloat(avgdatagbpchfco),
    parseFloat(avgdatagbpaudco),
    parseFloat(avgdatagbpcadco),
  ];

  values.sort((a, b) => b - a);
  let highest1 = values[0].toFixed(3) + "%";
  let highest2 = values[1].toFixed(3) + "%";
  let highest3 = values[2].toFixed(3) + "%";

  // console.log("highest1" , highest1 , highest2 , highest3)
  // <------------lo------------>
  const avgdatagbpusdlo =
    (averageDifff2 !== null ? averageDifff2.toFixed(3) : "N/A") + "%";
  const avgdatagbpjpylo =
    (avgjpydifff2 !== null ? avgjpydifff2.toFixed(3) : "N/A") + "%";
  const avgdatagbpnzdlo =
    (averagegbpnzdbyodiff2 !== null
      ? averagegbpnzdbyodiff2.toFixed(3)
      : "N/A") + "%";
  const avgdatagbpeurlo =
    (averagegbpeurbyodiff2 !== null
      ? averagegbpeurbyodiff2.toFixed(3)
      : "N/A") + "%";
  const avgdatagbpchflo =
    (averagegbpchfbyodiff2 !== null
      ? averagegbpchfbyodiff2.toFixed(3)
      : "N/A") + "%";
  const avgdatagbpaudlo =
    (averagegbpaudbyodiff2 !== null
      ? averagegbpaudbyodiff2.toFixed(3)
      : "N/A") + "%";
  const avgdatagbpcadlo =
    (averagegbpcadbyodiff2 !== null
      ? averagegbpcadbyodiff2.toFixed(3)
      : "N/A") + "%";

  const values1 = [
    parseFloat(avgdatagbpusdlo),
    parseFloat(avgdatagbpjpylo),
    parseFloat(avgdatagbpnzdlo),
    parseFloat(avgdatagbpeurlo),
    parseFloat(avgdatagbpchflo),
    parseFloat(avgdatagbpaudlo),
    parseFloat(avgdatagbpcadlo),
  ];

  values1.sort((a, b) => b - a);
  let highest1lo = values1[0].toFixed(3) + "%";
  let highest2lo = values1[1].toFixed(3) + "%";
  let highest3lo = values1[2].toFixed(3) + "%";
  // console.log("highest1lo" , highest1lo , highest2lo, highest3lo)
  // <------------ho------------>
  const avgdatagbpusdho =
    (averageDifff3 !== null ? averageDifff3.toFixed(4) : "N/A") + "%";
  const avgdatagbpjpyho =
    (avgjpydifff3 !== null ? avgjpydifff3.toFixed(4) : "N/A") + "%";
  const avgdatagbpnzdho =
    (averagegbpnzdbyodiff3 !== null
      ? averagegbpnzdbyodiff3.toFixed(3)
      : "N/A") + "%";
  const avgdatagbpeurho =
    (averagegbpeurbyodiff3 !== null
      ? averagegbpeurbyodiff3.toFixed(3)
      : "N/A") + "%";
  const avgdatagbpchfho =
    (averagegbpchfbyodiff3 !== null
      ? averagegbpchfbyodiff3.toFixed(3)
      : "N/A") + "%";
  const avgdatagbpaudho =
    (averagegbpaudbyodiff3 !== null
      ? averagegbpaudbyodiff3.toFixed(3)
      : "N/A") + "%";
  const avgdatagbpcadho =
    (averagegbpcadbyodiff3 !== null
      ? averagegbpcadbyodiff3.toFixed(3)
      : "N/A") + "%";

  const values3 = [
    parseFloat(avgdatagbpusdho),
    parseFloat(avgdatagbpjpyho),
    parseFloat(avgdatagbpnzdho),
    parseFloat(avgdatagbpeurho),
    parseFloat(avgdatagbpchfho),
    parseFloat(avgdatagbpaudho),
    parseFloat(avgdatagbpcadho),
  ];

  values3.sort((a, b) => b - a);
  let highest1ho = values3[0].toFixed(3) + "%";
  let highest2ho = values3[1].toFixed(3) + "%";
  let highest3ho = values3[2].toFixed(3) + "%";
  // console.log("highest1ho" , highest1ho , highest2ho , highest3ho)
  // <--------------------------highest value of flat average ----------------->
  // <------------co------------>
  const avgdatausdco =
    (averageDifff_flat0 !== null ? averageDifff_flat0.toFixed(3) : "N/A") + "%";
  const avgdatajpyco =
    (avgjpydifff_flat0 !== null ? avgjpydifff_flat0.toFixed(3) : "N/A") + "%";
  const avgdatanzdco =
    (averagegbpnzdbyodiff1_flat0 !== null
      ? averagegbpnzdbyodiff1_flat0.toFixed(3)
      : "N/A") + "%";
  const avgdataeurco =
    (averagegbpeurbyodiff1_flat0 !== null
      ? averagegbpeurbyodiff1_flat0.toFixed(3)
      : "N/A") + "%";
  const avgdatachfco =
    (averagegbpchfbyodiff1_flat0 !== null
      ? averagegbpchfbyodiff1_flat0.toFixed(3)
      : "N/A") + "%";
  const avgdataaudco =
    (averagegbpaudbyodiff1_flat0 !== null
      ? averagegbpaudbyodiff1_flat0.toFixed(3)
      : "N/A") + "%";
  const avgdatacadco =
    (averagegbpcadbyodiff1_flat0 !== null
      ? averagegbpcadbyodiff1_flat0.toFixed(3)
      : "N/A") + "%";
  // console.log("avgdatausdco" , avgdatausdco)
  const valuesflatco = [
    parseFloat(avgdatausdco),
    parseFloat(avgdatajpyco),
    parseFloat(avgdatanzdco),
    parseFloat(avgdataeurco),
    parseFloat(avgdatachfco),
    parseFloat(avgdataaudco),
    parseFloat(avgdatacadco),
  ];
  // console.log("valuesflatco" , valuesflatco)
  const data_valuesflatco = valuesflatco
    .filter((value) => value !== 0.0 && !isNaN(value))
    .sort((a, b) => b - a);
  let highest1coflat =
    data_valuesflatco[0] !== undefined
      ? data_valuesflatco[0].toFixed(3) + "%"
      : "N/A";
  let highest2coflat =
    data_valuesflatco[1] !== undefined
      ? data_valuesflatco[1].toFixed(3) + "%"
      : "N/A";
  let highest3coflat =
    data_valuesflatco[2] !== undefined
      ? data_valuesflatco[2].toFixed(3) + "%"
      : "N/A";
  //
  // <------------lo------------>
  const avgdatausdlo =
    (averageDifff2_flat0 !== null ? averageDifff2_flat0.toFixed(3) : "N/A") +
    "%";
  const avgdatajpylo =
    (avgjpydifff2_flat0 !== null ? avgjpydifff2_flat0.toFixed(3) : "N/A") + "%";
  const avgdatanzdlo =
    (averagegbpnzdbyodiff2_flat0 !== null
      ? averagegbpnzdbyodiff2_flat0.toFixed(3)
      : "N/A") + "%";
  const avgdataeurlo =
    (averagegbpeurbyodiff2_flat0 !== null
      ? averagegbpeurbyodiff2_flat0.toFixed(3)
      : "N/A") + "%";
  const avgdatachflo =
    (averagegbpchfbyodiff2_flat0 !== null
      ? averagegbpchfbyodiff2_flat0.toFixed(3)
      : "N/A") + "%";
  const avgdataaudlo =
    (averagegbpaudbyodiff2_flat0 !== null
      ? averagegbpaudbyodiff2_flat0.toFixed(3)
      : "N/A") + "%";
  const avgdatacadlo =
    (averagegbpcadbyodiff2_flat0 !== null
      ? averagegbpcadbyodiff2_flat0.toFixed(3)
      : "N/A") + "%";

  const values1loflat = [
    parseFloat(avgdatausdlo),
    parseFloat(avgdatajpylo),
    parseFloat(avgdatanzdlo),
    parseFloat(avgdataeurlo),
    parseFloat(avgdatachflo),
    parseFloat(avgdataaudlo),
    parseFloat(avgdatacadlo),
  ];

  const data_values1loflat = values1loflat
    .filter((value) => value !== 0.0 && !isNaN(value))
    .sort((a, b) => b - a);
  let highest1loflat =
    data_values1loflat[0] !== undefined
      ? data_values1loflat[0].toFixed(3) + "%"
      : "N/A";
  let highest2loflat =
    data_values1loflat[1] !== undefined
      ? data_values1loflat[1].toFixed(3) + "%"
      : "N/A";
  let highest3loflat =
    data_values1loflat[2] !== undefined
      ? data_values1loflat[2].toFixed(3) + "%"
      : "N/A";

  // <------------ho------------>
  const avgdatausdho =
    (averageDifff3_flat0 !== null ? averageDifff3_flat0.toFixed(3) : "N/A") +
    "%";
  const avgdatajpyho =
    (avgjpydifff3_flat0 !== null ? avgjpydifff3_flat0.toFixed(3) : "N/A") + "%";
  const avgdatanzdho =
    (averagegbpnzdbyodiff3_flat0 !== null
      ? averagegbpnzdbyodiff3_flat0.toFixed(3)
      : "N/A") + "%";
  const avgdataeurho =
    (averagegbpeurbyodiff3_flat0 !== null
      ? averagegbpeurbyodiff3_flat0.toFixed(3)
      : "N/A") + "%";
  const avgdatachfho =
    (averagegbpchfbyodiff3_flat0 !== null
      ? averagegbpchfbyodiff3_flat0.toFixed(3)
      : "N/A") + "%";
  const avgdataaudho =
    (averagegbpaudbyodiff3_flat0 !== null
      ? averagegbpaudbyodiff3_flat0.toFixed(3)
      : "N/A") + "%";
  const avgdatacadho =
    (averagegbpcadbyodiff3_flat0 !== null
      ? averagegbpcadbyodiff3_flat0.toFixed(3)
      : "N/A") + "%";

  const values3hoflat = [
    parseFloat(avgdatausdho),
    parseFloat(avgdatajpyho),
    parseFloat(avgdatanzdho),
    parseFloat(avgdataeurho),
    parseFloat(avgdatachfho),
    parseFloat(avgdataaudho),
    parseFloat(avgdatacadho),
  ];

  const data_values3hoflat = values3hoflat
    .filter((value) => value !== 0 && !isNaN(value))
    .sort((a, b) => b - a);
  let highest1hoflat =
    data_values3hoflat[0] !== undefined
      ? data_values3hoflat[0].toFixed(3) + "%"
      : "N/A";
  let highest2hoflat =
    data_values3hoflat[1] !== undefined
      ? data_values3hoflat[1].toFixed(3) + "%"
      : "N/A";
  let highest3hoflat =
    data_values3hoflat[2] !== undefined
      ? data_values3hoflat[2].toFixed(3) + "%"
      : "N/A";

  const [filteredModalData, setFilteredModalData] = useState([]);
  const handleShowModalbeforetime = (date) => {
    const filteredData = modalimpactdatabeforetime.filter(
      (item) => item.date === date
    );
    setFilteredModalData(filteredData);
    document.getElementById("my_modal_2").showModal();
  };

  const handleShowModalbeforetime_2nd_table = (date) => {
    const filteredData = modalimpactdatabeforetime.filter(
      (item) => item.date === date
    );
    setFilteredModalData(filteredData);
    document.getElementById("my_modal_2_2nd_table").showModal();
  };

  const handleShowModalbeforetime_3rd_table = (date) => {
    const filteredData = modalimpactdatabeforetime.filter(
      (item) => item.date === date
    );
    setFilteredModalData(filteredData);
    document.getElementById("my_modal_2_3rdtable").showModal();
  };

  const [filteredModalDataontime, setFilteredModalDataontime] = useState([]);
  const handleShowModalontime = (date) => {
    const filteredData = modalimpactdataontime.filter(
      (item) => item.date === date
    );
    setFilteredModalDataontime(filteredData);
    document.getElementById("my_modal_3").showModal();
  };
  const handleShowModalontime_2nd_table = (date) => {
    const filteredData = modalimpactdataontime.filter(
      (item) => item.date === date
    );
    setFilteredModalDataontime(filteredData);
    document.getElementById("my_modal_3_2nd_table").showModal();
  };
  const handleShowModalontime_3rd_table = (date) => {
    const filteredData = modalimpactdataontime.filter(
      (item) => item.date === date
    );
    setFilteredModalDataontime(filteredData);
    document.getElementById("my_modal_3_3rd_table").showModal();
  };

  useEffect(() => {
    const modal = document.getElementById("my_modal_3_3rd_table");

    const handleOpen = () => {
      document.body.style.overflow = "hidden"; // Prevent background scrolling
    };

    const handleClose = () => {
      document.body.style.overflow = "auto"; // Restore scrolling
    };

    if (modal) {
      modal.addEventListener("click", (event) => {
        if (event.target === modal) {
          modal.close(); // Close modal when clicking outside
        }
      });

      modal.addEventListener("cancel", handleClose); // When user presses "Escape"
      modal.addEventListener("close", handleClose); // When modal closes normally
      modal.addEventListener("DOMNodeInserted", handleOpen); // Detect when it's added
    }

    return () => {
      if (modal) {
        modal.removeEventListener("cancel", handleClose);
        modal.removeEventListener("close", handleClose);
        modal.removeEventListener("DOMNodeInserted", handleOpen);
      }
      document.body.style.overflow = "auto"; // Cleanup on unmount
    };
  }, [handleShowModalontime_3rd_table, handleShowModalbeforetime_3rd_table]);
  function autoClickButton() {
    var button = document.getElementById("aashima_id");
    button.click();
  }
  function autoClickButton_2nd_table() {
    var button = document.getElementById("aashima_id_2nd_table");
    button.click();
  }
  function autoClickButton_3rd_table() {
    var button = document.getElementById("aashima_id_3rd_table");
    button.click();
  }
  function autoClickButton1() {
    var button = document.getElementById("closemod11");
    button.click();
  }
  function autoClickButton1_2nd_table() {
    var button = document.getElementById("closemod11__2nd_table");
    button.click();
  }
  function autoClickButton1_3rd_table() {
    var button = document.getElementById("closemod11__3rd_table");
    button.click();
  }

  useEffect(() => {
    const dates = eventHistory.map((item) => item.date);
    // Function to parse dates and calculate the difference in days
    function getDateDifferences(dates) {
      const dateDifferences = [];
      for (let i = 0; i < dates.length - 1; i++) {
        const date1 = new Date(dates[i]);
        const date2 = new Date(dates[i + 1]);
        const differenceInTime = Math.abs(date2.getTime() - date1.getTime());
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);
        dateDifferences.push(differenceInDays);
      }
      return dateDifferences;
    }

    // Get the date differences for the first 6 days
    const first6Dates = dates.slice(0, 6);
    const dateDifferences = getDateDifferences(first6Dates);
    const sumOfDifferences = dateDifferences.reduce(
      (sum, diff) => sum + diff,
      0
    );
    const averageGap = sumOfDifferences / dateDifferences.length;
    const roundedAverageGap = Math.round(averageGap);
    setFrequency_date(roundedAverageGap);
    // console.log('Average gap between the first 6 days:', roundedAverageGap);
  }, [eventHistory]);

  // <------third table averge movement varients are calculating here final table-------->

  const calculateAverageHighLow = (
    data_avg,
    setAverageHighLow,
    setAvgOfThirdTable,
    setAvgOfThirdTable_flat0,
    eventHistory
  ) => {
    const a_minus_evalue = eventHistory2.map((item) =>
      item.actual - item.estimate === 0 ||
      item.estimate === null ||
      item.estimate === ""
        ? item.actual - item.previous
        : item.actual - item.estimate
    );

    const groupedByDate = data_avg.reduce((acc, entry) => {
      const entryDate = entry.date.split(".").reverse().join("."); // Format date to YYYY.MM.DD
      if (!acc[entryDate]) {
        acc[entryDate] = [];
      }
      acc[entryDate].push(entry);
      return acc;
    }, {});

    // Convert groupedByDate into an array of entries and merge consecutive dates
    const mergeConsecutiveDates = (groupedByDate) => {
      const groupedData = Object.entries(groupedByDate).sort((a, b) => {
        // Sort dates in ascending order
        return (
          new Date(a[0].split(".").join("-")) -
          new Date(b[0].split(".").join("-"))
        );
      });

      const mergedResult = [];
      let currentGroup = null;

      groupedData.forEach(([date, entries], index) => {
        const currentDate = new Date(date.split(".").join("-"));
        const previousDate = currentGroup
          ? new Date(currentGroup[0].split(".").join("-"))
          : null;

        if (
          previousDate &&
          currentDate - previousDate === 1 * 24 * 60 * 60 * 1000
        ) {
          // If dates are consecutive, merge into the current group
          currentGroup[1] = [...currentGroup[1], ...entries];
        } else {
          // Push the completed group and start a new one
          if (currentGroup) mergedResult.push(currentGroup);
          currentGroup = [date, [...entries]];
        }
      });

      // Add the last group
      if (currentGroup) mergedResult.push(currentGroup);

      // Update the group date to be the most recent date
      return mergedResult.map(([groupDate, groupEntries]) => {
        // Get the most recent date from the group
        // const latestDate = (groupEntries[groupEntries.length - 1].date);
        const latestDate = groupEntries[groupEntries.length - 1].date
          .split(".")
          .reverse()
          .join(".");
        return [latestDate, groupEntries];
      });
    };

    // Example data_avg to test

    const groupedAndMerged = mergeConsecutiveDates(groupedByDate);
    // console.log("groupedAndMerged ------------>" , groupedAndMerged);

    const reversedGroupedAndMerged = groupedAndMerged.reverse();

    let sliced_entries;
    if (optionValue === "Last 6") {
      sliced_entries = groupedAndMerged.slice(0, 6);
    } else if (optionValue === "Last 12") {
      sliced_entries = groupedAndMerged.slice(0, 12);
    } else {
      sliced_entries = groupedAndMerged;
    }

    const eventTimes = eventHistory2.map((item) => item.time);
    const eventDate = eventHistory2.map((item) => item.date);
    const findemptyestimate = eventHistory2.map((item) => item.estimate);

    //  <-------- it will return empty data if dates r not matching or data is missed in eventhistory2 --------->

    const result = eventHistory2.map((event) => {
      // console.log("eventHistory2" , eventHistory2)
      const formattedEventDate = event.date;

      const result = sliced_entries.find(
        ([date]) => date === formattedEventDate
      );
      if (result) {
        return {
          date: event.date,
          entries: result[1].slice(0, 6), // Use the second element of the matching array
        };
      } else {
        return {
          date: event.date,
          entries: [],
        };
      }
    });

    // console.log("result----------->-" , result)
    // Now, calculate the average differences
    let sumOfAverages = 0;
    let countOfAverages = 0;
    let sumOfFirstIndexValues = 0;

    let countOfAverages_flat0 = 0;
    let sumOfAverages_flat0 = 0;

    const averageDifferencesArray = result.map((item, index) => {
      const { date, entries } = item;

      const matchingEntries = entries.filter((entry) =>
        eventTimes.includes(entry.time)
      );
      // <---matching entries means on that particular time--->
      // <----- comment - this is that minute value H-L by avg of 5min---->
      const nonMatchingEntries = entries.filter(
        (entry) => !eventTimes.includes(entry.time)
      );

      // console.log("nonMatchingEntries90" , nonMatchingEntries)
      // console.log("matchingEntries" , matchingEntries)
      const highLowDifferences = nonMatchingEntries.map(
        (entry) => entry.High - entry.Low
      );

      // console.log("highLowDifferences90" , highLowDifferences)
      // <--this is H-L of mathcing entry---->
      const matchingHighLowDifferences = matchingEntries.map(
        (entry) => entry.High - entry.Low
      );

      let finalsum_uppervalue_HL; // Declare without initializing

      if (matchingHighLowDifferences.length > 0) {
        const firstIndexValue = matchingHighLowDifferences[0];
        finalsum_uppervalue_HL = parseFloat(firstIndexValue);
      } else {
        finalsum_uppervalue_HL = "N/A";
      }

      let sumOfFirstIndexValues = 0;
      // Only add to sum if finalsum_uppervalue_HL is a number
      if (finalsum_uppervalue_HL !== "N/A") {
        sumOfFirstIndexValues += finalsum_uppervalue_HL;
      } else {
        sumOfFirstIndexValues = "N/A";
      }

      // console.log("sumOfFirstIndexValues" , sumOfFirstIndexValues)

      const totalDifference = highLowDifferences.reduce(
        (sum, diff) => sum + diff,
        0
      );

      // console.log("totalDifference" , totalDifference)
      const matchingTotalDifference = matchingHighLowDifferences.reduce(
        (sum, diff) => sum + diff,
        0
      );

      let averageDifference;

      // console.log("highLowDifferences.length" , highLowDifferences.length)
      if (sumOfFirstIndexValues !== "N/A") {
        // Check if totalDifference is 0
        if (totalDifference != 0 && highLowDifferences.length > 0) {
          averageDifference =
            sumOfFirstIndexValues /
            (totalDifference / highLowDifferences.length);
        } else {
          averageDifference = "Last 5 min's data is missing";
        }
      } else {
        averageDifference = "N/A";
      }

      const avgdata = parseFloat(averageDifference);
      // console.log("avgdata" , avgdata)
      // const finalavg = avgdata * 100;
      const finalavg = avgdata;
      // console.log("finalavg------------testing" , finalavg)

      if (a_minus_evalue[index] !== 0.0 && a_minus_evalue[index] !== -0.0) {
        if (!isNaN(finalavg)) {
          sumOfAverages += Math.round(finalavg * 100);
          // console.log("sumOfAverages single---------------->" , Math.round(finalavg*100))
          // console.log("sumOfAverages---------------->" , sumOfAverages)
          countOfAverages += 1;
        } else {
          // console.log("finalavg is NaN, skipping this value");
        }
      } else {
        if (!isNaN(finalavg)) {
          sumOfAverages_flat0 += Math.round(finalavg * 100);

          countOfAverages_flat0 += 1;
          // console.log("sumOfAverages_flat0" , sumOfAverages_flat0 , countOfAverages_flat0)
        }
      }

      if (averageDifference === "Last 5 min's data is missing") {
        // console.log("Last 5 min's data is missing");

        return { date, averageDifference: "Last 5 min's data is missing" };
      } else {
        return { date, averageDifference: avgdata };
      }
    });

    const overallAverage =
      countOfAverages > 0 ? sumOfAverages / countOfAverages : null;

    // console.log("overallAverage 1st---->" , overallAverage)
    const overallAverage_flat0 =
      countOfAverages_flat0 > 0
        ? sumOfAverages_flat0 / countOfAverages_flat0
        : null;
    // console.log("overallAverage_flat0 2nd---->" , overallAverage_flat0)

    setAverageHighLow(averageDifferencesArray);
    setAvgOfThirdTable(Math.round(overallAverage));

    setAvgOfThirdTable_flat0(Math.round(overallAverage_flat0));
  };

  useEffect(() => {
    calculateAverageHighLow(
      usddata_avg,
      setAverageHighLow_usddata,
      setAvg_ofthirdtable_usd,
      setAvg_ofthirdtable_usd_flat0,
      eventHistory2,
      optionValue
    );
    calculateAverageHighLow(
      jpydata_avg,
      setAverageHighLow_jpydata,
      setAvg_ofthirdtable_jpy,
      setAvg_ofthirdtable_jpy_flat0,
      eventHistory2,
      optionValue
    );
    calculateAverageHighLow(
      gbpnzddata_avg,
      setAverageHighLow_nzddata,
      setAvg_ofthirdtable_nzd,
      setAvg_ofthirdtable_nzd_flat0,
      eventHistory2,
      optionValue
    );
    calculateAverageHighLow(
      eurgbpdata_avg,
      setAverageHighLow_eurdata,
      setAvg_ofthirdtable_eur,
      setAvg_ofthirdtable_eur_flat0,
      eventHistory2,
      optionValue
    );
    calculateAverageHighLow(
      gbpchfdata_avg,
      setAverageHighLow_chfdata,
      setAvg_ofthirdtable_chf,
      setAvg_ofthirdtable_chf_flat0,
      eventHistory2,
      optionValue
    );
    calculateAverageHighLow(
      gbpauddata_avg,
      setAverageHighLow_auddata,
      setAvg_ofthirdtable_aud,
      setAvg_ofthirdtable_aud_flat0,
      eventHistory2,
      optionValue
    );
    calculateAverageHighLow(
      gbpcaddata_avg,
      setAverageHighLow_caddata,
      setAvg_ofthirdtable_cad,
      setAvg_ofthirdtable_cad_flat0,
      eventHistory2,
      optionValue
    );
  }, [
    optionValue,
    handleOptionChange,
    eventHistory2,
    allEventHistory2,
    usddata_avg,
    jpydata_avg,
    gbpnzddata_avg,
    eurgbpdata_avg,
    gbpchfdata_avg,
    gbpauddata_avg,
    gbpcaddata_avg,
  ]);

  // <------render data in 3rd table(average of 5min averages ------->
  const renderTableRows_avg = (averagedata_table, date) => {
    const filteredData = averagedata_table.find((item) => item.date === date);
    if (!filteredData) {
      return <div className="py-7 bg-gray-200">No Data</div>;
    }

    const formattedDifference =
      filteredData.averageDifference === "Last 5 min's data is missing"
        ? "Last 5 min's data is missing"
        : typeof filteredData.averageDifference === "number" &&
          !isNaN(filteredData.averageDifference)
        ? filteredData.averageDifference
        : "N/A";

    const colorClass =
      formattedDifference === "N/A" || isNaN(formattedDifference)
        ? "bg-[#E5E7EB]"
        : Math.round(formattedDifference * 100) > 500.0
        ? "bg-[#7fe9a4]"
        : Math.round(formattedDifference * 100) > 300.0 &&
          Math.round(formattedDifference * 100) <= 500.0
        ? "bg-[#f7dc14]"
        : "bg-[#f3b2b2]";

    return (
      <div
        className={` py-6 ${colorClass}   h-[86px] flex justify-center items-center`}
      >
        {formattedDifference === "Last 5 min's data is missing"
          ? "N/A"
          : formattedDifference === "N/A"
          ? "N/A"
          : `(${Math.round(formattedDifference * 100)}%)`}
      </div>
    );
  };
  // <-------------color code special---------------->
  const renderTableRows_avg_colorcode = (averagedata_table, date) => {
    const filteredData = averagedata_table.find((item) => item.date === date);
    if (!filteredData) {
      return <div className="py-7 bg-gray-200">No Data</div>;
    }

    const formattedDifference =
      typeof filteredData.averageDifference === "number" &&
      !isNaN(filteredData.averageDifference)
        ? // ? filteredData.averageDifference.toFixed(5) * 100
          filteredData.averageDifference
        : "N/A";

    return formattedDifference === "N/A" || isNaN(formattedDifference)
      ? "bg-[#E5E7EB]"
      : Math.round(formattedDifference * 100) > 500.0
      ? "bg-[#7fe9a4]"
      : Math.round(formattedDifference * 100) >= 300.0 &&
        Math.round(formattedDifference * 100) < 500.0
      ? "bg-[#f7dc14]"
      : "bg-[#f3b2b2]";
  };

  // <----------calculate the average of 3rd table ------------->
  // <---cybercure-->
  const calculate_currencyaveragethirdtable = () => {
    const filteredEventHistory = eventHistory2.filter(
      (item) => item.estimate !== null && item.estimate !== ""
    );

    const a_minus_evalue = eventHistory2.map((item) =>
      item.actual - item.estimate === 0 ||
      item.estimate === null ||
      item.estimate === ""
        ? item.actual - item.previous
        : item.actual - item.estimate
    );

    // const a_minus_evalue = eventHistory.map(
    //   (item) => item.actual - item.estimate
    // );
    // <---here we r matching date time , bcz. length r different --->
    const eventavgtime = eventHistory2.map((item) => item.time);
    const eventavgestimate = eventHistory2.map((item) => item.estimate);
    const eventavgdate = eventHistory2.map((item) =>
      item.date.split(".").reverse().join(".")
    );

    const calculateAverageHL_thirdtable = (data, differences) => {
      const filledData = eventavgdate.map((date, index) => {
        const time = eventavgtime[index];
        const entry = data.find(
          (item) => item.date === date && item.time === time
        );
        return entry || { date: date, time: time, Low: "", High: "" };
      });

      if (filledData.some((entry) => entry.Low !== "" && entry.High !== "")) {
        const sum = filledData.reduce((total, item, index) => {
          if (a_minus_evalue[index] !== 0.0 && a_minus_evalue[index] !== -0.0) {
            if (item.High === "" || item.Low === "") {
              return total;
            }
            const differenceHL = item.High - item.Low;
            // console.log("differenceHL" , differenceHL)

            let modulusHL;
            if (data === jpydata_avg) {
              modulusHL = Math.abs(Math.round(differenceHL * 1000));
            } else {
              modulusHL = Math.abs(
                Math.round(differenceHL * (country === "JP" ? 1000 : 100000))
              );
            }

            // console.log("modulusHL" , modulusHL)
            return total + modulusHL;
          }
          return total;
        }, 0);
        // console.log("sum" , sum)
        const validEntriesCount = filledData.filter((item, index) => {
          const lowAndHighNotEmpty = item.Low !== "" && item.High !== "";

          // Only include the item if Low and High are not empty and the difference of A-E is not 0.0 or -0.0
          return (
            lowAndHighNotEmpty &&
            a_minus_evalue[index] !== 0.0 &&
            a_minus_evalue[index] !== -0.0
          );
        }).length;

        const average = validEntriesCount > 0 ? sum / validEntriesCount : 0;
        // console.log("validEntriesCount----------" , validEntriesCount)
        return average;
      } else {
        return null;
      }
    };

    // Calculate averages for different data sets
    const averageHL1 = calculateAverageHL_thirdtable(
      usddata_avg,
      a_minus_evalue
    );
    SetAveragegbpusddiff1_thirdtable(averageHL1);
    const averageHL2 = calculateAverageHL_thirdtable(
      jpydata_avg,
      a_minus_evalue
    );
    SetAveragegbpjpydiff1_thirdtable(averageHL2);
    const averageHL3 = calculateAverageHL_thirdtable(
      gbpnzddata_avg,
      a_minus_evalue
    );
    SetAveragegbpnzddiff1_thirdtable(averageHL3);
    const averageHL4 = calculateAverageHL_thirdtable(
      eurgbpdata_avg,
      a_minus_evalue
    );
    SetAveragegbpeurdiff1_thirdtable(averageHL4);
    const averageHL5 = calculateAverageHL_thirdtable(
      gbpchfdata_avg,
      a_minus_evalue
    );
    SetAveragegbpchfdiff1_thirdtable(averageHL5);
    const averageHL6 = calculateAverageHL_thirdtable(
      gbpauddata_avg,
      a_minus_evalue
    );
    SetAveragegbpauddiff1_thirdtable(averageHL6);
    const averageHL7 = calculateAverageHL_thirdtable(
      gbpcaddata_avg,
      a_minus_evalue
    );
    SetAveragegbpcaddiff1_thirdtable(averageHL7);

    // <-------for flat 0 values------------>

    const calculateSumAndAverageHL_flat0_thirdtable = (data, differences) => {
      const filledData = eventavgdate.map((date, index) => {
        const time = eventavgtime[index];
        const entry = data.find(
          (item) => item.date === date && item.time === time
        );
        return entry || { date: date, time: time, Low: "", High: "" };
      });
      // const filteredData = filledData.filter((entry, index) => {
      //   return eventavgestimate[index] !== undefined && eventavgestimate[index] !== null;
      // });
      if (filledData.some((entry) => entry.Low !== "" && entry.High !== "")) {
        const sum = filledData.reduce((total, item, index) => {
          if (a_minus_evalue[index] === 0.0 || a_minus_evalue[index] === -0.0) {
            if (item.High === "" || item.Low === "") {
              return total;
            }
            const differenceHL_thirdtable = item.High - item.Low;

            let modulusHL_thirdtable;
            if (data === jpydata_avg) {
              modulusHL_thirdtable = Math.abs(
                Math.round(differenceHL_thirdtable * 1000)
              );
            } else {
              modulusHL_thirdtable = Math.abs(
                Math.round(
                  differenceHL_thirdtable * (country === "JP" ? 1000 : 100000)
                )
              );
            }
            return total + modulusHL_thirdtable;
          }

          return total;
        }, 0);

        const validEntriesCount = filledData.filter((item, index) => {
          const lowhighhNotEmpty = item.Low !== "" && item.High !== "";

          // Only include the item if Low and High are not empty and the difference of A-E is not 0.0 or -0.0
          return (
            lowhighhNotEmpty &&
            a_minus_evalue[index] === 0.0 &&
            a_minus_evalue[index] === -0.0
          );
        }).length;

        const average = validEntriesCount > 0 ? sum / validEntriesCount : 0;
        // console.log("average------------" , average)
        return average;
      } else {
        return null;
      }
    };

    // Calculate averages for different data sets when actual - estimate is zero
    const averageHL1_flat0_thirdtable =
      calculateSumAndAverageHL_flat0_thirdtable(usddata_avg, a_minus_evalue);
    setaveragegbpusddiff1_flat0_thirdtable(averageHL1_flat0_thirdtable);

    const averageHL2_flat0_thirdtable =
      calculateSumAndAverageHL_flat0_thirdtable(jpydata_avg, a_minus_evalue);
    setaveragegbpjpydiff1_flat0_thirdtable(averageHL2_flat0_thirdtable);

    const averageHL3_flat0_thirdtable =
      calculateSumAndAverageHL_flat0_thirdtable(gbpnzddata_avg, a_minus_evalue);
    setaveragegbpnzddiff1_flat0_thirdtable(averageHL3_flat0_thirdtable);

    const averageHL4_flat0_thirdtable =
      calculateSumAndAverageHL_flat0_thirdtable(eurgbpdata_avg, a_minus_evalue);
    setaveragegbpeurdiff1_flat0_thirdtable(averageHL4_flat0_thirdtable);

    const averageHL5_flat0_thirdtable =
      calculateSumAndAverageHL_flat0_thirdtable(gbpchfdata_avg, a_minus_evalue);
    setaveragegbpchfdiff1_flat0_thirdtable(averageHL5_flat0_thirdtable);

    const averageHL6_flat0_thirdtable =
      calculateSumAndAverageHL_flat0_thirdtable(gbpauddata_avg, a_minus_evalue);
    setaveragegbpauddiff1_flat0_thirdtable(averageHL6_flat0_thirdtable);

    const averageHL7_flat0_thirdtable =
      calculateSumAndAverageHL_flat0_thirdtable(gbpcaddata_avg, a_minus_evalue);
    setaveragegbpcaddiff1_flat0_thirdtable(averageHL7_flat0_thirdtable);
  };

  useEffect(() => {
    calculate_currencyaveragethirdtable();
  }, [
    handleOptionChange,
    eventHistory2,
    allEventHistory,
    eventHistory,
    eurgbpdata,
    gbpauddata,
    gbpcaddata,
    gbpchfdata,
    gbpnzddata,
    jpydata,
    usddata,

    eurgbpdata_avg,
    gbpauddata_avg,
    gbpcaddata_avg,
    gbpchfdata_avg,
    gbpnzddata_avg,
    jpydata_avg,
    usddata_avg,
  ]);

  // <-------------aashima today---------- H-L of 5min third column 1st table----------->

  const calculate_fiveminutemaxHighLow = (
    data_avg_5min,
    setMaxHighLow_3rdColumn,
    setfinalAvg_ofmaxof5min,
    setfinalAvg_ofmaxof5min_flat0,
    eventHistory
  ) => {
    const a_minus_evalue = eventHistory2.map((item) =>
      item.actual - item.estimate === 0 ||
      item.estimate === null ||
      item.estimate === ""
        ? item.actual - item.previous
        : item.actual - item.estimate
    );

    const groupedByDate = data_avg_5min.reduce((acc, entry) => {
      const entryDate = entry.date.split(".").reverse().join(".");
      if (!acc[entryDate]) {
        acc[entryDate] = [];
      }

      acc[entryDate].push(entry);
      return acc;
    }, {});

    const groupedByDateArray = Object.entries(groupedByDate);

    let sliced_entries;
    if (optionValue === "Last 6") {
      sliced_entries = groupedByDateArray.slice(0, 6);
    } else if (optionValue === "Last 12") {
      sliced_entries = groupedByDateArray.slice(0, 12);
    } else {
      sliced_entries = groupedByDateArray;
    }

    const slicedGroupedByDate = Object.fromEntries(sliced_entries);

    const eventTimes = eventHistory2.map((item) => item.time);
    const eventDate = eventHistory2.map((item) => item.date);
    const findemptyestimate = eventHistory2.map((item) => item.estimate);

    let sumOfAverages = 0;
    let countOfAverages = 0;
    let countOfAverages_flat0 = 0;
    let sumOfAverages_flat0 = 0;

    //  <-------- it will return empty data if dates r not matching or data is missed in eventhistory2 --------->

    const result = eventHistory2.map((event) => {
      const formattedEventDate = event.date;
      if (formattedEventDate in slicedGroupedByDate) {
        return {
          date: event.date,
          entries: (slicedGroupedByDate[formattedEventDate] || []).slice(0, 6),
        };
      } else {
        return {
          date: event.date,
          entries: [],
        };
      }
    });

    // console.log("result" , result)

    const averageDifferencesArray2 = result.map((item, index) => {
      const { date, entries } = item;

      // console.log("entries" , entries)

      const result_1 = entries.reduce(
        (acc, entry) => {
          if (entry) {
            // console.log("entry", entry);
            acc.highest = Math.max(acc.highest, entry.High);
            acc.lowest = Math.min(acc.lowest, entry.Low);
            acc.hasValidEntry = true; // Mark that a valid entry was found
          }
          return acc;
        },
        { highest: -Infinity, lowest: Infinity, hasValidEntry: false }
      );
      // console.log("result_1" , result_1)

      let final_max_high_low;

      if (result_1.hasValidEntry) {
        final_max_high_low = result_1.highest - result_1.lowest;
      } else {
        final_max_high_low = "N/A";
      }
      // console.log('Highest High:', highest);
      // console.log('Lowest Low:', lowest);
      // const final_max_high_low = highest - lowest;
      // console.log("final_max_h_l" , final_max_high_low)

      let maxhighlowDifference;

      if (final_max_high_low) {
        maxhighlowDifference = final_max_high_low;
      } else {
        maxhighlowDifference = "N/A";
      }

      if (a_minus_evalue[index] !== 0.0 && a_minus_evalue[index] !== -0.0) {
        if (!isNaN(final_max_high_low)) {
          // console.log("final_max_high_low" , final_max_high_low)
          sumOfAverages += final_max_high_low;
          // console.log("sumOfAverages single---------------->" , Math.round(finalavg*100))
          // console.log("sumOfAverages---------------->" , sumOfAverages)
          countOfAverages += 1;
        } else {
          // console.log("finalavg is NaN, skipping this value");
        }
      } else {
        if (!isNaN(final_max_high_low)) {
          sumOfAverages_flat0 += final_max_high_low;

          countOfAverages_flat0 += 1;
          // console.log(
          //   "sumOfAverages_flat0",
          //   sumOfAverages_flat0,
          //   countOfAverages_flat0
          // );
        }
      }
      //  console.log("maxhighlowDifference-----" , maxhighlowDifference)
      return { date, maxhighlowDifference };
    });
    // console.log("averageDifferencesArray2" ,averageDifferencesArray2)

    // console.log("sumOfAverages========>", sumOfAverages)
    // console.log("countOfAverages", countOfAverages)

    const overallAverage =
      countOfAverages > 0 ? sumOfAverages / countOfAverages : null;
    const overallAverage_flat0 =
      countOfAverages_flat0 > 0
        ? sumOfAverages_flat0 / countOfAverages_flat0
        : 0;

    // console.log("overallAverage" , overallAverage)
    // console.log("overallAverage_flat0", overallAverage_flat0);
    setMaxHighLow_3rdColumn(averageDifferencesArray2);
    setfinalAvg_ofmaxof5min(overallAverage);
    setfinalAvg_ofmaxof5min_flat0(overallAverage_flat0);
  };

  useEffect(() => {
    calculate_fiveminutemaxHighLow(
      usddata_5minadd,
      setmaxHighLow_usddata_3rdcol,
      setfinalAvg_ofmaxof5min_usd,
      setfinalAvg_ofmaxof5min_usd_flat0,
      eventHistory2,
      optionValue
    );
    calculate_fiveminutemaxHighLow(
      jpydata_5minadd,
      setmaxHighHighLow_jpydata_3rdcol,
      setfinalAvg_ofmaxof5min_jpy,
      setfinalAvg_ofmaxof5min_jpy_flat0,
      eventHistory2,
      optionValue
    );
    calculate_fiveminutemaxHighLow(
      gbpnzddata_5minadd,
      setmaxHighHighLow_nzddata_3rdcol,
      setfinalAvg_ofmaxof5min_nzd,
      setfinalAvg_ofmaxof5min_nzd_flat0,
      eventHistory2,
      optionValue
    );
    calculate_fiveminutemaxHighLow(
      eurgbpdata_5minadd,
      setmaxHighHighLow_eurdata_3rdcol,
      setfinalAvg_ofmaxof5min_eur,
      setfinalAvg_ofmaxof5min_eur_flat0,
      eventHistory2,
      optionValue
    );
    calculate_fiveminutemaxHighLow(
      gbpchfdata_5minadd,
      setmaxHighHighLow_chfdata_3rdcol,
      setfinalAvg_ofmaxof5min_chf,
      setfinalAvg_ofmaxof5min_chf_flat0,
      eventHistory2,
      optionValue
    );
    calculate_fiveminutemaxHighLow(
      gbpauddata_5minadd,
      setmaxHighHighLow_auddata_3rdcol,
      setfinalAvg_ofmaxof5min_aud,
      setfinalAvg_ofmaxof5min_aud_flat0,
      eventHistory2,
      optionValue
    );
    calculate_fiveminutemaxHighLow(
      gbpcaddata_5minadd,
      setmaxHighHighLow_caddata_3rdcol,
      setfinalAvg_ofmaxof5min_cad,
      setfinalAvg_ofmaxof5min_cad_flat0,
      eventHistory2,
      optionValue
    );
  }, [
    optionValue,
    handleOptionChange,
    eventHistory2,
    allEventHistory2,
    usddata_avg,
    jpydata_avg,
    gbpnzddata_avg,
    eurgbpdata_avg,
    gbpchfdata_avg,
    gbpauddata_avg,
    gbpcaddata_avg,
  ]);

  const renderTableRows_avg2 = (maxhighlowdata_table, date) => {
    const filteredData = maxhighlowdata_table.find(
      (item) => item.date === date
    );
    if (!filteredData) {
      return <div className="py-7 bg-gray-200">No Data</div>;
    }

    const formattedDifference =
      filteredData.maxhighlowDifference === "Last 5 min's data is missing"
        ? "Last 5 min's data is missing"
        : typeof filteredData.maxhighlowDifference === "number" &&
          !isNaN(filteredData.maxhighlowDifference)
        ? filteredData.maxhighlowDifference
        : "N/A";

    const isJPYData = maxhighlowdata_table === maxHighHighLow_jpydata_3rdcol;

    // console.log("formattedDifference" , formattedDifference.toFixed(3) * 1000)
    return (
      <div className={`py-6  h-[67px]`}>
        {formattedDifference === "Last 5 min's data is missing" ||
        formattedDifference === "N/A"
          ? "N/A"
          : isJPYData
          ? Math.round(formattedDifference.toFixed(3) * 1000)
          : Math.round(
              formattedDifference.toFixed(country === "JP" ? 3 : 5) *
                (country === "JP" ? 1000 : 100000)
            )}
      </div>
    );
  };

  const renderTableRows_avg_colorcode2 = (
    maxhighlowdata_table,
    date,
    comparisonValue
  ) => {
    // console.log("comparisonValue" , comparisonValue)
    const filteredData = maxhighlowdata_table.find(
      (item) => item.date === date
    );
    // console.log("filteredData" , filteredData)
    if (!filteredData) {
      return <div className="py-7 bg-gray-200">No Data</div>;
    }

    const formattedDifference =
      typeof filteredData.maxhighlowDifference === "number" &&
      !isNaN(filteredData.maxhighlowDifference)
        ? filteredData.maxhighlowDifference
        : "N/A";

    if (formattedDifference === "N/A" || isNaN(formattedDifference)) {
      return "bg-[#E5E7EB]";
    }

    const isJPYData = maxhighlowdata_table === maxHighHighLow_jpydata_3rdcol;

    const finalresultdata =
      formattedDifference === "N/A"
        ? "N/A"
        : isJPYData
        ? Math.round(formattedDifference.toFixed(3) * 1000)
        : Math.round(
            formattedDifference.toFixed(country === "JP" ? 3 : 5) *
              (country === "JP" ? 1000 : 100000)
          );
    // console.log("finalresultdata----->" , finalresultdata)

    const diffResult = finalresultdata / comparisonValue;

    return diffResult >= 1.5
      ? "bg-[#5de98e]" // Green
      : diffResult >= 1.2 && diffResult < 1.5
      ? "bg-[#f1d500]" // Yellow
      : "bg-[#ff8e8ef2]"; // Red
  };

  // <-----2nd table average of minues ------2nd block--->

  const calculate_valueMaxCloseOpen_2ndTable = (
    data_avg_NextMinutes,
    setmaxCloseOpen_3rdcol_2ndtable,
    setfinalAvg_ofmaxof5min_2ndtable,
    setfinalAvg_ofmaxof5min_flat0_2ndtable,
    eventHistory
  ) => {
    const a_minus_evalue = eventHistory.map((item) =>
      item.actual - item.estimate === 0 ||
      item.estimate === null ||
      item.estimate === ""
        ? item.actual - item.previous
        : item.actual - item.estimate
    );
    const a_minus_evalue_Sign = eventHistory.map((item) => {
  
        if (
          item.actual == null ||
          (item.estimate === null || item.estimate === "") && item.previous == null
        ) {
          return "N/A";
        }
        let val;
        if (item.estimate === null || item.estimate === "") {
          val = item.actual - item.previous;
        } else {
          val = item.actual - item.estimate;
        }

        if (val > 0) return "+";
        if (val < 0) return "-";
        if (val === 0 || val === -0) return null;
        return "N/A";
      });



    const groupedByDate = data_avg_NextMinutes.reduce((acc, entry) => {
      const entryDate = entry.date.split(".").reverse().join(".");
      if (!acc[entryDate]) {
        acc[entryDate] = [];
      }

      acc[entryDate].push(entry);
      return acc;
    }, {});

    const groupedByDateArray = Object.entries(groupedByDate);

    let sliced_entries;
    if (optionValue === "Last 6") {
      sliced_entries = groupedByDateArray.slice(0, 6);
    } else if (optionValue === "Last 12") {
      sliced_entries = groupedByDateArray.slice(0, 12);
    } else {
      sliced_entries = groupedByDateArray;
    }

    const slicedGroupedByDate = Object.fromEntries(sliced_entries);

 
    //  <-------- it will return empty data if dates r not matching or data is missed in eventhistory2 --------->
     let empty_count_2ndTable = 0;
      let NonzeroPositive_count_2ndTable = 0;
      let NonzeroNegative_count_2ndTable = 0;
      let FlatPositive_count_2ndTable = 0;
      let FlatNegative_count_2ndTable = 0;
    const result = eventHistory.map((event) => {
      const formattedEventDate = event.date;
      if (formattedEventDate in slicedGroupedByDate) {
        return {
          date: event.date,
          entries: (slicedGroupedByDate[formattedEventDate] || []).slice(0, 6),
        };
      } else {
        return {
          date: event.date,
          entries: [],
        };
      }
    });

    // console.log("result", result);

    const averageDifferencesArray2 = result.map((item, index) => {
      const { date, entries } = item;

      // console.log("entries", entries);

      let diff = "N/A";
      if (entries.length > 0) {
        const firstOpen = entries[0].Open;
        const lastClose = entries[entries.length - 1].Close;

        diff = lastClose - firstOpen;
      }

      // console.log("diff----->", diff);

      // console.log("diff----->" , diff)

      let final_max_OpenClose;

      let maxOpenCloseDifference;
      let sign;
      if (typeof diff === "number" && !isNaN(diff)) {
        sign = diff > 0 ? "+" : diff < 0 ? "-" : "";
        // console.log("sign", sign);
        maxOpenCloseDifference = sign;
      } else {
        maxOpenCloseDifference = "N/A";
        // console.log("hi");
      }
      // console.log("maxOpenCloseDifference" , maxOpenCloseDifference)

      

      if (sign === "") {
        empty_count_2ndTable++;
      }
      if (a_minus_evalue[index] !== 0 && a_minus_evalue[index] !== -0) {
        // non‐zero group
        if (
          (sign === "+" && a_minus_evalue[index] === "+") ||
          (sign === "-" && a_minus_evalue[index] === "-") ||
          (sign === "" && a_minus_evalue[index] === "+") ||
          (sign === "-" && a_minus_evalue[index] === "-")
        )
          NonzeroPositive_count_2ndTable++;
        else if (
          (sign === "+" && a_minus_evalue[index] === "-") ||
          (sign === "-" && a_minus_evalue[index] === "+")
        )
          NonzeroNegative_count_2ndTable++;
      } else if (
        (sign === "+" && a_minus_evalue[index] === "") ||
        (sign === "" && a_minus_evalue[index] === "")
      ) {
        FlatPositive_count_2ndTable++;
      } else if (sign === "" && a_minus_evalue[index] === "-") {
        FlatNegative_count_2ndTable++;
      } else {
        NonzeroPositive_count_2ndTable++;
      }   
      return {
        date,
        maxOpenCloseDifference
      };
    });
    // console.log("averageDifferencesArray2", averageDifferencesArray2);
    // console.log("NonzeroPositive_count_2ndTable" , NonzeroPositive_count_2ndTable)
    // console.log("NonzeroNegative_count_2ndTable" , NonzeroNegative_count_2ndTable)
    // console.log("FlatPositive_count_2ndTable" , FlatPositive_count_2ndTable)
    // console.log("FlatNegative_count_2ndTable" , FlatNegative_count_2ndTable)


    // console.log("overallAverage_flat0", overallAverage_flat0);
    setmaxCloseOpen_3rdcol_2ndtable(averageDifferencesArray2);
    // setfinalAvg_ofmaxof5min_2ndtable(overallAverage);
    // setfinalAvg_ofmaxof5min_flat0_2ndtable(overallAverage_flat0);
  };

  useEffect(() => {
    calculate_valueMaxCloseOpen_2ndTable(
      usddata_5minadd_2ndtable,
      setmaxHighLow_usddata_3rdcol_2ndtable,
      setfinalAvg_ofmaxof5min_usd,
      setfinalAvg_ofmaxof5min_usd_flat0,
      eventHistory,
      optionValue
    );
    calculate_valueMaxCloseOpen_2ndTable(
      jpydata_5minadd_2ndtable,
      setmaxCloseOpen_jpydata_3rdcol_2ndtable,
      setfinalAvg_ofmaxof5min_jpy,
      setfinalAvg_ofmaxof5min_jpy_flat0,
      eventHistory,
      optionValue
    );
    calculate_valueMaxCloseOpen_2ndTable(
      gbpnzddata_5minadd_2ndtable,
      setmaxCloseOpen_nzddata_3rdcol_2ndtable,
      setfinalAvg_ofmaxof5min_nzd,
      setfinalAvg_ofmaxof5min_nzd_flat0,
      eventHistory,
      optionValue
    );
    calculate_valueMaxCloseOpen_2ndTable(
      eurgbpdata_5minadd_2ndtable,
      setmaxCloseOpen_eurdata_3rdcol_2ndtable,
      setfinalAvg_ofmaxof5min_eur,
      setfinalAvg_ofmaxof5min_eur_flat0,
      eventHistory,
      optionValue
    );
    calculate_valueMaxCloseOpen_2ndTable(
      gbpchfdata_5minadd_2ndtable,
      setmaxCloseOpen_chfdata_3rdcol_2ndtable,
      setfinalAvg_ofmaxof5min_chf,
      setfinalAvg_ofmaxof5min_chf_flat0,
      eventHistory,
      optionValue
    );
    calculate_valueMaxCloseOpen_2ndTable(
      gbpauddata_5minadd_2ndtable,
      setmaxCloseOpen_auddata_3rdcol_2ndtable,
      setfinalAvg_ofmaxof5min_aud,
      setfinalAvg_ofmaxof5min_aud_flat0,
      eventHistory,
      optionValue
    );
    calculate_valueMaxCloseOpen_2ndTable(
      gbpcaddata_5minadd_2ndtable,
      setmaxCloseOpen_caddata_3rdcol_2ndtable,
      setfinalAvg_ofmaxof5min_cad,
      setfinalAvg_ofmaxof5min_cad_flat0,
      eventHistory,
      optionValue
    );
  }, [
    optionValue,
    handleOptionChange,
    eventHistory,
    allEventHistory,
    usddata,
    jpydata,
    gbpnzddata,
    eurgbpdata,
    gbpchfdata,
    gbpauddata,
    gbpcaddata,
  ]);

  const renderTableRows_avg2_2ndTable = (dataArray, date) => {
    // find the record for this date
    const record = dataArray?.find((item) => item.date === date);
    if (!record) {
      return <div className="py-7 bg-gray-200">No Data</div>;
    }

    const sign = record.maxOpenCloseDifference;
    // sign is "+" | "-" | "" | "N/A"

    // handle the "no data" case
    if (sign === "N/A") {
      return <div className="py-6 h-[67px]">N/A</div>;
    }

    // otherwise, just render the sign (or blank)
    return <div className="py-6 h-[67px]">{sign}</div>;
  };

  const renderTableRows_avg_colorcode2_2ndTable = (dataArray, date) => {
    // find the record for this date
    const record = dataArray?.find((item) => item.date === date);
    if (!record) {
      return "bg-[#E5E7EB]";
    }

    const val = record.maxOpenCloseDifference;

    if (val === "") {
      return "bg-[#f1d500]";
    }
    if (val === "-") {
      return "bg-[#ff8e8ef2]";
    }
    if (val === "+") {
      return "bg-[#5de98e]";
    }

    return "bg-[#E5E7EB]";
  };

  // const renderTableRows_avg2_2ndTable = (maxOpenCloseDifference, date) => {
  //   const filteredData = maxOpenCloseDifference.find(
  //     (item) => item.date === date
  //   );
  //   if (!filteredData) {
  //     return <div className="py-7 bg-gray-200">No Data</div>;
  //   }

  //   const formattedDifference =
  //     filteredData.maxOpenCloseDifference === "Last 5 min's data is missing"
  //       ? "Last 5 min's data is missing"
  //       : typeof filteredData.maxOpenCloseDifference === "number" &&
  //         !isNaN(filteredData.maxOpenCloseDifference)
  //       ? filteredData.maxOpenCloseDifference
  //       : "N/A";

  //   const isJPYData = maxOpenCloseDifference === maxHighHighLow_jpydata_3rdcol;

  //   return (
  //     <div className={`py-6  h-[67px]`}>
  //       {formattedDifference === "Last 5 min's data is missing" ||
  //       formattedDifference === "N/A"
  //         ? "N/A"
  //         : isJPYData
  //         ? Math.round(formattedDifference.toFixed(3) * 1000)
  //         : Math.round(
  //             formattedDifference.toFixed(country === "JP" ? 3 : 5) *
  //               (country === "JP" ? 1000 : 100000)
  //           )}
  //     </div>
  //   );
  // };

  // const renderTableRows_avg_colorcode2_2ndTable = (
  //   maxhighlowdata_table,
  //   date,
  //   comparisonValue
  // ) => {
  //   // console.log("comparisonValue" , comparisonValue)
  //   const filteredData = maxhighlowdata_table.find(
  //     (item) => item.date === date
  //   );
  //   // console.log("filteredData" , filteredData)
  //   if (!filteredData) {
  //     return <div className="py-7 bg-gray-200">No Data</div>;
  //   }

  //   const formattedDifference =
  //     typeof filteredData.maxhighlowDifference === "number" &&
  //     !isNaN(filteredData.maxhighlowDifference)
  //       ? filteredData.maxhighlowDifference
  //       : "N/A";

  //   if (formattedDifference === "N/A" || isNaN(formattedDifference)) {
  //     return "bg-[#E5E7EB]";
  //   }

  //   const isJPYData = maxhighlowdata_table === maxHighHighLow_jpydata_3rdcol;

  //   const finalresultdata =
  //     formattedDifference === "N/A"
  //       ? "N/A"
  //       : isJPYData
  //       ? Math.round(formattedDifference.toFixed(3) * 1000)
  //       : Math.round(
  //           formattedDifference.toFixed(country === "JP" ? 3 : 5) *
  //             (country === "JP" ? 1000 : 100000)
  //         );
  //   // console.log("finalresultdata----->" , finalresultdata)

  //   const diffResult = finalresultdata / comparisonValue;

  //   return diffResult >= 1.5
  //     ? "bg-[#5de98e]" // Green
  //     : diffResult >= 1.2 && diffResult < 1.5
  //     ? "bg-[#f1d500]" // Yellow
  //     : "bg-[#ff8e8ef2]"; // Red
  // };

  // <-----2nd table average of minues ------2nd block--->
  // <----------------calculate the highest of average of third table---------------->

  // <------------hl------------>
  const avgdatagbpusdhl =
    averagegbpusddiff1_thirdtable !== null
      ? averagegbpusddiff1_thirdtable.toFixed(2)
      : "N/A";
  const avgdatagbpjpyhl =
    averagegbpjpydiff1_thirdtable !== null
      ? averagegbpjpydiff1_thirdtable.toFixed(2)
      : "N/A";
  const avgdatagbpnzdhl =
    averagegbpnzddiff1_thirdtable !== null
      ? averagegbpnzddiff1_thirdtable.toFixed(2)
      : "N/A";
  const avgdatagbpeurhl =
    averagegbpeurdiff1_thirdtable !== null
      ? averagegbpeurdiff1_thirdtable.toFixed(2)
      : "N/A";
  const avgdatagbpchfhl =
    averagegbpchfdiff1_thirdtable !== null
      ? averagegbpchfdiff1_thirdtable.toFixed(2)
      : "N/A";
  const avgdatagbpaudhl =
    averagegbpauddiff1_thirdtable !== null
      ? averagegbpauddiff1_thirdtable.toFixed(2)
      : "N/A";
  const avgdatagbpcadhl =
    averagegbpcaddiff1_thirdtable !== null
      ? averagegbpcaddiff1_thirdtable.toFixed(2)
      : "N/A";
  // console.log("avgdatagbpcadhl" ,avgdatagbpcadhl)
  const values4 = [
    avgdatagbpusdhl,
    avgdatagbpjpyhl,
    avgdatagbpnzdhl,
    avgdatagbpeurhl,
    avgdatagbpchfhl,
    avgdatagbpaudhl,
    avgdatagbpcadhl,
  ];

  values4.sort((a, b) => b - a);
  let highest1hl_thirdtable = values4[0];
  let highest2hl_thirdtable = values4[1];
  let highest3hl_thirdtable = values4[2];

  // console.log("high" , highest1hl_thirdtable , highest2hl_thirdtable , highest3hl_thirdtable)

  // <---------------------now , find the highest  of averges of third table of variance (color coding)----------->
  const avgdatagbpusdhl_last5min =
    avg_ofthirdtable_usd !== null ? Math.round(avg_ofthirdtable_usd) : "N/A";
  const avgdatagbpjpyhl_last5min =
    avg_ofthirdtable_jpy !== null ? Math.round(avg_ofthirdtable_jpy) : "N/A";
  const avgdatagbpnzdhl_last5min =
    avg_ofthirdtable_nzd !== null ? Math.round(avg_ofthirdtable_nzd) : "N/A";
  const avgdatagbpeurhl_last5min =
    avg_ofthirdtable_eur !== null ? Math.round(avg_ofthirdtable_eur) : "N/A";
  const avgdatagbpchfhl_last5min =
    avg_ofthirdtable_chf !== null ? Math.round(avg_ofthirdtable_chf) : "N/A";
  const avgdatagbpaudhl_last5min =
    avg_ofthirdtable_aud !== null ? Math.round(avg_ofthirdtable_aud) : "N/A";
  const avgdatagbpcadhl_last5min =
    avg_ofthirdtable_cad !== null ? Math.round(avg_ofthirdtable_cad) : "N/A";

  const values5 = [
    parseFloat(avgdatagbpusdhl_last5min),
    parseFloat(avgdatagbpjpyhl_last5min),
    parseFloat(avgdatagbpnzdhl_last5min),
    parseFloat(avgdatagbpeurhl_last5min),
    parseFloat(avgdatagbpchfhl_last5min),
    parseFloat(avgdatagbpaudhl_last5min),
    parseFloat(avgdatagbpcadhl_last5min),
  ];

  const Nonzero = values5
    .filter((value) => value !== 0 || (value !== 0.0 && !isNaN(value)))
    .sort((a, b) => b - a);
  let highest1hl_thirdtable_last5min =
    Nonzero[0] !== undefined ? Nonzero[0] + "%" : "N/A";
  let highest2hl_thirdtable_last5min =
    Nonzero[1] !== undefined ? Nonzero[1] + "%" : "N/A";
  let highest3hl_thirdtable_last5min =
    Nonzero[2] !== undefined ? Nonzero[2] + "%" : "N/A";

  // <------------hl flat avg highest normal (last portion)------------>
  const avgdatagbpusdhl_flat0 =
    averagegbpusddiff1_flat0_thirdtable !== null
      ? averagegbpusddiff1_flat0_thirdtable.toFixed(2)
      : "N/A";
  const avgdatagbpjpyhl_flat0 =
    averagegbpjpydiff1_flat0_thirdtable !== null
      ? averagegbpjpydiff1_flat0_thirdtable.toFixed(2)
      : "N/A";
  const avgdatagbpnzdhl_flat0 =
    averagegbpnzddiff1_flat0_thirdtable !== null
      ? averagegbpnzddiff1_flat0_thirdtable.toFixed(2)
      : "N/A";
  const avgdatagbpeurhl_flat0 =
    averagegbpeurdiff1_flat0_thirdtable !== null
      ? averagegbpeurdiff1_flat0_thirdtable.toFixed(2)
      : "N/A";
  const avgdatagbpchfhl_flat0 =
    averagegbpchfdiff1_flat0_thirdtable !== null
      ? averagegbpchfdiff1_flat0_thirdtable.toFixed(2)
      : "N/A";
  const avgdatagbpaudhl_flat0 =
    averagegbpauddiff1_flat0_thirdtable !== null
      ? averagegbpauddiff1_flat0_thirdtable.toFixed(2)
      : "N/A";
  const avgdatagbpcadhl_flat0 =
    averagegbpcaddiff1_flat0_thirdtable !== null
      ? averagegbpcaddiff1_flat0_thirdtable.toFixed(2)
      : "N/A";
  // console.log("avgdatagbpcadhl" ,avgdatagbpcadhl)
  const values4_flat0 = [
    avgdatagbpusdhl_flat0,
    avgdatagbpjpyhl_flat0,
    avgdatagbpnzdhl_flat0,
    avgdatagbpeurhl_flat0,
    avgdatagbpchfhl_flat0,
    avgdatagbpaudhl_flat0,
    avgdatagbpcadhl_flat0,
  ];

  const data_values4_flat0 = values4_flat0
    .filter((value) => value !== 0.0 || (value !== 0 && !isNaN(value)))
    .sort((a, b) => b - a);
  let highest1hl_thirdtable_flat0 =
    data_values4_flat0[0] !== undefined ? data_values4_flat0[0] : "N/A";
  let highest2hl_thirdtable_flat0 =
    data_values4_flat0[1] !== undefined ? data_values4_flat0[1] : "N/A";
  let highest3hl_thirdtable_flat0 =
    data_values4_flat0[2] !== undefined ? data_values4_flat0[2] : "N/A";

  // console.log(
  //   "highet",
  //   highest1hl_thirdtable_flat0,
  //   highest2hl_thirdtable_flat0,
  //   highest3hl_thirdtable_flat0
  // );

  // <------------hl flat avg highest (variance) (first portion)------------>
  const avgdatagbpusdhl_last5min_flat0 =
    avg_ofthirdtable_usd_flat0 !== null
      ? Math.round(avg_ofthirdtable_usd_flat0)
      : "N/A";
  const avgdatagbpjpyhl_last5min_flat0 =
    avg_ofthirdtable_jpy_flat0 !== null
      ? Math.round(avg_ofthirdtable_jpy_flat0)
      : "N/A";
  const avgdatagbpnzdhl_last5min_flat0 =
    avg_ofthirdtable_nzd_flat0 !== null
      ? Math.round(avg_ofthirdtable_nzd_flat0)
      : "N/A";
  const avgdatagbpeurhl_last5min_flat0 =
    avg_ofthirdtable_eur_flat0 !== null
      ? Math.round(avg_ofthirdtable_eur_flat0)
      : "N/A";
  const avgdatagbpchfhl_last5min_flat0 =
    avg_ofthirdtable_chf_flat0 !== null
      ? Math.round(avg_ofthirdtable_chf_flat0)
      : "N/A";
  const avgdatagbpaudhl_last5min_flat0 =
    avg_ofthirdtable_aud_flat0 !== null
      ? Math.round(avg_ofthirdtable_aud_flat0)
      : "N/A";
  const avgdatagbpcadhl_last5min_flat0 =
    avg_ofthirdtable_cad_flat0 !== null
      ? Math.round(avg_ofthirdtable_cad_flat0)
      : "N/A";

  const values5_third_last5min_flat0 = [
    parseFloat(avgdatagbpusdhl_last5min_flat0),
    parseFloat(avgdatagbpjpyhl_last5min_flat0),
    parseFloat(avgdatagbpnzdhl_last5min_flat0),
    parseFloat(avgdatagbpeurhl_last5min_flat0),
    parseFloat(avgdatagbpchfhl_last5min_flat0),
    parseFloat(avgdatagbpaudhl_last5min_flat0),
    parseFloat(avgdatagbpcadhl_last5min_flat0),
  ];

  const ZeroValues = values5_third_last5min_flat0
    .filter((value) => value !== 0 && !isNaN(value))
    .sort((a, b) => b - a);

  let highest1hl_thirdtable_last5min_flat0 =
    ZeroValues[0] !== undefined ? ZeroValues[0] + "%" : "N/A";
  let highest2hl_thirdtable_last5min_flat0 =
    ZeroValues[1] !== undefined ? ZeroValues[1] + "%" : "N/A";
  let highest3hl_thirdtable_last5min_flat0 =
    ZeroValues[2] !== undefined ? ZeroValues[2] + "%" : "N/A";

  // <-------- aashima last box highest calculation 1st table ----------->
  const finalAvg_ofmaxof5mingbpusdhl_future5min =
    finalAvg_ofmaxof5min_usd !== null ? finalAvg_ofmaxof5min_usd : "N/A";
  const finalAvg_ofmaxof5mingbpjpyhl_future5min =
    finalAvg_ofmaxof5min_jpy !== null ? finalAvg_ofmaxof5min_jpy : "N/A";
  const finalAvg_ofmaxof5mingbpnzdhl_future5min =
    finalAvg_ofmaxof5min_nzd !== null ? finalAvg_ofmaxof5min_nzd : "N/A";
  const finalAvg_ofmaxof5mingbpeurhl_future5min =
    finalAvg_ofmaxof5min_eur !== null ? finalAvg_ofmaxof5min_eur : "N/A";
  const finalAvg_ofmaxof5mingbpchfhl_future5min =
    finalAvg_ofmaxof5min_chf !== null ? finalAvg_ofmaxof5min_chf : "N/A";
  const finalAvg_ofmaxof5mingbpaudhl_future5min =
    finalAvg_ofmaxof5min_aud !== null ? finalAvg_ofmaxof5min_aud : "N/A";
  const finalAvg_ofmaxof5mingbpcadhl_future5min =
    finalAvg_ofmaxof5min_cad !== null ? finalAvg_ofmaxof5min_cad : "N/A";

  const values5_future5min = [
    parseFloat(finalAvg_ofmaxof5mingbpusdhl_future5min),
    parseFloat(finalAvg_ofmaxof5mingbpjpyhl_future5min),
    parseFloat(finalAvg_ofmaxof5mingbpnzdhl_future5min),
    parseFloat(finalAvg_ofmaxof5mingbpeurhl_future5min),
    parseFloat(finalAvg_ofmaxof5mingbpchfhl_future5min),
    parseFloat(finalAvg_ofmaxof5mingbpaudhl_future5min),
    parseFloat(finalAvg_ofmaxof5mingbpcadhl_future5min),
  ];

  values5_future5min.sort((a, b) => b - a);
  let highest1hl_thirdtable_future5min = values5_future5min[0] + "%";
  let highest2hl_thirdtable_future5min = values5_future5min[1] + "%";
  let highest3hl_thirdtable_future5min = values5_future5min[2] + "%";

  const finalAvg_ofmaxof5mingbpusdhl_future5min_flat0 =
    finalAvg_ofmaxof5min_usd_flat0 !== null
      ? finalAvg_ofmaxof5min_usd_flat0
      : "N/A";
  const finalAvg_ofmaxof5mingbpjpyhl_future5min_flat0 =
    finalAvg_ofmaxof5min_jpy_flat0 !== null
      ? finalAvg_ofmaxof5min_jpy_flat0
      : "N/A";
  const finalAvg_ofmaxof5mingbpnzdhl_future5min_flat0 =
    finalAvg_ofmaxof5min_nzd_flat0 !== null
      ? finalAvg_ofmaxof5min_nzd_flat0
      : "N/A";
  const finalAvg_ofmaxof5mingbpeurhl_future5min_flat0 =
    finalAvg_ofmaxof5min_eur_flat0 !== null
      ? finalAvg_ofmaxof5min_eur_flat0
      : "N/A";
  const finalAvg_ofmaxof5mingbpchfhl_future5min_flat0 =
    finalAvg_ofmaxof5min_chf_flat0 !== null
      ? finalAvg_ofmaxof5min_chf_flat0
      : "N/A";
  const finalAvg_ofmaxof5mingbpaudhl_future5min_flat0 =
    finalAvg_ofmaxof5min_aud_flat0 !== null
      ? finalAvg_ofmaxof5min_aud_flat0
      : "N/A";
  const finalAvg_ofmaxof5mingbpcadhl_future5min_flat0 =
    finalAvg_ofmaxof5min_cad_flat0 !== null
      ? finalAvg_ofmaxof5min_cad_flat0
      : "N/A";

  const values5_third_future5min_flat0 = [
    parseFloat(finalAvg_ofmaxof5mingbpusdhl_future5min_flat0),
    parseFloat(finalAvg_ofmaxof5mingbpjpyhl_future5min_flat0),
    parseFloat(finalAvg_ofmaxof5mingbpnzdhl_future5min_flat0),
    parseFloat(finalAvg_ofmaxof5mingbpeurhl_future5min_flat0),
    parseFloat(finalAvg_ofmaxof5mingbpchfhl_future5min_flat0),
    parseFloat(finalAvg_ofmaxof5mingbpaudhl_future5min_flat0),
    parseFloat(finalAvg_ofmaxof5mingbpcadhl_future5min_flat0),
  ];

  const data_values5_third_future5min_flat0 = values5_third_future5min_flat0
    .filter((value) => value !== 0 && !isNaN(value))
    .sort((a, b) => b - a);
  let highest1hl_thirdtable_future5min_flat0 =
    data_values5_third_future5min_flat0[0] !== undefined
      ? data_values5_third_future5min_flat0[0] + "%"
      : "N/A";
  let highest2hl_thirdtable_future5min_flat0 =
    data_values5_third_future5min_flat0[1] !== undefined
      ? data_values5_third_future5min_flat0[1] + "%"
      : "N/A";
  let highest3hl_thirdtable_future5min_flat0 =
    data_values5_third_future5min_flat0[2] !== undefined
      ? data_values5_third_future5min_flat0[2] + "%"
      : "N/A";
  // console.log("highest1h" , highest1hl_thirdtable_last5min_flat0 , highest2hl_thirdtable_last5min_flat0 , highest3hl_thirdtable_last5min_flat0)

  return (
    <>
      {eventHistory2.length > 0 && !Loading ? (
        <div className="">
          <UserNavbar />

          <div className={` mx-auto  flex justify-center items-center w-full`}>
            <div
              className={`${styles.eventpage} flex flex-col mx-auto mt-[20%] sm:mt-[20%] md:mt-[10%] lg:mt-[8%] xl:mt-[3%] bg-[#fff]  rounded-[18px] justify-center items-start md:items-center`}
            >
              <div
                className={`  ${styles.eventpage} flex flex-col sm:flex-col md:flex-col lg:flex-col xl:flex-row px-[2%] pb-[1%] pt-[3%] `}
              >
                <div className=" font-bold flex text-[15px]  sm:text-[15px] md:text-[18px] text-[#5829A9] w-[363px]">
                  {" "}
                  <span className="font-medium flex px-1 text-[#240D3A] pr-2 w-[113px]">
                    <img
                      src={eventicon}
                      alt="eventicon"
                      className="h-[20px] w-[20px] mr-2 mt-1 "
                    />{" "}
                    Event :
                  </span>
                  <span className="md:w-[300px] mr-[3%] "> {event}</span>{" "}
                </div>
                <div className="text-[15px] sm:text-[15px] md:text-[18px] font-bold text-[#5829A9] md:w-[200px]  flex ml-0 sm:ml-0 md:ml-0 lg:ml-0 xl:ml-[0%]">
                  <span className="font-medium flex px-1 text-[#240D3A]">
                    <img
                      src={locationicon}
                      alt="locationicon"
                      className="h-[20px] w-[20px] mr-2 mt-1 font-bold "
                    />{" "}
                    Country :
                  </span>{" "}
                  {country}{" "}
                </div>
                <div className="flex text-[15px] sm:text-[15px] md:text-[18px] font-semibold flex-col sm:flex-col md:flex-row lg:flex-row xl:flex-row">
                  <div className="w-[200px] font-bold flex text-[#5829A9] ">
                    <span className="font-medium flex px-1 text-[#240D3A]">
                      <img
                        src={dateicon}
                        alt="dateicon"
                        className="h-[20px] w-[20px] mr-2 mt-1 "
                      />
                      Date :{" "}
                    </span>{" "}
                    {date}{" "}
                  </div>{" "}
                  <div className="text-[#5829A9] ml-0 lg:ml-10 font-bold md:w-[300px] flex">
                    <span className="font-medium flex px-1 text-[#240D3A]">
                      <img
                        src={timeicon}
                        alt="timeicon"
                        className="h-[20px] w-[20px] mr-2 mt-1 "
                      />
                      Time (GMT) :
                    </span>{" "}
                    {time.slice(0, 5)}{" "}
                  </div>
                </div>
                <div className="flex text-[15px] sm:text-[15px] md:text-[18px] font-semibold   ml-0 sm:ml-0 md:ml-0 lg:ml-0 xl:ml-[0%] xl:mr-[3%]">
                  {" "}
                  <div className="text-[#5829A9] ml-0 md:w-[180px] font-bold flex">
                    <span className="font-medium flex px-1 text-[#240D3A]">
                      <img
                        src={impacticon}
                        alt="impacticon"
                        className="h-[20px] w-[20px] mr-2 mt-1 "
                      />
                      Impact :
                    </span>
                    {impact}{" "}
                  </div>
                </div>

                <div className="text-[#5829A9]  font-bold flex text-[15px] sm:text-[15px] md:text-[18px]   md:w-[430px]  ml-0 sm:ml-0 md:ml-0 lg:ml-0 xl:ml-0">
                  {" "}
                  <span className="font-medium flex px-1 text-[#240D3A]">
                    {" "}
                    <img
                      src={frequencyicon}
                      alt="frequencyicon"
                      className="h-[20px] w-[20px] mr-2 mt-1 "
                    />
                    Average frequency of event release :
                  </span>{" "}
                  {frequency_date}
                </div>
              </div>
              <hr className="bg-[#A0A0A0] bg-opacity-[5%] h-1 w-full" />
              <div className=" flex flex-col text-[15px] sm:text-[15px] md:text-[18px] text-[#240d3a] py-[1%] px-[8%] md:px-0 lg:px-[1%] xl:px-[2%] w-full text-center justify-center items-start md:items-start">
                <h1 className="font-bold text-start my-1">
                  Event count on
                  <span className="font-semibold text-[#5829A9]">
                    {" "}
                    {date}
                  </span>{" "}
                  at{" "}
                  <span className="font-semibold text-[#5829A9]">
                    {time.slice(0, 5)}
                  </span>{" "}
                  :{" "}
                  <span className="ml-3 font-semibold">
                    {
                      clickeddate_Loading ? (
                        <span className="loader1 text-red-400">Loading...</span>
                      ) : // console.log("eventimpactontimespecificdate" , eventimpactontimespecificdate)
                      eventimpactontimespecificdate.every(
                          (item) => item === ""
                        ) ? (
                        "No data"
                      ) : (
                        eventimpactontimespecificdate || "No data"
                      )

                      // eventimpactontimespecificdate || "None"
                    }
                  </span>
                </h1>
                <h1 className="font-bold text-start my-1 w-[90%] ">
                  Event count on
                  <span className="font-semibold text-[#5829A9]">
                    {" "}
                    {date}{" "}
                  </span>{" "}
                  before{" "}
                  <span className="font-semibold text-[#5829A9]">
                    {" "}
                    {time.slice(0, 5)}{" "}
                  </span>{" "}
                  :{" "}
                  <span className="ml-3 font-semibold">
                    {
                      clickeddate_Loading ? (
                        <span className="loader1 text-red-400">Loading...</span>
                      ) : // console.log("eventimpactbeforetimespecificdate",  eventimpactbeforetimespecificdate)
                      eventimpactbeforetimespecificdate.every(
                          (item) => item === ""
                        ) ? (
                        "No data"
                      ) : (
                        eventimpactbeforetimespecificdate || "No data"
                      )
                      // eventimpactbeforetimespecificdate || "None"
                    }
                  </span>
                </h1>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-col md:flex-row lg:flex-row xl:flex-row justify-between mx-[3%] mt-[2%]">
            <div>
              <IoArrowBack
                className=" cursor-pointer mb-2"
                onClick={() => navigate("/user/economicdata")}
                title="Back Button"
              />
              <div className="relative block sm:block md:inline-block lg:inline-block xl:inline-block pr-3 mb-4 sm:mb-4 md:mb-4 lg:mb-0 xl:mb-0">
                <Space
                  style={{
                    width: "100%",
                    paddingTop: 0,
                    height: "46px",
                  }}
                  direction="vertical"
                >
                  <FormControl sx={{ width: 200, height: 46 }}>
                    <InputLabel id="range-select-label">
                      Select Range
                    </InputLabel>
                    <Select
                      labelId="range-select-label"
                      value={optionValue}
                      onChange={(e) => handleOptionChange(e.target.value)}
                      label="Events Range"
                      sx={{ height: 46 }}
                    >
                      <MenuItem value="Last 6">Last 6</MenuItem>
                      <MenuItem value="Last 12">Last 12</MenuItem>
                      <MenuItem value="Last 24">Last 24</MenuItem>
                    </Select>
                  </FormControl>
                </Space>
              </div>
              <div className="relative block sm:block md:inline-block lg:inline-block xl:inline-block pr-3 mb-4 sm:mb-4 md:mb-4 lg:mb-0 xl:mb-0">
                <Space
                  style={{
                    width: "100%",
                    paddingTop: 0,
                    height: "46px",
                  }}
                  direction="vertical"
                >
                  <FormControl sx={{ width: 200, height: 46 }}>
                    <InputLabel id="time-select-label">Select Time</InputLabel>
                    <Select
                      labelId="time-select-label"
                      value={clickedtimeButton}
                      onChange={(e) => handletimebtnclick(e.target.value)}
                      label="Select Time"
                      sx={{ height: 46 }}
                      disabled={
                        !off_minutebuttons1 &&
                        !off_minutebuttons2 &&
                        !off_minutebuttons3 &&
                        !off_minutebuttons4
                      } // Disable if all buttons are off
                    >
                      <MenuItem value="1min" disabled={!off_minutebuttons1}>
                        1 min
                      </MenuItem>
                      <MenuItem value="2min" disabled={!off_minutebuttons2}>
                        2 min
                      </MenuItem>
                      <MenuItem value="5min" disabled={!off_minutebuttons3}>
                        5 min
                      </MenuItem>
                      <MenuItem value="15min" disabled={!off_minutebuttons4}>
                        15 min
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Space>
              </div>
            </div>
          </div>
          {/* <------------------first table which was 3rd--------------> */}

          <div className="m-3  py-2 px-3  mt-5 flex ">
            <div className="relative inline-block ml-[2%] ">
              {/* Icon */}
              {showTooltip && (
                <div className="fixed inset-0  backdrop-blur-[1px] z-10"></div>
              )}

              {/* Tooltip */}
              {showTooltip && (
                <div
                  ref={tooltipRef}
                  className="w-[256px] left-[180px] md:w-[514px] md:left-[460px] border-white rounded-[8px] bg-white absolute bottom-[155%]  transform -translate-x-1/2 z-30  text-[#240d3a] text-sm p-4  shadow-lg "
                >
                  <div className="bg-[#f7f7f7] p-3 flex text-center flex-col sm:flex-col md:flex-row">
                    <div className="text-center sm:flex-col flex-col md:flex-col lg:flex-col xl:flex-col flex mt-[5%] sm:mt-[5%] md:mt-[5%] lg:mt-[0%] xl:mt-[0%]">
                      <div>
                        <h1 className="font-bold text-[#240d3a] text-[18px] mt-3 mx-[4px]">
                          Summary Color Key :{" "}
                        </h1>
                      </div>
                      <div className="mt-2">
                        <div className="flex items-center my-2">
                          <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                            Highest Average:
                          </h1>
                          <img
                            src={color1}
                            title="color"
                            alt="color"
                            className="ml-4 w-[25px] h-[27px]"
                          />
                          {/* <span className="font-bold ml-2">,</span> */}
                        </div>
                        <div className="flex items-center my-2">
                          <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                            {" "}
                            2nd Highest Average:
                          </h1>
                          <img
                            src={color2}
                            title="color"
                            alt="color"
                            className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                          />
                          {/* <span className="font-bold ml-2">,</span> */}
                        </div>
                        <div className="flex items-center my-2">
                          <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                            {" "}
                            3rd Highest Average:
                          </h1>
                          <img
                            src={color3}
                            title="color"
                            alt="color"
                            className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                          />
                          {/* <span className="ml-[8px]">,</span> */}
                        </div>
                      </div>
                    </div>

                    <div className="text-center sm:flex-col flex-col md:flex-col lg:flex-col xl:flex-col flex mt-[5%] sm:mt-[5%] md:mt-[5%] lg:mt-[0%] xl:mt-[0%]">
                      <div>
                        <h1 className="font-bold text-[#240d3a] text-[18px] mt-3 mx-[4px]">
                          Table Color Key :{" "}
                        </h1>
                      </div>
                      <div className="mt-2">
                        <div className="flex items-center my-2">
                          <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                            {">500 % :"}
                          </h1>
                          <img
                            src={color4}
                            title="color"
                            alt="color"
                            className="ml-4 w-[25px] h-[27px]"
                          />
                          {/* <span className="font-bold ml-2">,</span> */}
                        </div>
                        <div className="flex items-center my-2">
                          <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                            {"300-500 % :"}
                          </h1>
                          <img
                            src={color5}
                            title="color"
                            alt="color"
                            className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                          />
                          {/* <span className="font-bold ml-2">,</span> */}
                        </div>
                        <div className="flex items-center my-2">
                          <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                            {"<300 % :"}
                          </h1>
                          <img
                            src={color6}
                            title="color"
                            alt="color"
                            className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                          />
                          {/* <span className="ml-[8px]">,</span> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Triangle Tip */}
                  <div className="absolute bottom-[-10px] left-[8%] transform -translate-x-1/2 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-white"></div>
                </div>
              )}
            </div>
            <h1 className="ml-[4px] font-bold text-[20px] text-[#240d3a]">
              Event Volatility Impact dd
            </h1>
            <img
              src={eye_btn_tooltip}
              title="Information of Volatility Correlation Table"
              alt="eye_btn_tooltip"
              className="w-[24px] h-[27px]  cursor-pointer pb-2"
              onClick={handleImageClick}
            />
            :
          </div>

          <div className="overflow-auto relative">
            {/* <div className="  mx-[3%] overflow-x-auto overflow-y-auto max-h-[103vh] "> */}
            <div
              className={`mx-[3%] overflow-x-auto overflow-y-auto relative${
                optionValue === "last 6"
                  ? "max-h-[103vh]"
                  : optionValue === "last 12"
                  ? "max-h-[165vh]"
                  : optionValue === "last 24"
                  ? "max-h-[300vh]"
                  : ""
              }`}
            >
              {/* {console.log("country" , country)} */}
              <table
                className={` ${styles.tableuser} min-w-full  overflow-x-scroll m-auto  font-semibold `}
              >
                <thead className="bg-[#D2C2F0]   text-[#240d3a]  sticky top-0 z-5 text-[14px] font-semibold border-b-[12px] border-solid border-[#F6F6F6] rounded-[8px]  z-[99]">
                  <tr>
                    <th
                      className="bg-[#5a2989] h-[79.96] min-h-[79.96] border-r-2 border-r-white "
                      colSpan={11}
                    ></th>

                    <th
                      className="text-[18px] bg-[#5a2989] h-[79.96] min-h-[79.96] border-r-2 border-r-white text-white"
                      colSpan={7}
                    >
                      {`Total points moved post release (High – Low , (1min))`}
                    </th>
                    <th
                      className="text-[18px] bg-[#5a2989] h-[79.96] min-h-[79.96] border-r-2 border-r-white text-white"
                      colSpan={11}
                    >
                      {`Total points moved post release (High – Low , ${timeclickedurl_state}min)`}
                    </th>
                  </tr>
                  <tr className="h-[96px]">
                    <th className="sticky top-0 py-2 px-2 min-w-[81px] w-[80px]">
                      S. No
                    </th>
                    <th className="sticky top-0 py-2 px-2 w-[73px]">Date</th>
                    <th className="sticky top-0 py-2 px-2 w-[91px]">
                      Time(GMT)
                    </th>
                    <th
                      className={`sticky top-0 py-2 px-2 w-[200px] min-w-[200px]`}
                    >
                      Event count before this time
                    </th>
                    <th className="sticky top-0 py-2 w-[150px] px-2 min-w-[150px]">
                      Event count at this time
                    </th>
                    <th className="sticky top-0 py-2 px-2 w-[77px]">
                      Previous
                    </th>
                    <th className="sticky top-0 py-2 px-2 w-[60px]">Actual</th>
                    <th className="sticky top-0 py-2 px-2 w-[77px]">
                      Estimate
                    </th>

                    <th className="sticky w-[97px] top-0 py-2 px-2  min-w-[99.33px]">
                      Act - Prev
                    </th>

                    <th className="z-[99] w-[98px] sticky top-0 py-2 px-2 border-r-[4px] border-[#F6F6F6]  min-w-[99.33px]">
                      Act - Est
                    </th>
                    <th className=" z-[99] w-[100px] sticky top-0 py-2 px-2 border-r-[4px] border-[#F6F6F6] bg-[#b38dd3] bg-opacity-[56%] ">
                      Final movement direction
                    </th>

                    {headers.map((header) => (
                      <th
                        key={header.id}
                        className="sticky top-0 py-2 px-2 bg-[#b38dd3] bg-opacity-[56%]  text-[#240d3a] "
                      >
                        {header.name}
                      </th>
                    ))}
                    {headers.map((header) => (
                      <th
                        key={header.id}
                        className="sticky top-0 py-2 px-2 bg-[#D2C2F0] bg-opacity-[56%]  text-[#240d3a] "
                      >
                        {header.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="bg-[#F6F6F6]  z-0 text-[#240d3a] font-bold text-[14px] relative">
                  {eventHistory2.map((item, index) => {
                    const itemDate = item.date.split(".").reverse().join(".");

                    // let itemTime;
                    let itemTime = item.time;
                    // if (selectedTime === 5) {
                    //   itemTime = roundDownToNearestMultipleOf5(item.time);
                    // } else if (selectedTime === 15) {
                    //   itemTime = roundDownToNearestMultipleOf15(item.time);
                    // } else if (selectedTime === 60) {
                    //   itemTime = roundDownToNearestMultipleOf1Hour(item.time);
                    // } else {
                    //   itemTime = item.time;
                    // }

                    const usdEntry_avg = usddata_avg.find((entry) => {
                      // console.log("entry.time", entry.time);
                      return entry.date === itemDate && entry.time === itemTime;
                    });
                    // console.log("usdEntry_avg", usdEntry_avg);

                    const jpyEntry_avg = jpydata_avg.find(
                      (entry) =>
                        entry.date === itemDate && entry.time === itemTime
                    );
                    const nzdEntry_avg = gbpnzddata_avg.find(
                      (entry) =>
                        entry.date === itemDate && entry.time === itemTime
                    );
                    const eurEntry_avg = eurgbpdata_avg.find(
                      (entry) =>
                        entry.date === itemDate && entry.time === itemTime
                    );
                    const chfEntry_avg = gbpchfdata_avg.find(
                      (entry) =>
                        entry.date === itemDate && entry.time === itemTime
                    );
                    const audEntry_avg = gbpauddata_avg.find(
                      (entry) =>
                        entry.date === itemDate && entry.time === itemTime
                    );
                    const cadEntry_avg = gbpcaddata_avg.find(
                      (entry) =>
                        entry.date === itemDate && entry.time === itemTime
                    );

                    const usdLow_avg = usdEntry_avg ? usdEntry_avg.Low : "N/A";
                    const usdHigh_avg = usdEntry_avg
                      ? usdEntry_avg.High
                      : "N/A";

                    const avg_diff =
                      usdLow_avg !== "N/A" && usdHigh_avg !== "N/A"
                        ? usdHigh_avg - usdLow_avg
                        : "N/A";
                    // console.log("avg_diff" , avg_diff)

                    const jpyLow_avg = jpyEntry_avg ? jpyEntry_avg.Low : "N/A";
                    const jpyHigh_avg = jpyEntry_avg
                      ? jpyEntry_avg.High
                      : "N/A";
                    const avg_jpydiff =
                      jpyLow_avg !== "N/A" && jpyHigh_avg !== "N/A"
                        ? jpyHigh_avg - jpyLow_avg
                        : "N/A";

                    const nzdLow_avg = nzdEntry_avg ? nzdEntry_avg.Low : "N/A";
                    const nzdHigh_avg = nzdEntry_avg
                      ? nzdEntry_avg.High
                      : "N/A";
                    const avg_diffnzdgbp =
                      nzdLow_avg !== "N/A" && nzdHigh_avg !== "N/A"
                        ? nzdHigh_avg - nzdLow_avg
                        : "N/A";

                    const eurLow_avg = eurEntry_avg ? eurEntry_avg.Low : "N/A";
                    const eurHigh_avg = eurEntry_avg
                      ? eurEntry_avg.High
                      : "N/A";
                    const avg_diffeurgbp =
                      eurLow_avg !== "N/A" && eurHigh_avg !== "N/A"
                        ? eurHigh_avg - eurLow_avg
                        : "N/A";

                    const chfLow_avg = chfEntry_avg ? chfEntry_avg.Low : "N/A";
                    const chfHigh_avg = chfEntry_avg
                      ? chfEntry_avg.High
                      : "N/A";
                    const avg_diffgbpchf =
                      chfLow_avg !== "N/A" && chfHigh_avg !== "N/A"
                        ? chfHigh_avg - chfLow_avg
                        : "N/A";

                    const audLow_avg = audEntry_avg ? audEntry_avg.Low : "N/A";
                    const audHigh_avg = audEntry_avg
                      ? audEntry_avg.High
                      : "N/A";

                    // console.log("audLow_avg" , audLow_avg)
                    // console.log("audHigh_avg" , audHigh_avg)
                    const avg_diffgbpaud =
                      audLow_avg !== "N/A" && audHigh_avg !== "N/A"
                        ? audHigh_avg - audLow_avg
                        : "N/A";

                    // console.log("avg_diffgbpaud" , avg_diffgbpaud)
                    const cadLow_avg = cadEntry_avg ? cadEntry_avg.Low : "N/A";
                    const cadHigh_avg = cadEntry_avg
                      ? cadEntry_avg.High
                      : "N/A";
                    const avg_diffgbpcad =
                      cadLow_avg !== "N/A" && cadHigh_avg !== "N/A"
                        ? cadHigh_avg - cadLow_avg
                        : "N/A";

                    // console.log("cadLow_avg" , cadLow_avg)
                    // console.log("cadHigh_avg" , cadHigh_avg)
                    // console.log("avg_diffgbpcad" , avg_diffgbpcad)

                    const itemDatecheck = item.date.split(" ")[0];

                    // Filtering impacthighlow array to find the matching data
                    const matchingData = impacthighlow.find((data) =>
                      data.startsWith(itemDatecheck)
                    );

                    const normalizeDate = (dateStr) => {
                      return dateStr.split(" ")[0];
                    };

                    const filterImpactData = (date) => {
                      const normalizedDate = normalizeDate(date);

                      return impacthighlowbeforethis.filter((impact) => {
                        const impactDate = impact.split(":")[0];

                        return impactDate === normalizedDate;
                      });
                    };

                    const impactData = filterImpactData(item.date);
                    return (
                      <>
                        <tr
                          key={index}
                          className=" cursor-pointer  text-center bg-white  border-y-[16px] border-solid border-[#F6F6F6] "
                        >
                          <td className="py-2 min-w-[81px]">{index + 1}.</td>
                          <td className="py-2 ">{item.date}</td>
                          <td className="py-2 ">{item.time.slice(0, 5)}</td>

                          {run_modalloader ? (
                            <td className="min-w-[200px] w-[200px]">
                              {" "}
                              <span className="loader1 text-[#1c72ca] text-center">
                                Loading...
                              </span>
                            </td>
                          ) : (
                            <>
                              <td
                                className="py-2  text-[13px] min-w-[200px] w-[200px] relative cursor-pointer"
                                onClick={() =>
                                  handleShowModalbeforetime(item.date)
                                }
                              >
                                {impactData.length > 0 ? (
                                  impactData.map((impact, i) => {
                                    const impactParts = impact.split(" ");
                                    // Remove the first element (date and time)
                                    const formattedImpact = impactParts
                                      .slice(1)
                                      .join(" ");

                                    return (
                                      <span key={i} className="font-bold block">
                                        {formattedImpact}
                                      </span>
                                    );
                                  })
                                ) : (
                                  <span className="font-bold">No Data</span>
                                )}
                              </td>

                              <dialog
                                id="my_modal_2"
                                onClick={() => {
                                  autoClickButton();
                                }}
                                className={` ${styles.addmodalDirection_eventhistory} modal p-2 sm:p-2 md:p-2 lg:p-6 xl:p-6 absolute max-h-[60vh]  top-[106%] sm:top-[106%] md:top-[106%] lg:top-[44%] xl:top-[44%]  bg-[f6f6f6] rounded-[8px] w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[80vw] xl:w-[29vw] `}
                              >
                                <form
                                  method="dialog"
                                  className="modal-  relative top-[-10px]  right-[-6px] text-right w-[80vw] sm:w-[80vw] md:w-[80vw] lg:w-[60vw] xl:w-[24vw]"
                                >
                                  <div className="modal-box relative top-[3px]">
                                    <div
                                      onClick={() => {
                                        autoClickButton();
                                      }}
                                    >
                                      <button id="aashima_id">
                                        <img
                                          alt="img"
                                          src={crossicon}
                                          className="w-[20px] h-[20px]"
                                        ></img>
                                      </button>
                                    </div>
                                    <div className="">
                                      {filteredModalData.length > 0 ? (
                                        <>
                                          {/* High Impact */}
                                          {filteredModalData.some(
                                            (data) =>
                                              data.impact.toLowerCase() ===
                                              "high"
                                          ) && (
                                            <div className="text-center flex items-center justify-center">
                                              <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4  w-[193px] text-[#240d3a]">
                                                High Impact :-
                                              </h3>
                                            </div>
                                          )}
                                          <div className="bg-white px-0 sm:px-0 md:px-[20px] py-[10px] rounded-[8px]">
                                            {filteredModalData.map(
                                              (data, index) => {
                                                if (
                                                  data.impact.toLowerCase() ===
                                                  "high"
                                                ) {
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="text-start pl-[20px] my-4"
                                                    >
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className=" flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={dateicon}
                                                            alt="dateicon"
                                                            className="h-[20px] w-[20px] mr-2  "
                                                          />
                                                          Date:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.date}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={timeicon}
                                                            alt="timeicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />
                                                          Time:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.time.slice(
                                                            0,
                                                            5
                                                          )}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={locationicon}
                                                            alt="locationicon"
                                                            className="h-[20px] w-[20px] mr-2 font-bold "
                                                          />{" "}
                                                          Country:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.country}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={eventicon}
                                                            alt="eventicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Event :{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.event}{" "}
                                                        </span>
                                                      </p>
                                                      <hr />
                                                    </div>
                                                  );
                                                }
                                                return null;
                                              }
                                            )}
                                          </div>

                                          {/* Medium Impact */}
                                          {filteredModalData.some(
                                            (data) =>
                                              data.impact.toLowerCase() ===
                                              "medium"
                                          ) && (
                                            <div className="text-center flex items-center justify-center">
                                              <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4 text-[#240d3a]">
                                                Medium Impact :-
                                              </h3>
                                            </div>
                                          )}
                                          <div className="bg-white px-0 sm:px-0 md:px-[20px] py-[10px] rounded-[8px]">
                                            {filteredModalData.map(
                                              (data, index) => {
                                                if (
                                                  data.impact.toLowerCase() ===
                                                  "medium"
                                                ) {
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="text-start pl-[20px] my-4"
                                                    >
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={dateicon}
                                                            alt="dateicon"
                                                            className="h-[20px] w-[20px] mr-2  "
                                                          />{" "}
                                                          Date:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.date}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={timeicon}
                                                            alt="timeicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Time:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.time.slice(
                                                            0,
                                                            5
                                                          )}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={locationicon}
                                                            alt="locationicon"
                                                            className="h-[20px] w-[20px] mr-2 font-bold "
                                                          />{" "}
                                                          Country:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.country}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={eventicon}
                                                            alt="eventicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Event:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.event}
                                                        </span>
                                                      </p>
                                                      <hr />
                                                    </div>
                                                  );
                                                }
                                                return null;
                                              }
                                            )}
                                          </div>
                                        </>
                                      ) : (
                                        <p className="text-center mt-4">
                                          No Data
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </form>
                              </dialog>
                            </>
                          )}

                          {run_modalloader ? (
                            <td>
                              <span className="loader1 text-[#1c72ca] text-center min-w-[150px] w-[150px]">
                                Loading...
                              </span>
                            </td>
                          ) : (
                            <>
                              {" "}
                              <td
                                className=" py-2 px-4  min-w-[140px] relative cursor-pointer"
                                onClick={() => handleShowModalontime(item.date)}
                              >
                                {matchingData && (
                                  <span className="font-bold text-[13px]">
                                    {matchingData.includes(": ")
                                      ? matchingData.substring(
                                          matchingData.indexOf(": ") + 2
                                        )
                                      : matchingData}
                                  </span>
                                )}
                              </td>
                              <dialog
                                id="my_modal_3"
                                onClick={() => {
                                  autoClickButton1();
                                }}
                                className={`  ${styles.addmodalDirection_eventhistory} modal p-6 absolute max-h-[60vh] top-[106%] sm:top-[106%] md:top-[106%] lg:top-[44%] xl:top-[44%]  bg-[f6f6f6] rounded-[8px] w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[80vw] xl:w-[29vw] `}
                              >
                                <form
                                  method="dialog"
                                  className="modal-  relative top-[-10px]  right-[-6px] text-right w-[80vw] sm:w-[80vw] md:w-[80vw] lg:w-[60vw] xl:w-[24vw]"
                                >
                                  <div className="modal-box relative top-[3px]">
                                    <div
                                      onClick={() => {
                                        autoClickButton1();
                                      }}
                                    >
                                      <button id="closemod11">
                                        <img
                                          alt="img"
                                          src={crossicon}
                                          className="w-[20px] h-[20px]"
                                        ></img>
                                      </button>
                                    </div>
                                    <div>
                                      {filteredModalDataontime.length > 0 ? (
                                        <>
                                          {/* High Impact */}
                                          {filteredModalDataontime.some(
                                            (data) =>
                                              data.impact.toLowerCase() ===
                                              "high"
                                          ) && (
                                            <div className="text-center flex items-center justify-center">
                                              <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4  w-[193px] text-[#240d3a]">
                                                High Impact :-
                                              </h3>
                                            </div>
                                          )}
                                          <div className="">
                                            {filteredModalDataontime.map(
                                              (data, index) => {
                                                if (
                                                  data.impact.toLowerCase() ===
                                                  "high"
                                                ) {
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="text-start pl-[20px] my-4"
                                                    >
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className=" flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={dateicon}
                                                            alt="dateicon"
                                                            className="h-[20px] w-[20px] mr-2  "
                                                          />
                                                          Date:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.date}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={timeicon}
                                                            alt="timeicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />
                                                          Time:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.time.slice(
                                                            0,
                                                            5
                                                          )}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={locationicon}
                                                            alt="locationicon"
                                                            className="h-[20px] w-[20px] mr-2 font-bold "
                                                          />{" "}
                                                          Country:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.country}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={eventicon}
                                                            alt="eventicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Event :{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.event}{" "}
                                                        </span>
                                                      </p>
                                                      <hr />
                                                    </div>
                                                  );
                                                }
                                                return null;
                                              }
                                            )}
                                          </div>

                                          {/* Medium Impact */}
                                          {filteredModalDataontime.some(
                                            (data) =>
                                              data.impact.toLowerCase() ===
                                              "medium"
                                          ) && (
                                            <div className="text-center flex items-center justify-center">
                                              <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4 text-[#240d3a]">
                                                Medium Impact :-
                                              </h3>
                                            </div>
                                          )}
                                          <div className="">
                                            {filteredModalDataontime.map(
                                              (data, index) => {
                                                if (
                                                  data.impact.toLowerCase() ===
                                                  "medium"
                                                ) {
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="text-start pl-[20px] my-4"
                                                    >
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={dateicon}
                                                            alt="dateicon"
                                                            className="h-[20px] w-[20px] mr-2  "
                                                          />{" "}
                                                          Date:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.date}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={timeicon}
                                                            alt="timeicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Time:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.time.slice(
                                                            0,
                                                            5
                                                          )}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={locationicon}
                                                            alt="locationicon"
                                                            className="h-[20px] w-[20px] mr-2 font-bold "
                                                          />{" "}
                                                          Country:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.country}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={eventicon}
                                                            alt="eventicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Event:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.event}
                                                        </span>
                                                      </p>
                                                      <hr />
                                                    </div>
                                                  );
                                                }
                                                return null;
                                              }
                                            )}
                                          </div>
                                        </>
                                      ) : (
                                        <p className="text-center mt-4">
                                          No Data
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </form>
                              </dialog>
                            </>
                          )}

                          <td className="py-2 ">{item.previous}</td>
                          <td className="py-2 ">{item.actual}</td>
                          <td className="py-2 ">{item.estimate}</td>

                          <td
                            className={`py-2  text-[#240d3a] font-bold  ${
                              item.previous === null || item.previous === ""
                                ? "bg-[#E5E7EB]" // N/A case:
                                : item.actual - item.previous > 0
                                ? "bg-[#5de98e]"
                                : item.actual - item.previous === 0
                                ? "bg-[#f1d500]"
                                : "bg-[#ff8e8ef2]"
                            }`}
                          >
                            {/* {(item.actual - item.previous).toFixed(4)} <br />(
                          {(
                            Math.abs(
                              (item.actual - item.previous) / item.previous
                            ) * 100
                          ).toFixed(4) + "%"}
                          ) */}

                            {item.previous === null || item.previous === "" ? (
                              "N/A"
                            ) : (
                              <>
                                {(
                                  Math.abs(
                                    (item.actual - item.previous) /
                                      item.previous
                                  ) * 100
                                ).toFixed(1) + "%"}
                                <br />(
                                {/* {(item.actual - item.previous).toFixed(1)}) */}
                                {item.actual !== null || item.previous !== null
                                  ? (
                                      (item.actual || 0) - (item.previous || 0)
                                    ).toFixed(
                                      item.actual?.toString().includes(".")
                                        ? item.actual.toString().split(".")[1]
                                            .length
                                        : item.previous
                                            ?.toString()
                                            ?.split(".")[1]?.length || 0
                                    )
                                  : ""}
                                )
                              </>
                            )}
                          </td>

                          <td
                            className={`py-2 border border-r-4 border-[#F6F6F6] text-[#240d3a] font-semibold  ${
                              item.estimate === null || item.estimate === ""
                                ? "bg-[#E5E7EB]" // N/A case:
                                : item.actual - item.estimate > 0
                                ? "bg-[#5de98e]"
                                : item.actual - item.estimate === 0
                                ? "bg-[#f1d500]"
                                : "bg-[#ff8e8ef2]"
                            }`}
                          >
                            {/* {(item.actual - item.estimate).toFixed(4)} <br />( */}
                            {item.estimate === null || item.estimate === "" ? (
                              "N/A"
                            ) : (
                              <>
                                {(
                                  Math.abs(
                                    (item.actual - item.estimate) /
                                      item.estimate
                                  ) * 100
                                ).toFixed(1) + "%"}
                                <br />(
                                {/* {(item.actual - item.estimate).toFixed(1)} */}
                                {item.actual !== null || item.estimate !== null
                                  ? (
                                      (item.actual || 0) - (item.estimate || 0)
                                    ).toFixed(
                                      item.actual?.toString().includes(".")
                                        ? item.actual.toString().split(".")[1]
                                            .length
                                        : item.estimate
                                            ?.toString()
                                            ?.split(".")[1]?.length || 0
                                    )
                                  : ""}
                                )
                              </>
                            )}
                            {/* {(
                            Math.abs(
                              (item.actual - item.estimate) / item.estimate
                            ) * 100
                          ).toFixed(4) + "%"}
                          ) */}
                          </td>

                          <td
                            className={`py-2 border border-r-4 border-[#F6F6F6] text-[#240d3a] font-semibold ${
                              item.actual - item.estimate === 0 ||
                              item.estimate === null ||
                              item.estimate === ""
                                ? item.actual - item.previous > 0
                                  ? "bg-[#5de98e]"
                                  : item.actual - item.previous === 0
                                  ? "bg-[#f1d500]"
                                  : "bg-[#ff8e8ef2]"
                                : item.actual - item.estimate > 0
                                ? "bg-[#5de98e]"
                                : item.actual - item.estimate === 0 ||
                                  item.estimate === null ||
                                  item.estimate === ""
                                ? "bg-[#f1d500]"
                                : "bg-[#ff8e8ef2]"
                            }`}
                          >
                            {(
                              Math.abs(
                                item.actual - item.estimate === 0 ||
                                  item.estimate === null ||
                                  item.estimate === ""
                                  ? (item.actual - item.previous) /
                                      item.previous
                                  : (item.actual - item.estimate) /
                                      item.estimate
                              ) * 100
                            ).toFixed(1) + "%"}
                            <br />(
                            {item.actual !== null ||
                            item.estimate !== null ||
                            item.previous !== null
                              ? (item.actual - item.estimate === 0 ||
                                item.estimate == null ||
                                item.estimate === ""
                                  ? (item.actual || 0) - (item.previous || 0)
                                  : (item.actual || 0) - (item.estimate || 0)
                                ).toFixed(
                                  item.actual?.toString().includes(".")
                                    ? item.actual.toString().split(".")[1]
                                        .length
                                    : item.estimate?.toString()?.split(".")[1]
                                        ?.length ||
                                        item.previous?.toString()?.split(".")[1]
                                          ?.length ||
                                        0
                                )
                              : ""}
                            )
                          </td>

                          {/* <--harsh> */}
                          {/* <---------------single H-L starts from here------------> */}
                          {country === "AU" ? (
                            <>
                              <td
                                className={` ${renderTableRows_avg_colorcode(
                                  averageHighLow_caddata,
                                  item.date
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {typeof avg_diffgbpcad === "number"
                                  ? Math.round(
                                      avg_diffgbpcad.toFixed(
                                        country === "JP" ? 3 : 5
                                      ) * (country === "JP" ? 1000 : 100000)
                                    )
                                  : avg_diffgbpcad}
                              </td>

                              <td
                                className={` ${renderTableRows_avg_colorcode(
                                  averageHighLow_chfdata,
                                  item.date
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {typeof avg_diffgbpchf === "number"
                                  ? Math.round(
                                      avg_diffgbpchf.toFixed(
                                        country === "JP" ? 3 : 5
                                      ) * (country === "JP" ? 1000 : 100000)
                                    )
                                  : avg_diffgbpchf}
                              </td>

                              <td
                                className={` ${renderTableRows_avg_colorcode(
                                  averageHighLow_eurdata,
                                  item.date
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {typeof avg_diffeurgbp === "number"
                                  ? Math.round(
                                      avg_diffeurgbp.toFixed(
                                        country === "JP" ? 3 : 5
                                      ) * (country === "JP" ? 1000 : 100000)
                                    )
                                  : avg_diffeurgbp}
                              </td>
                              <td
                                className={` ${renderTableRows_avg_colorcode(
                                  averageHighLow_auddata,
                                  item.date
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {typeof avg_diffgbpaud === "number"
                                  ? Math.round(
                                      avg_diffgbpaud.toFixed(
                                        country === "JP" ? 3 : 5
                                      ) * (country === "JP" ? 1000 : 100000)
                                    )
                                  : avg_diffgbpaud}
                              </td>

                              {country === "US" || country === "NZ" ? (
                                <>
                                  <td
                                    // className={`py-2  border border-[#ffffff] ${
                                    //   typeof avg_diffnzdgbp === "number"
                                    //     // ? avg_diffnzdgbp.toFixed(5) === "0.0000" ||
                                    //     //   avg_diffnzdgbp.toFixed(5) === "-0.0000"
                                    //      ? avg_diffnzdgbp.toFixed(country === "JP" ? 3 : 5) === "0.0000" ||
                                    //      avg_diffnzdgbp.toFixed(country === "JP" ? 3 : 5) === "-0.0000"
                                    //       ? "bg-[#f7dc14]"
                                    //       : typeof avg_diffnzdgbp === "number" &&
                                    //         avg_diffnzdgbp > 0
                                    //       ? "bg-[#7fe9a4]"
                                    //       : "bg-[#f3b2b2]"
                                    //     : "bg-[#E5E7EB]"
                                    // }`}
                                    className={` ${renderTableRows_avg_colorcode(
                                      averageHighLow_nzddata,
                                      item.date
                                    )} border-r-2 border-[#F6F6F6]  min-w-[91.95px]`}
                                  >
                                    {typeof avg_diffnzdgbp === "number"
                                      ? Math.round(
                                          avg_diffnzdgbp.toFixed(
                                            country === "JP" ? 3 : 5
                                          ) * (country === "JP" ? 1000 : 100000)
                                        )
                                      : avg_diffnzdgbp}
                                  </td>

                                  <td
                                    className={` ${renderTableRows_avg_colorcode(
                                      averageHighLow_jpydata,
                                      item.date
                                    )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {/* <-----------------JP is fixed here-------------> */}
                                    {typeof avg_jpydiff === "number"
                                      ? Math.round(
                                          avg_jpydiff.toFixed(3) * 1000
                                        )
                                      : // ? Math.round((avg_jpydiff.toFixed(country === "JP" ? 3 : 5))*(country === "JP" ? 1000 : 100000))
                                        avg_jpydiff}
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td
                                    className={` ${renderTableRows_avg_colorcode(
                                      averageHighLow_jpydata,
                                      item.date
                                    )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {/* <-----------------JP is fixed here-------------> */}
                                    {typeof avg_jpydiff === "number"
                                      ? Math.round(
                                          avg_jpydiff.toFixed(3) * 1000
                                        )
                                      : // ? Math.round((avg_jpydiff.toFixed(country === "JP" ? 3 : 5))*(country === "JP" ? 1000 : 100000))
                                        avg_jpydiff}
                                  </td>
                                  <td
                                    // className={`py-2  border border-[#ffffff] ${
                                    //   typeof avg_diffnzdgbp === "number"
                                    //     // ? avg_diffnzdgbp.toFixed(5) === "0.0000" ||
                                    //     //   avg_diffnzdgbp.toFixed(5) === "-0.0000"
                                    //      ? avg_diffnzdgbp.toFixed(country === "JP" ? 3 : 5) === "0.0000" ||
                                    //      avg_diffnzdgbp.toFixed(country === "JP" ? 3 : 5) === "-0.0000"
                                    //       ? "bg-[#f7dc14]"
                                    //       : typeof avg_diffnzdgbp === "number" &&
                                    //         avg_diffnzdgbp > 0
                                    //       ? "bg-[#7fe9a4]"
                                    //       : "bg-[#f3b2b2]"
                                    //     : "bg-[#E5E7EB]"
                                    // }`}
                                    className={` ${renderTableRows_avg_colorcode(
                                      averageHighLow_nzddata,
                                      item.date
                                    )} border-r-2 border-[#F6F6F6]  min-w-[91.95px]`}
                                  >
                                    {typeof avg_diffnzdgbp === "number"
                                      ? Math.round(
                                          avg_diffnzdgbp.toFixed(
                                            country === "JP" ? 3 : 5
                                          ) * (country === "JP" ? 1000 : 100000)
                                        )
                                      : avg_diffnzdgbp}
                                  </td>
                                </>
                              )}

                              <td
                                className={`${renderTableRows_avg_colorcode(
                                  averageHighLow_usddata,
                                  item.date
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {typeof avg_diff === "number"
                                  ? // ? Math.round(avg_diff.toFixed(3)*1000)
                                    Math.round(
                                      avg_diff.toFixed(
                                        country === "JP" ? 3 : 5
                                      ) * (country === "JP" ? 1000 : 100000)
                                    )
                                  : avg_diff}
                                {/* <br/>
                            { avg_diff.toFixed(5)} */}
                              </td>
                            </>
                          ) : (
                            <>
                              <td
                                className={` ${renderTableRows_avg_colorcode(
                                  averageHighLow_auddata,
                                  item.date
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {typeof avg_diffgbpaud === "number"
                                  ? Math.round(
                                      avg_diffgbpaud.toFixed(
                                        country === "JP" ? 3 : 5
                                      ) * (country === "JP" ? 1000 : 100000)
                                    )
                                  : avg_diffgbpaud}
                              </td>

                              <td
                                className={` ${renderTableRows_avg_colorcode(
                                  averageHighLow_caddata,
                                  item.date
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {typeof avg_diffgbpcad === "number"
                                  ? Math.round(
                                      avg_diffgbpcad.toFixed(
                                        country === "JP" ? 3 : 5
                                      ) * (country === "JP" ? 1000 : 100000)
                                    )
                                  : avg_diffgbpcad}
                              </td>

                              <td
                                className={` ${renderTableRows_avg_colorcode(
                                  averageHighLow_chfdata,
                                  item.date
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {typeof avg_diffgbpchf === "number"
                                  ? Math.round(
                                      avg_diffgbpchf.toFixed(
                                        country === "JP" ? 3 : 5
                                      ) * (country === "JP" ? 1000 : 100000)
                                    )
                                  : avg_diffgbpchf}
                              </td>

                              <td
                                className={` ${renderTableRows_avg_colorcode(
                                  averageHighLow_eurdata,
                                  item.date
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {typeof avg_diffeurgbp === "number"
                                  ? Math.round(
                                      avg_diffeurgbp.toFixed(
                                        country === "JP" ? 3 : 5
                                      ) * (country === "JP" ? 1000 : 100000)
                                    )
                                  : avg_diffeurgbp}
                              </td>

                              {country === "US" || country === "NZ" ? (
                                <>
                                  <td
                                    // className={`py-2  border border-[#ffffff] ${
                                    //   typeof avg_diffnzdgbp === "number"
                                    //     // ? avg_diffnzdgbp.toFixed(5) === "0.0000" ||
                                    //     //   avg_diffnzdgbp.toFixed(5) === "-0.0000"
                                    //      ? avg_diffnzdgbp.toFixed(country === "JP" ? 3 : 5) === "0.0000" ||
                                    //      avg_diffnzdgbp.toFixed(country === "JP" ? 3 : 5) === "-0.0000"
                                    //       ? "bg-[#f7dc14]"
                                    //       : typeof avg_diffnzdgbp === "number" &&
                                    //         avg_diffnzdgbp > 0
                                    //       ? "bg-[#7fe9a4]"
                                    //       : "bg-[#f3b2b2]"
                                    //     : "bg-[#E5E7EB]"
                                    // }`}
                                    className={` ${renderTableRows_avg_colorcode(
                                      averageHighLow_nzddata,
                                      item.date
                                    )} border-r-2 border-[#F6F6F6]  min-w-[91.95px]`}
                                  >
                                    {typeof avg_diffnzdgbp === "number"
                                      ? Math.round(
                                          avg_diffnzdgbp.toFixed(
                                            country === "JP" ? 3 : 5
                                          ) * (country === "JP" ? 1000 : 100000)
                                        )
                                      : avg_diffnzdgbp}
                                  </td>

                                  <td
                                    className={` ${renderTableRows_avg_colorcode(
                                      averageHighLow_jpydata,
                                      item.date
                                    )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {/* <-----------------JP is fixed here-------------> */}
                                    {typeof avg_jpydiff === "number"
                                      ? Math.round(
                                          avg_jpydiff.toFixed(3) * 1000
                                        )
                                      : // ? Math.round((avg_jpydiff.toFixed(country === "JP" ? 3 : 5))*(country === "JP" ? 1000 : 100000))
                                        avg_jpydiff}
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td
                                    className={` ${renderTableRows_avg_colorcode(
                                      averageHighLow_jpydata,
                                      item.date
                                    )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {/* <-----------------JP is fixed here-------------> */}
                                    {typeof avg_jpydiff === "number"
                                      ? Math.round(
                                          avg_jpydiff.toFixed(3) * 1000
                                        )
                                      : // ? Math.round((avg_jpydiff.toFixed(country === "JP" ? 3 : 5))*(country === "JP" ? 1000 : 100000))
                                        avg_jpydiff}
                                  </td>
                                  <td
                                    // className={`py-2  border border-[#ffffff] ${
                                    //   typeof avg_diffnzdgbp === "number"
                                    //     // ? avg_diffnzdgbp.toFixed(5) === "0.0000" ||
                                    //     //   avg_diffnzdgbp.toFixed(5) === "-0.0000"
                                    //      ? avg_diffnzdgbp.toFixed(country === "JP" ? 3 : 5) === "0.0000" ||
                                    //      avg_diffnzdgbp.toFixed(country === "JP" ? 3 : 5) === "-0.0000"
                                    //       ? "bg-[#f7dc14]"
                                    //       : typeof avg_diffnzdgbp === "number" &&
                                    //         avg_diffnzdgbp > 0
                                    //       ? "bg-[#7fe9a4]"
                                    //       : "bg-[#f3b2b2]"
                                    //     : "bg-[#E5E7EB]"
                                    // }`}
                                    className={` ${renderTableRows_avg_colorcode(
                                      averageHighLow_nzddata,
                                      item.date
                                    )} border-r-2 border-[#F6F6F6]  min-w-[91.95px]`}
                                  >
                                    {typeof avg_diffnzdgbp === "number"
                                      ? Math.round(
                                          avg_diffnzdgbp.toFixed(
                                            country === "JP" ? 3 : 5
                                          ) * (country === "JP" ? 1000 : 100000)
                                        )
                                      : avg_diffnzdgbp}
                                  </td>
                                </>
                              )}

                              <td
                                className={`${renderTableRows_avg_colorcode(
                                  averageHighLow_usddata,
                                  item.date
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {typeof avg_diff === "number"
                                  ? // ? Math.round(avg_diff.toFixed(3)*1000)
                                    Math.round(
                                      avg_diff.toFixed(
                                        country === "JP" ? 3 : 5
                                      ) * (country === "JP" ? 1000 : 100000)
                                    )
                                  : avg_diff}
                                {/* <br/>
                            { avg_diff.toFixed(5)} */}
                              </td>
                            </>
                          )}

                          {/* <------------------------today aashima 5 min data start--------------> */}
                          {/* <---anindita 2----> */}
                          {country === "AU" ? (
                            <>
                              <td
                                className={` ${renderTableRows_avg_colorcode2(
                                  maxHighHighLow_caddata_3rdcol,
                                  item.date,
                                  typeof avg_diffgbpcad === "number"
                                    ? Math.round(
                                        avg_diffgbpcad.toFixed(
                                          country === "JP" ? 3 : 5
                                        ) * (country === "JP" ? 1000 : 100000)
                                      )
                                    : avg_diffgbpcad
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {renderTableRows_avg2(
                                  maxHighHighLow_caddata_3rdcol,
                                  item.date
                                )}
                              </td>

                              <td
                                className={` ${renderTableRows_avg_colorcode2(
                                  maxHighHighLow_chfdata_3rdcol,
                                  item.date,
                                  typeof avg_diffgbpchf === "number"
                                    ? Math.round(
                                        avg_diffgbpchf.toFixed(
                                          country === "JP" ? 3 : 5
                                        ) * (country === "JP" ? 1000 : 100000)
                                      )
                                    : avg_diffgbpchf
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {renderTableRows_avg2(
                                  maxHighHighLow_chfdata_3rdcol,
                                  item.date
                                )}
                              </td>

                              <td
                                className={` ${renderTableRows_avg_colorcode2(
                                  maxHighHighLow_eurdata_3rdcol,
                                  item.date,
                                  typeof avg_diffeurgbp === "number"
                                    ? Math.round(
                                        avg_diffeurgbp.toFixed(
                                          country === "JP" ? 3 : 5
                                        ) * (country === "JP" ? 1000 : 100000)
                                      )
                                    : avg_diffeurgbp
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {renderTableRows_avg2(
                                  maxHighHighLow_eurdata_3rdcol,
                                  item.date
                                )}
                              </td>
                              <td
                                className={` ${renderTableRows_avg_colorcode2(
                                  maxHighHighLow_auddata_3rdcol,
                                  item.date,
                                  typeof avg_diffgbpaud === "number"
                                    ? Math.round(
                                        avg_diffgbpaud.toFixed(
                                          country === "JP" ? 3 : 5
                                        ) * (country === "JP" ? 1000 : 100000)
                                      )
                                    : avg_diffgbpaud
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {renderTableRows_avg2(
                                  maxHighHighLow_auddata_3rdcol,
                                  item.date
                                )}
                              </td>
                              {country === "US" || country === "NZ" ? (
                                <>
                                  <td
                                    className={` ${renderTableRows_avg_colorcode2(
                                      maxHighHighLow_nzddata_3rdcol,
                                      item.date,
                                      typeof avg_diffnzdgbp === "number"
                                        ? Math.round(
                                            avg_diffnzdgbp.toFixed(
                                              country === "JP" ? 3 : 5
                                            ) *
                                              (country === "JP" ? 1000 : 100000)
                                          )
                                        : avg_diffnzdgbp
                                    )} border-r-2 border-[#F6F6F6]  min-w-[91.95px]`}
                                  >
                                    {/* <vivek--></vivek--> */}
                                    {renderTableRows_avg2(
                                      maxHighHighLow_nzddata_3rdcol,
                                      item.date
                                    )}
                                  </td>
                                  <td
                                    className={` ${renderTableRows_avg_colorcode2(
                                      maxHighHighLow_jpydata_3rdcol,
                                      item.date,
                                      typeof avg_jpydiff === "number"
                                        ? Math.round(
                                            avg_jpydiff.toFixed(3) * 1000
                                          )
                                        : // ? Math.round((avg_jpydiff.toFixed(country === "JP" ? 3 : 5))*(country === "JP" ? 1000 : 100000))
                                          avg_jpydiff
                                    )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {renderTableRows_avg2(
                                      maxHighHighLow_jpydata_3rdcol,
                                      item.date
                                    )}
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td
                                    className={` ${renderTableRows_avg_colorcode2(
                                      maxHighHighLow_jpydata_3rdcol,
                                      item.date,
                                      typeof avg_jpydiff === "number"
                                        ? Math.round(
                                            avg_jpydiff.toFixed(3) * 1000
                                          )
                                        : // ? Math.round((avg_jpydiff.toFixed(country === "JP" ? 3 : 5))*(country === "JP" ? 1000 : 100000))
                                          avg_jpydiff
                                    )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {renderTableRows_avg2(
                                      maxHighHighLow_jpydata_3rdcol,
                                      item.date
                                    )}
                                  </td>

                                  <td
                                    className={` ${renderTableRows_avg_colorcode2(
                                      maxHighHighLow_nzddata_3rdcol,
                                      item.date,
                                      typeof avg_diffnzdgbp === "number"
                                        ? Math.round(
                                            avg_diffnzdgbp.toFixed(
                                              country === "JP" ? 3 : 5
                                            ) *
                                              (country === "JP" ? 1000 : 100000)
                                          )
                                        : avg_diffnzdgbp
                                    )} border-r-2 border-[#F6F6F6]  min-w-[91.95px]`}
                                  >
                                    {/* <vivek--></vivek--> */}
                                    {renderTableRows_avg2(
                                      maxHighHighLow_nzddata_3rdcol,
                                      item.date
                                    )}
                                  </td>
                                </>
                              )}

                              <td
                                className={` ${renderTableRows_avg_colorcode2(
                                  maxHighLow_usddata_3rdcol,
                                  item.date,
                                  typeof avg_diff === "number"
                                    ? // ? Math.round(avg_diff.toFixed(3)*1000)
                                      Math.round(
                                        avg_diff.toFixed(
                                          country === "JP" ? 3 : 5
                                        ) * (country === "JP" ? 1000 : 100000)
                                      )
                                    : avg_diff
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {renderTableRows_avg2(
                                  maxHighLow_usddata_3rdcol,
                                  item.date
                                )}
                              </td>
                            </>
                          ) : (
                            <>
                              <td
                                className={` ${renderTableRows_avg_colorcode2(
                                  maxHighHighLow_auddata_3rdcol,
                                  item.date,
                                  typeof avg_diffgbpaud === "number"
                                    ? Math.round(
                                        avg_diffgbpaud.toFixed(
                                          country === "JP" ? 3 : 5
                                        ) * (country === "JP" ? 1000 : 100000)
                                      )
                                    : avg_diffgbpaud
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {renderTableRows_avg2(
                                  maxHighHighLow_auddata_3rdcol,
                                  item.date
                                )}
                              </td>

                              <td
                                className={` ${renderTableRows_avg_colorcode2(
                                  maxHighHighLow_caddata_3rdcol,
                                  item.date,
                                  typeof avg_diffgbpcad === "number"
                                    ? Math.round(
                                        avg_diffgbpcad.toFixed(
                                          country === "JP" ? 3 : 5
                                        ) * (country === "JP" ? 1000 : 100000)
                                      )
                                    : avg_diffgbpcad
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {renderTableRows_avg2(
                                  maxHighHighLow_caddata_3rdcol,
                                  item.date
                                )}
                              </td>

                              <td
                                className={` ${renderTableRows_avg_colorcode2(
                                  maxHighHighLow_chfdata_3rdcol,
                                  item.date,
                                  typeof avg_diffgbpchf === "number"
                                    ? Math.round(
                                        avg_diffgbpchf.toFixed(
                                          country === "JP" ? 3 : 5
                                        ) * (country === "JP" ? 1000 : 100000)
                                      )
                                    : avg_diffgbpchf
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {renderTableRows_avg2(
                                  maxHighHighLow_chfdata_3rdcol,
                                  item.date
                                )}
                              </td>

                              <td
                                className={` ${renderTableRows_avg_colorcode2(
                                  maxHighHighLow_eurdata_3rdcol,
                                  item.date,
                                  typeof avg_diffeurgbp === "number"
                                    ? Math.round(
                                        avg_diffeurgbp.toFixed(
                                          country === "JP" ? 3 : 5
                                        ) * (country === "JP" ? 1000 : 100000)
                                      )
                                    : avg_diffeurgbp
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {renderTableRows_avg2(
                                  maxHighHighLow_eurdata_3rdcol,
                                  item.date
                                )}
                              </td>
                              {country === "US" || country === "NZ" ? (
                                <>
                                  <td
                                    className={` ${renderTableRows_avg_colorcode2(
                                      maxHighHighLow_nzddata_3rdcol,
                                      item.date,
                                      typeof avg_diffnzdgbp === "number"
                                        ? Math.round(
                                            avg_diffnzdgbp.toFixed(
                                              country === "JP" ? 3 : 5
                                            ) *
                                              (country === "JP" ? 1000 : 100000)
                                          )
                                        : avg_diffnzdgbp
                                    )} border-r-2 border-[#F6F6F6]  min-w-[91.95px]`}
                                  >
                                    {/* <vivek--></vivek--> */}
                                    {renderTableRows_avg2(
                                      maxHighHighLow_nzddata_3rdcol,
                                      item.date
                                    )}
                                  </td>
                                  <td
                                    className={` ${renderTableRows_avg_colorcode2(
                                      maxHighHighLow_jpydata_3rdcol,
                                      item.date,
                                      typeof avg_jpydiff === "number"
                                        ? Math.round(
                                            avg_jpydiff.toFixed(3) * 1000
                                          )
                                        : // ? Math.round((avg_jpydiff.toFixed(country === "JP" ? 3 : 5))*(country === "JP" ? 1000 : 100000))
                                          avg_jpydiff
                                    )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {renderTableRows_avg2(
                                      maxHighHighLow_jpydata_3rdcol,
                                      item.date
                                    )}
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td
                                    className={` ${renderTableRows_avg_colorcode2(
                                      maxHighHighLow_jpydata_3rdcol,
                                      item.date,
                                      typeof avg_jpydiff === "number"
                                        ? Math.round(
                                            avg_jpydiff.toFixed(3) * 1000
                                          )
                                        : // ? Math.round((avg_jpydiff.toFixed(country === "JP" ? 3 : 5))*(country === "JP" ? 1000 : 100000))
                                          avg_jpydiff
                                    )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {renderTableRows_avg2(
                                      maxHighHighLow_jpydata_3rdcol,
                                      item.date
                                    )}
                                  </td>

                                  <td
                                    className={` ${renderTableRows_avg_colorcode2(
                                      maxHighHighLow_nzddata_3rdcol,
                                      item.date,
                                      typeof avg_diffnzdgbp === "number"
                                        ? Math.round(
                                            avg_diffnzdgbp.toFixed(
                                              country === "JP" ? 3 : 5
                                            ) *
                                              (country === "JP" ? 1000 : 100000)
                                          )
                                        : avg_diffnzdgbp
                                    )} border-r-2 border-[#F6F6F6]  min-w-[91.95px]`}
                                  >
                                    {/* <vivek--></vivek--> */}
                                    {renderTableRows_avg2(
                                      maxHighHighLow_nzddata_3rdcol,
                                      item.date
                                    )}
                                  </td>
                                </>
                              )}

                              <td
                                className={` ${renderTableRows_avg_colorcode2(
                                  maxHighLow_usddata_3rdcol,
                                  item.date,
                                  typeof avg_diff === "number"
                                    ? // ? Math.round(avg_diff.toFixed(3)*1000)
                                      Math.round(
                                        avg_diff.toFixed(
                                          country === "JP" ? 3 : 5
                                        ) * (country === "JP" ? 1000 : 100000)
                                      )
                                    : avg_diff
                                )} border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                              >
                                {renderTableRows_avg2(
                                  maxHighLow_usddata_3rdcol,
                                  item.date
                                )}
                              </td>
                            </>
                          )}
                        </tr>
                      </>
                    );
                  })}

                  {/* <------normal average of 3rd table------> */}
                  <tr className="bg-[#dccafe5e] text-center">
                    <td
                      className="py-2  font-bold   min-w-[80.8px] min-h-[66.97px] h-[66.97px]"
                      colSpan={4}
                    >
                      Non- Zero event (average movement)
                    </td>

                    <td className="py-2 "></td>
                    <td className="py-2 "></td>
                    <td className="py-2 "></td>
                    <td className="py-2 "></td>

                    <td className="py-2">
                      {/* {sumActualPreviousbyo}%<br />({sumActualPrevious}) */}
                    </td>
                    <td className="py-2 ">
                      {/* {sumActualEstimatebyo}%<br />({sumActualEstimate}) */}
                    </td>
                    <td className="py-2 ">
                      {/* {sumfinalmovementbyo}%<br />({sumfinalmovement}) */}
                    </td>

                    {country === "AU" ? (
                      <>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpcaddiff1_thirdtable !== null
                              ? averagegbpcaddiff1_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpcaddiff1_thirdtable !== null
                                  ? averagegbpcaddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest2hl_thirdtable
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpcaddiff1_thirdtable !== null
                                  ? averagegbpcaddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest3hl_thirdtable
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {averagegbpcaddiff1_thirdtable !== null
                            ? averagegbpcaddiff1_thirdtable.toFixed(2)
                            : "N/A"}{" "}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpchfdiff1_thirdtable !== null
                              ? averagegbpchfdiff1_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpchfdiff1_thirdtable !== null
                                  ? averagegbpchfdiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest2hl_thirdtable
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpchfdiff1_thirdtable !== null
                                  ? averagegbpchfdiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest3hl_thirdtable
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {averagegbpchfdiff1_thirdtable !== null
                            ? averagegbpchfdiff1_thirdtable.toFixed(2)
                            : "N/A"}{" "}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpeurdiff1_thirdtable !== null
                              ? averagegbpeurdiff1_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpeurdiff1_thirdtable !== null
                                  ? averagegbpeurdiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest2hl_thirdtable
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpeurdiff1_thirdtable !== null
                                  ? averagegbpeurdiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest3hl_thirdtable
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {averagegbpeurdiff1_thirdtable !== null
                            ? averagegbpeurdiff1_thirdtable.toFixed(2)
                            : "N/A"}{" "}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpauddiff1_thirdtable !== null
                              ? averagegbpauddiff1_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpauddiff1_thirdtable !== null
                                  ? averagegbpauddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest2hl_thirdtable
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpauddiff1_thirdtable !== null
                                  ? averagegbpauddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest3hl_thirdtable
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {averagegbpauddiff1_thirdtable !== null
                            ? averagegbpauddiff1_thirdtable.toFixed(2)
                            : "N/A"}{" "}
                        </td>

                        {country === "US" || country === "NZ" ? (
                          <>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpnzddiff1_thirdtable !== null
                                  ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest1hl_thirdtable
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_thirdtable !== null
                                      ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest2hl_thirdtable
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_thirdtable !== null
                                      ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest3hl_thirdtable
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {averagegbpnzddiff1_thirdtable !== null
                                ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                : "N/A"}{" "}
                            </td>
                            <td
                              // className={`text-[15px] py-2 ${
                              //   (averagegbpjpydiff1_thirdtable !== null
                              //     ? averagegbpjpydiff1_thirdtable
                              //     : "N/A") === highest1hl_thirdtable
                              //     ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              //     : (averagegbpjpydiff1_thirdtable !== null
                              //         ? averagegbpjpydiff1_thirdtable
                              //         : "N/A") === highest2hl_thirdtable
                              //     ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              //     : (averagegbpjpydiff1_thirdtable !== null
                              //         ? averagegbpjpydiff1_thirdtable
                              //         : "N/A") === highest3hl_thirdtable
                              //     ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              //     : null
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpjpydiff1_thirdtable !== null
                                  ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest1hl_thirdtable
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_thirdtable !== null
                                      ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest2hl_thirdtable
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_thirdtable !== null
                                      ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest3hl_thirdtable
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {averagegbpjpydiff1_thirdtable !== null
                                ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                : "N/A"}
                            </td>
                          </>
                        ) : (
                          <>
                            <td
                              // className={`text-[15px] py-2 ${
                              //   (averagegbpjpydiff1_thirdtable !== null
                              //     ? averagegbpjpydiff1_thirdtable
                              //     : "N/A") === highest1hl_thirdtable
                              //     ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              //     : (averagegbpjpydiff1_thirdtable !== null
                              //         ? averagegbpjpydiff1_thirdtable
                              //         : "N/A") === highest2hl_thirdtable
                              //     ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              //     : (averagegbpjpydiff1_thirdtable !== null
                              //         ? averagegbpjpydiff1_thirdtable
                              //         : "N/A") === highest3hl_thirdtable
                              //     ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              //     : null
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpjpydiff1_thirdtable !== null
                                  ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest1hl_thirdtable
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_thirdtable !== null
                                      ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest2hl_thirdtable
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_thirdtable !== null
                                      ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest3hl_thirdtable
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {averagegbpjpydiff1_thirdtable !== null
                                ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                : "N/A"}
                            </td>

                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpnzddiff1_thirdtable !== null
                                  ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest1hl_thirdtable
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_thirdtable !== null
                                      ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest2hl_thirdtable
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_thirdtable !== null
                                      ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest3hl_thirdtable
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {averagegbpnzddiff1_thirdtable !== null
                                ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                : "N/A"}{" "}
                            </td>
                          </>
                        )}

                        <td
                          className={`text-[15px] py-2  border border-r-2 border-[#F6F6F6] ${
                            (averagegbpusddiff1_thirdtable !== null
                              ? averagegbpusddiff1_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpusddiff1_thirdtable !== null
                                  ? averagegbpusddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest2hl_thirdtable
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpusddiff1_thirdtable !== null
                                  ? averagegbpusddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest3hl_thirdtable
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {averagegbpusddiff1_thirdtable !== null
                            ? averagegbpusddiff1_thirdtable.toFixed(2)
                            : "N/A"}
                        </td>
                      </>
                    ) : (
                      <>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpauddiff1_thirdtable !== null
                              ? averagegbpauddiff1_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpauddiff1_thirdtable !== null
                                  ? averagegbpauddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest2hl_thirdtable
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpauddiff1_thirdtable !== null
                                  ? averagegbpauddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest3hl_thirdtable
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {averagegbpauddiff1_thirdtable !== null
                            ? averagegbpauddiff1_thirdtable.toFixed(2)
                            : "N/A"}{" "}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpcaddiff1_thirdtable !== null
                              ? averagegbpcaddiff1_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpcaddiff1_thirdtable !== null
                                  ? averagegbpcaddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest2hl_thirdtable
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpcaddiff1_thirdtable !== null
                                  ? averagegbpcaddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest3hl_thirdtable
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {averagegbpcaddiff1_thirdtable !== null
                            ? averagegbpcaddiff1_thirdtable.toFixed(2)
                            : "N/A"}{" "}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpchfdiff1_thirdtable !== null
                              ? averagegbpchfdiff1_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpchfdiff1_thirdtable !== null
                                  ? averagegbpchfdiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest2hl_thirdtable
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpchfdiff1_thirdtable !== null
                                  ? averagegbpchfdiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest3hl_thirdtable
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {averagegbpchfdiff1_thirdtable !== null
                            ? averagegbpchfdiff1_thirdtable.toFixed(2)
                            : "N/A"}{" "}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpeurdiff1_thirdtable !== null
                              ? averagegbpeurdiff1_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpeurdiff1_thirdtable !== null
                                  ? averagegbpeurdiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest2hl_thirdtable
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpeurdiff1_thirdtable !== null
                                  ? averagegbpeurdiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest3hl_thirdtable
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {averagegbpeurdiff1_thirdtable !== null
                            ? averagegbpeurdiff1_thirdtable.toFixed(2)
                            : "N/A"}{" "}
                        </td>

                        {country === "US" || country === "NZ" ? (
                          <>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpnzddiff1_thirdtable !== null
                                  ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest1hl_thirdtable
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_thirdtable !== null
                                      ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest2hl_thirdtable
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_thirdtable !== null
                                      ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest3hl_thirdtable
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {averagegbpnzddiff1_thirdtable !== null
                                ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                : "N/A"}{" "}
                            </td>
                            <td
                              // className={`text-[15px] py-2 ${
                              //   (averagegbpjpydiff1_thirdtable !== null
                              //     ? averagegbpjpydiff1_thirdtable
                              //     : "N/A") === highest1hl_thirdtable
                              //     ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              //     : (averagegbpjpydiff1_thirdtable !== null
                              //         ? averagegbpjpydiff1_thirdtable
                              //         : "N/A") === highest2hl_thirdtable
                              //     ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              //     : (averagegbpjpydiff1_thirdtable !== null
                              //         ? averagegbpjpydiff1_thirdtable
                              //         : "N/A") === highest3hl_thirdtable
                              //     ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              //     : null
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpjpydiff1_thirdtable !== null
                                  ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest1hl_thirdtable
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_thirdtable !== null
                                      ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest2hl_thirdtable
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_thirdtable !== null
                                      ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest3hl_thirdtable
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {averagegbpjpydiff1_thirdtable !== null
                                ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                : "N/A"}
                            </td>
                          </>
                        ) : (
                          <>
                            <td
                              // className={`text-[15px] py-2 ${
                              //   (averagegbpjpydiff1_thirdtable !== null
                              //     ? averagegbpjpydiff1_thirdtable
                              //     : "N/A") === highest1hl_thirdtable
                              //     ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              //     : (averagegbpjpydiff1_thirdtable !== null
                              //         ? averagegbpjpydiff1_thirdtable
                              //         : "N/A") === highest2hl_thirdtable
                              //     ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              //     : (averagegbpjpydiff1_thirdtable !== null
                              //         ? averagegbpjpydiff1_thirdtable
                              //         : "N/A") === highest3hl_thirdtable
                              //     ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              //     : null
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpjpydiff1_thirdtable !== null
                                  ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest1hl_thirdtable
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_thirdtable !== null
                                      ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest2hl_thirdtable
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_thirdtable !== null
                                      ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest3hl_thirdtable
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {averagegbpjpydiff1_thirdtable !== null
                                ? averagegbpjpydiff1_thirdtable.toFixed(2)
                                : "N/A"}
                            </td>

                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpnzddiff1_thirdtable !== null
                                  ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest1hl_thirdtable
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_thirdtable !== null
                                      ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest2hl_thirdtable
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_thirdtable !== null
                                      ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                      : "N/A") === highest3hl_thirdtable
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {averagegbpnzddiff1_thirdtable !== null
                                ? averagegbpnzddiff1_thirdtable.toFixed(2)
                                : "N/A"}{" "}
                            </td>
                          </>
                        )}

                        <td
                          className={`text-[15px] py-2  border border-r-2 border-[#F6F6F6] ${
                            (averagegbpusddiff1_thirdtable !== null
                              ? averagegbpusddiff1_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpusddiff1_thirdtable !== null
                                  ? averagegbpusddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest2hl_thirdtable
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpusddiff1_thirdtable !== null
                                  ? averagegbpusddiff1_thirdtable.toFixed(2)
                                  : "N/A") === highest3hl_thirdtable
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {averagegbpusddiff1_thirdtable !== null
                            ? averagegbpusddiff1_thirdtable.toFixed(2)
                            : "N/A"}
                        </td>
                      </>
                    )}

                    {/* <---today aashima ---?> */}

                    {country === "AU" ? (
                      <>
                        <td
                          className={`text-[15px] py-2 border border-r-4 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_cad !== null
                              ? finalAvg_ofmaxof5min_cad + "%"
                              : "N/A") === highest1hl_thirdtable_future5min
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_cad !== null
                                  ? finalAvg_ofmaxof5min_cad + "%"
                                  : "N/A") === highest2hl_thirdtable_future5min
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_cad !== null
                                  ? finalAvg_ofmaxof5min_cad
                                  : "N/A") === highest3hl_thirdtable_future5min
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_cad !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_cad.toFixed(3) * 1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_cad !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_cad.toFixed(5) * 100000
                              )
                            : "N/A"}
                          {/* {finalAvg_ofmaxof5min_cad !== null
                        ? Math.round((finalAvg_ofmaxof5min_cad.toFixed(5))*100000)
                        : "N/A"}
                       */}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_chf !== null
                              ? finalAvg_ofmaxof5min_chf + "%"
                              : "N/A") === highest1hl_thirdtable_future5min
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_chf !== null
                                  ? finalAvg_ofmaxof5min_chf + "%"
                                  : "N/A") === highest2hl_thirdtable_future5min
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_chf !== null
                                  ? finalAvg_ofmaxof5min_chf + "%"
                                  : "N/A") === highest3hl_thirdtable_future5min
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_chf !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_chf.toFixed(3) * 1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_chf !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_chf.toFixed(5) * 100000
                              )
                            : "N/A"}
                          {/* {finalAvg_ofmaxof5min_chf !== null
                        ? Math.round((finalAvg_ofmaxof5min_chf.toFixed(5))*100000)
                        : "N/A"} */}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_eur !== null
                              ? finalAvg_ofmaxof5min_eur + "%"
                              : "N/A") === highest1hl_thirdtable_future5min
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_eur !== null
                                  ? finalAvg_ofmaxof5min_eur + "%"
                                  : "N/A") === highest2hl_thirdtable_future5min
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_eur !== null
                                  ? finalAvg_ofmaxof5min_eur + "%"
                                  : "N/A") === highest3hl_thirdtable_future5min
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_eur !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_eur.toFixed(3) * 1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_eur !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_eur.toFixed(5) * 100000
                              )
                            : "N/A"}
                          {/* {finalAvg_ofmaxof5min_eur !== null
                        ? Math.round((finalAvg_ofmaxof5min_eur.toFixed(5))*100000)
                        : "N/A"} */}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_aud !== null
                              ? finalAvg_ofmaxof5min_aud + "%"
                              : "N/A") === highest1hl_thirdtable_future5min
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_aud !== null
                                  ? finalAvg_ofmaxof5min_aud + "%"
                                  : "N/A") === highest2hl_thirdtable_future5min
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_aud !== null
                                  ? finalAvg_ofmaxof5min_aud + "%"
                                  : "N/A") === highest3hl_thirdtable_future5min
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_aud !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_aud.toFixed(3) * 1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_aud !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_aud.toFixed(5) * 100000
                              )
                            : "N/A"}
                        </td>

                        {country === "US" || country === "NZ" ? (
                          <>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_nzd !== null
                                  ? finalAvg_ofmaxof5min_nzd + "%"
                                  : "N/A") === highest1hl_thirdtable_future5min
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd !== null
                                      ? finalAvg_ofmaxof5min_nzd + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd !== null
                                      ? finalAvg_ofmaxof5min_nzd + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {country === "JP"
                                ? finalAvg_ofmaxof5min_nzd !== null
                                  ? Math.round(
                                      finalAvg_ofmaxof5min_nzd.toFixed(3) * 1000
                                    )
                                  : "N/A"
                                : finalAvg_ofmaxof5min_nzd !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_nzd.toFixed(5) * 100000
                                  )
                                : "N/A"}
                              {/* {finalAvg_ofmaxof5min_nzd !== null
                        ? Math.round((finalAvg_ofmaxof5min_nzd.toFixed(5))*100000)
                        : "N/A"} */}
                            </td>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_jpy !== null
                                  ? finalAvg_ofmaxof5min_jpy + "%"
                                  : "N/A") === highest1hl_thirdtable_future5min
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy !== null
                                      ? finalAvg_ofmaxof5min_jpy + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy !== null
                                      ? finalAvg_ofmaxof5min_jpy + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {finalAvg_ofmaxof5min_jpy !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_jpy.toFixed(3) * 1000
                                  )
                                : "N/A"}
                            </td>
                          </>
                        ) : (
                          <>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_jpy !== null
                                  ? finalAvg_ofmaxof5min_jpy + "%"
                                  : "N/A") === highest1hl_thirdtable_future5min
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy !== null
                                      ? finalAvg_ofmaxof5min_jpy + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy !== null
                                      ? finalAvg_ofmaxof5min_jpy + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {finalAvg_ofmaxof5min_jpy !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_jpy.toFixed(3) * 1000
                                  )
                                : "N/A"}
                            </td>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_nzd !== null
                                  ? finalAvg_ofmaxof5min_nzd + "%"
                                  : "N/A") === highest1hl_thirdtable_future5min
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd !== null
                                      ? finalAvg_ofmaxof5min_nzd + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd !== null
                                      ? finalAvg_ofmaxof5min_nzd + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {country === "JP"
                                ? finalAvg_ofmaxof5min_nzd !== null
                                  ? Math.round(
                                      finalAvg_ofmaxof5min_nzd.toFixed(3) * 1000
                                    )
                                  : "N/A"
                                : finalAvg_ofmaxof5min_nzd !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_nzd.toFixed(5) * 100000
                                  )
                                : "N/A"}
                              {/* {finalAvg_ofmaxof5min_nzd !== null
                        ? Math.round((finalAvg_ofmaxof5min_nzd.toFixed(5))*100000)
                        : "N/A"} */}
                            </td>
                          </>
                        )}

                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_usd !== null
                              ? finalAvg_ofmaxof5min_usd + "%"
                              : "N/A") === highest1hl_thirdtable_future5min
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_usd !== null
                                  ? finalAvg_ofmaxof5min_usd + "%"
                                  : "N/A") === highest2hl_thirdtable_future5min
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_usd !== null
                                  ? finalAvg_ofmaxof5min_usd + "%"
                                  : "N/A") === highest3hl_thirdtable_future5min
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : ""
                          }`}
                        >
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_usd !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_usd.toFixed(3) * 1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_usd !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_usd.toFixed(5) * 100000
                              )
                            : "N/A"}
                          {/* {finalAvg_ofmaxof5min_usd !== null
                        ? Math.round((finalAvg_ofmaxof5min_usd.toFixed(5))*100000)
                        : "N/A"} */}
                        </td>
                      </>
                    ) : (
                      <>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_aud !== null
                              ? finalAvg_ofmaxof5min_aud + "%"
                              : "N/A") === highest1hl_thirdtable_future5min
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_aud !== null
                                  ? finalAvg_ofmaxof5min_aud + "%"
                                  : "N/A") === highest2hl_thirdtable_future5min
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_aud !== null
                                  ? finalAvg_ofmaxof5min_aud + "%"
                                  : "N/A") === highest3hl_thirdtable_future5min
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_aud !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_aud.toFixed(3) * 1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_aud !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_aud.toFixed(5) * 100000
                              )
                            : "N/A"}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-4 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_cad !== null
                              ? finalAvg_ofmaxof5min_cad + "%"
                              : "N/A") === highest1hl_thirdtable_future5min
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_cad !== null
                                  ? finalAvg_ofmaxof5min_cad + "%"
                                  : "N/A") === highest2hl_thirdtable_future5min
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_cad !== null
                                  ? finalAvg_ofmaxof5min_cad
                                  : "N/A") === highest3hl_thirdtable_future5min
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_cad !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_cad.toFixed(3) * 1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_cad !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_cad.toFixed(5) * 100000
                              )
                            : "N/A"}
                          {/* {finalAvg_ofmaxof5min_cad !== null
                        ? Math.round((finalAvg_ofmaxof5min_cad.toFixed(5))*100000)
                        : "N/A"}
                       */}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_chf !== null
                              ? finalAvg_ofmaxof5min_chf + "%"
                              : "N/A") === highest1hl_thirdtable_future5min
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_chf !== null
                                  ? finalAvg_ofmaxof5min_chf + "%"
                                  : "N/A") === highest2hl_thirdtable_future5min
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_chf !== null
                                  ? finalAvg_ofmaxof5min_chf + "%"
                                  : "N/A") === highest3hl_thirdtable_future5min
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_chf !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_chf.toFixed(3) * 1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_chf !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_chf.toFixed(5) * 100000
                              )
                            : "N/A"}
                          {/* {finalAvg_ofmaxof5min_chf !== null
                        ? Math.round((finalAvg_ofmaxof5min_chf.toFixed(5))*100000)
                        : "N/A"} */}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_eur !== null
                              ? finalAvg_ofmaxof5min_eur + "%"
                              : "N/A") === highest1hl_thirdtable_future5min
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_eur !== null
                                  ? finalAvg_ofmaxof5min_eur + "%"
                                  : "N/A") === highest2hl_thirdtable_future5min
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_eur !== null
                                  ? finalAvg_ofmaxof5min_eur + "%"
                                  : "N/A") === highest3hl_thirdtable_future5min
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_eur !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_eur.toFixed(3) * 1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_eur !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_eur.toFixed(5) * 100000
                              )
                            : "N/A"}
                          {/* {finalAvg_ofmaxof5min_eur !== null
                        ? Math.round((finalAvg_ofmaxof5min_eur.toFixed(5))*100000)
                        : "N/A"} */}
                        </td>

                        {country === "US" || country === "NZ" ? (
                          <>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_nzd !== null
                                  ? finalAvg_ofmaxof5min_nzd + "%"
                                  : "N/A") === highest1hl_thirdtable_future5min
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd !== null
                                      ? finalAvg_ofmaxof5min_nzd + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd !== null
                                      ? finalAvg_ofmaxof5min_nzd + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {country === "JP"
                                ? finalAvg_ofmaxof5min_nzd !== null
                                  ? Math.round(
                                      finalAvg_ofmaxof5min_nzd.toFixed(3) * 1000
                                    )
                                  : "N/A"
                                : finalAvg_ofmaxof5min_nzd !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_nzd.toFixed(5) * 100000
                                  )
                                : "N/A"}
                              {/* {finalAvg_ofmaxof5min_nzd !== null
                        ? Math.round((finalAvg_ofmaxof5min_nzd.toFixed(5))*100000)
                        : "N/A"} */}
                            </td>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_jpy !== null
                                  ? finalAvg_ofmaxof5min_jpy + "%"
                                  : "N/A") === highest1hl_thirdtable_future5min
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy !== null
                                      ? finalAvg_ofmaxof5min_jpy + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy !== null
                                      ? finalAvg_ofmaxof5min_jpy + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {finalAvg_ofmaxof5min_jpy !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_jpy.toFixed(3) * 1000
                                  )
                                : "N/A"}
                            </td>
                          </>
                        ) : (
                          <>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_jpy !== null
                                  ? finalAvg_ofmaxof5min_jpy + "%"
                                  : "N/A") === highest1hl_thirdtable_future5min
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy !== null
                                      ? finalAvg_ofmaxof5min_jpy + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy !== null
                                      ? finalAvg_ofmaxof5min_jpy + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {finalAvg_ofmaxof5min_jpy !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_jpy.toFixed(3) * 1000
                                  )
                                : "N/A"}
                            </td>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_nzd !== null
                                  ? finalAvg_ofmaxof5min_nzd + "%"
                                  : "N/A") === highest1hl_thirdtable_future5min
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd !== null
                                      ? finalAvg_ofmaxof5min_nzd + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd !== null
                                      ? finalAvg_ofmaxof5min_nzd + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {country === "JP"
                                ? finalAvg_ofmaxof5min_nzd !== null
                                  ? Math.round(
                                      finalAvg_ofmaxof5min_nzd.toFixed(3) * 1000
                                    )
                                  : "N/A"
                                : finalAvg_ofmaxof5min_nzd !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_nzd.toFixed(5) * 100000
                                  )
                                : "N/A"}
                              {/* {finalAvg_ofmaxof5min_nzd !== null
                        ? Math.round((finalAvg_ofmaxof5min_nzd.toFixed(5))*100000)
                        : "N/A"} */}
                            </td>
                          </>
                        )}

                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_usd !== null
                              ? finalAvg_ofmaxof5min_usd + "%"
                              : "N/A") === highest1hl_thirdtable_future5min
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_usd !== null
                                  ? finalAvg_ofmaxof5min_usd + "%"
                                  : "N/A") === highest2hl_thirdtable_future5min
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_usd !== null
                                  ? finalAvg_ofmaxof5min_usd + "%"
                                  : "N/A") === highest3hl_thirdtable_future5min
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : ""
                          }`}
                        >
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_usd !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_usd.toFixed(3) * 1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_usd !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_usd.toFixed(5) * 100000
                              )
                            : "N/A"}
                          {/* {finalAvg_ofmaxof5min_usd !== null
                        ? Math.round((finalAvg_ofmaxof5min_usd.toFixed(5))*100000)
                        : "N/A"} */}
                        </td>
                      </>
                    )}
                  </tr>

                  {/* <------FLAT Average of 3rd table------> */}
                  <tr className="bg-[#dccafe5e] text-center">
                    <td
                      className="py-2  font-bold   min-w-[80.8px] min-h-[66.97px] h-[66.97px]"
                      colSpan={4}
                    >
                      Flat event (average movement)
                    </td>

                    <td className="py-2 "></td>
                    <td className="py-2 "></td>
                    <td className="py-2 "></td>
                    <td className="py-2 "></td>

                    <td className="py-2">
                      {/* 0.0% <br />
                     
                      (0.0) */}
                    </td>
                    <td className="py-2 ">
                      {/* 0.0% <br /> (0.0) */}
                      <br />
                    </td>
                    <td className="py-2 ">{/* 0.0% <br /> (0.0) */}</td>

                    {/* <--------------normal flat average-----------> */}

                    {country === "AU" ? (
                      <>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpcaddiff1_flat0_thirdtable !== null
                              ? averagegbpcaddiff1_flat0_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpcaddiff1_flat0_thirdtable !== null
                                  ? averagegbpcaddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest2hl_thirdtable_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpcaddiff1_flat0_thirdtable !== null
                                  ? averagegbpcaddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest3hl_thirdtable_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : ""
                          }`}
                        >
                          {averagegbpcaddiff1_flat0_thirdtable !== null
                            ? averagegbpcaddiff1_flat0_thirdtable.toFixed(2)
                            : "N/A"}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpchfdiff1_flat0_thirdtable !== null
                              ? averagegbpchfdiff1_flat0_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpchfdiff1_flat0_thirdtable !== null
                                  ? averagegbpchfdiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest2hl_thirdtable_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpchfdiff1_flat0_thirdtable !== null
                                  ? averagegbpchfdiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest3hl_thirdtable_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : ""
                          }`}
                        >
                          {averagegbpchfdiff1_flat0_thirdtable !== null
                            ? averagegbpchfdiff1_flat0_thirdtable.toFixed(2)
                            : "N/A"}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpeurdiff1_flat0_thirdtable !== null
                              ? averagegbpeurdiff1_flat0_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpeurdiff1_flat0_thirdtable !== null
                                  ? averagegbpeurdiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest2hl_thirdtable_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpeurdiff1_flat0_thirdtable !== null
                                  ? averagegbpeurdiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest3hl_thirdtable_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : ""
                          }`}
                        >
                          {averagegbpeurdiff1_flat0_thirdtable !== null
                            ? averagegbpeurdiff1_flat0_thirdtable.toFixed(2)
                            : "N/A"}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpauddiff1_flat0_thirdtable !== null
                              ? averagegbpauddiff1_flat0_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpauddiff1_flat0_thirdtable !== null
                                  ? averagegbpauddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest2hl_thirdtable_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpauddiff1_flat0_thirdtable !== null
                                  ? averagegbpauddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest3hl_thirdtable_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : ""
                          }`}
                        >
                          {averagegbpauddiff1_flat0_thirdtable !== null
                            ? averagegbpauddiff1_flat0_thirdtable.toFixed(2)
                            : "N/A"}
                        </td>

                        {country === "US" || country === "NZ" ? (
                          <>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpnzddiff1_flat0_thirdtable !== null
                                  ? averagegbpnzddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest1hl_thirdtable_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpnzddiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest2hl_thirdtable_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpnzddiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest3hl_thirdtable_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : ""
                              }`}
                            >
                              {averagegbpnzddiff1_flat0_thirdtable !== null
                                ? averagegbpnzddiff1_flat0_thirdtable.toFixed(2)
                                : "N/A"}
                            </td>{" "}
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpjpydiff1_flat0_thirdtable !== null
                                  ? averagegbpjpydiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest1hl_thirdtable_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpjpydiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest2hl_thirdtable_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpjpydiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest3hl_thirdtable_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : ""
                              }`}
                            >
                              {averagegbpjpydiff1_flat0_thirdtable !== null
                                ? averagegbpjpydiff1_flat0_thirdtable.toFixed(2)
                                : "N/A"}
                            </td>
                          </>
                        ) : (
                          <>
                            {" "}
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpjpydiff1_flat0_thirdtable !== null
                                  ? averagegbpjpydiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest1hl_thirdtable_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpjpydiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest2hl_thirdtable_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpjpydiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest3hl_thirdtable_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : ""
                              }`}
                            >
                              {averagegbpjpydiff1_flat0_thirdtable !== null
                                ? averagegbpjpydiff1_flat0_thirdtable.toFixed(2)
                                : "N/A"}
                            </td>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpnzddiff1_flat0_thirdtable !== null
                                  ? averagegbpnzddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest1hl_thirdtable_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpnzddiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest2hl_thirdtable_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpnzddiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest3hl_thirdtable_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : ""
                              }`}
                            >
                              {averagegbpnzddiff1_flat0_thirdtable !== null
                                ? averagegbpnzddiff1_flat0_thirdtable.toFixed(2)
                                : "N/A"}
                            </td>
                          </>
                        )}

                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpusddiff1_flat0_thirdtable !== null
                              ? averagegbpusddiff1_flat0_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpusddiff1_flat0_thirdtable !== null
                                  ? averagegbpusddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest2hl_thirdtable_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpusddiff1_flat0_thirdtable !== null
                                  ? averagegbpusddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest3hl_thirdtable_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : ""
                          }`}
                        >
                          {averagegbpusddiff1_flat0_thirdtable !== null
                            ? averagegbpusddiff1_flat0_thirdtable.toFixed(2)
                            : "N/A"}
                        </td>
                      </>
                    ) : (
                      <>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpauddiff1_flat0_thirdtable !== null
                              ? averagegbpauddiff1_flat0_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpauddiff1_flat0_thirdtable !== null
                                  ? averagegbpauddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest2hl_thirdtable_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpauddiff1_flat0_thirdtable !== null
                                  ? averagegbpauddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest3hl_thirdtable_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : ""
                          }`}
                        >
                          {averagegbpauddiff1_flat0_thirdtable !== null
                            ? averagegbpauddiff1_flat0_thirdtable.toFixed(2)
                            : "N/A"}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpcaddiff1_flat0_thirdtable !== null
                              ? averagegbpcaddiff1_flat0_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpcaddiff1_flat0_thirdtable !== null
                                  ? averagegbpcaddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest2hl_thirdtable_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpcaddiff1_flat0_thirdtable !== null
                                  ? averagegbpcaddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest3hl_thirdtable_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : ""
                          }`}
                        >
                          {averagegbpcaddiff1_flat0_thirdtable !== null
                            ? averagegbpcaddiff1_flat0_thirdtable.toFixed(2)
                            : "N/A"}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpchfdiff1_flat0_thirdtable !== null
                              ? averagegbpchfdiff1_flat0_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpchfdiff1_flat0_thirdtable !== null
                                  ? averagegbpchfdiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest2hl_thirdtable_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpchfdiff1_flat0_thirdtable !== null
                                  ? averagegbpchfdiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest3hl_thirdtable_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : ""
                          }`}
                        >
                          {averagegbpchfdiff1_flat0_thirdtable !== null
                            ? averagegbpchfdiff1_flat0_thirdtable.toFixed(2)
                            : "N/A"}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpeurdiff1_flat0_thirdtable !== null
                              ? averagegbpeurdiff1_flat0_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpeurdiff1_flat0_thirdtable !== null
                                  ? averagegbpeurdiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest2hl_thirdtable_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpeurdiff1_flat0_thirdtable !== null
                                  ? averagegbpeurdiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest3hl_thirdtable_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : ""
                          }`}
                        >
                          {averagegbpeurdiff1_flat0_thirdtable !== null
                            ? averagegbpeurdiff1_flat0_thirdtable.toFixed(2)
                            : "N/A"}
                        </td>
                        {country === "US" || country === "NZ" ? (
                          <>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpnzddiff1_flat0_thirdtable !== null
                                  ? averagegbpnzddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest1hl_thirdtable_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpnzddiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest2hl_thirdtable_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpnzddiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest3hl_thirdtable_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : ""
                              }`}
                            >
                              {averagegbpnzddiff1_flat0_thirdtable !== null
                                ? averagegbpnzddiff1_flat0_thirdtable.toFixed(2)
                                : "N/A"}
                            </td>{" "}
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpjpydiff1_flat0_thirdtable !== null
                                  ? averagegbpjpydiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest1hl_thirdtable_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpjpydiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest2hl_thirdtable_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpjpydiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest3hl_thirdtable_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : ""
                              }`}
                            >
                              {averagegbpjpydiff1_flat0_thirdtable !== null
                                ? averagegbpjpydiff1_flat0_thirdtable.toFixed(2)
                                : "N/A"}
                            </td>
                          </>
                        ) : (
                          <>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpjpydiff1_flat0_thirdtable !== null
                                  ? averagegbpjpydiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest1hl_thirdtable_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpjpydiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest2hl_thirdtable_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpjpydiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpjpydiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest3hl_thirdtable_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : ""
                              }`}
                            >
                              {averagegbpjpydiff1_flat0_thirdtable !== null
                                ? averagegbpjpydiff1_flat0_thirdtable.toFixed(2)
                                : "N/A"}
                            </td>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (averagegbpnzddiff1_flat0_thirdtable !== null
                                  ? averagegbpnzddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest1hl_thirdtable_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpnzddiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest2hl_thirdtable_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (averagegbpnzddiff1_flat0_thirdtable !==
                                    null
                                      ? averagegbpnzddiff1_flat0_thirdtable.toFixed(
                                          2
                                        )
                                      : "N/A") === highest3hl_thirdtable_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : ""
                              }`}
                            >
                              {averagegbpnzddiff1_flat0_thirdtable !== null
                                ? averagegbpnzddiff1_flat0_thirdtable.toFixed(2)
                                : "N/A"}
                            </td>
                          </>
                        )}

                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (averagegbpusddiff1_flat0_thirdtable !== null
                              ? averagegbpusddiff1_flat0_thirdtable.toFixed(2)
                              : "N/A") === highest1hl_thirdtable_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (averagegbpusddiff1_flat0_thirdtable !== null
                                  ? averagegbpusddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest2hl_thirdtable_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (averagegbpusddiff1_flat0_thirdtable !== null
                                  ? averagegbpusddiff1_flat0_thirdtable.toFixed(
                                      2
                                    )
                                  : "N/A") === highest3hl_thirdtable_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : ""
                          }`}
                        >
                          {averagegbpusddiff1_flat0_thirdtable !== null
                            ? averagegbpusddiff1_flat0_thirdtable.toFixed(2)
                            : "N/A"}
                        </td>
                      </>
                    )}

                    {/* <---------------today--------------> */}
                    {country === "AU" ? (
                      <>
                        {/* <--ye rhta hai abhi ---kal krte hai 14-05--> */}
                        <td
                          className={`text-[15px] py-2 border border-r-4 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_cad_flat0 !== null
                              ? finalAvg_ofmaxof5min_cad_flat0 + "%"
                              : "N/A") ===
                            highest1hl_thirdtable_future5min_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_cad_flat0 !== null
                                  ? finalAvg_ofmaxof5min_cad_flat0 + "%"
                                  : "N/A") ===
                                highest2hl_thirdtable_future5min_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_cad_flat0 !== null
                                  ? finalAvg_ofmaxof5min_cad_flat0 + "%"
                                  : "N/A") ===
                                highest3hl_thirdtable_future5min_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_cad_flat0 !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_cad_flat0.toFixed(3) *
                                    1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_cad_flat0 !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_cad_flat0.toFixed(5) *
                                  100000
                              )
                            : "N/A"}
                          {/* {finalAvg_ofmaxof5min_cad_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_cad_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_chf_flat0 !== null
                              ? finalAvg_ofmaxof5min_chf_flat0 + "%"
                              : "N/A") ===
                            highest1hl_thirdtable_future5min_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_chf_flat0 !== null
                                  ? finalAvg_ofmaxof5min_chf_flat0 + "%"
                                  : "N/A") ===
                                highest2hl_thirdtable_future5min_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_chf_flat0 !== null
                                  ? finalAvg_ofmaxof5min_chf_flat0 + "%"
                                  : "N/A") ===
                                highest3hl_thirdtable_future5min_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_chf_flat0 !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_chf_flat0.toFixed(3) *
                                    1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_chf_flat0 !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_chf_flat0.toFixed(5) *
                                  100000
                              )
                            : "N/A"}
                          {/* {finalAvg_ofmaxof5min_chf_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_chf_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_eur_flat0 !== null
                              ? finalAvg_ofmaxof5min_eur_flat0 + "%"
                              : "N/A") ===
                            highest1hl_thirdtable_future5min_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_eur_flat0 !== null
                                  ? finalAvg_ofmaxof5min_eur_flat0 + "%"
                                  : "N/A") ===
                                highest2hl_thirdtable_future5min_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_eur_flat0 !== null
                                  ? finalAvg_ofmaxof5min_eur_flat0 + "%"
                                  : "N/A") ===
                                highest3hl_thirdtable_future5min_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_eur_flat0 !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_eur_flat0.toFixed(3) *
                                    1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_eur_flat0 !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_eur_flat0.toFixed(5) *
                                  100000
                              )
                            : "N/A"}
                          {/* {finalAvg_ofmaxof5min_eur_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_eur_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_aud_flat0 !== null
                              ? finalAvg_ofmaxof5min_aud_flat0 + "%"
                              : "N/A") ===
                            highest1hl_thirdtable_future5min_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_aud_flat0 !== null
                                  ? finalAvg_ofmaxof5min_aud_flat0 + "%"
                                  : "N/A") ===
                                highest2hl_thirdtable_future5min_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_aud_flat0 !== null
                                  ? finalAvg_ofmaxof5min_aud_flat0 + "%"
                                  : "N/A") ===
                                highest3hl_thirdtable_future5min_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_aud_flat0 !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_aud_flat0.toFixed(3) *
                                    1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_aud_flat0 !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_aud_flat0.toFixed(5) *
                                  100000
                              )
                            : "N/A"}
                          {/* {finalAvg_ofmaxof5min_aud_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_aud_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                        </td>

                        {country === "US" || country === "NZ" ? (
                          <>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_nzd_flat0 !== null
                                  ? finalAvg_ofmaxof5min_nzd_flat0 + "%"
                                  : "N/A") ===
                                highest1hl_thirdtable_future5min_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd_flat0 !== null
                                      ? finalAvg_ofmaxof5min_nzd_flat0 + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd_flat0 !== null
                                      ? finalAvg_ofmaxof5min_nzd_flat0 + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {country === "JP"
                                ? finalAvg_ofmaxof5min_nzd_flat0 !== null
                                  ? Math.round(
                                      finalAvg_ofmaxof5min_nzd_flat0.toFixed(
                                        3
                                      ) * 1000
                                    )
                                  : "N/A"
                                : finalAvg_ofmaxof5min_nzd_flat0 !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_nzd_flat0.toFixed(5) *
                                      100000
                                  )
                                : "N/A"}
                              {/* {finalAvg_ofmaxof5min_nzd_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_nzd_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                            </td>

                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_jpy_flat0 !== null
                                  ? finalAvg_ofmaxof5min_jpy_flat0 + "%"
                                  : "N/A") ===
                                highest1hl_thirdtable_future5min_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy_flat0 !== null
                                      ? finalAvg_ofmaxof5min_jpy_flat0 + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy_flat0 !== null
                                      ? finalAvg_ofmaxof5min_jpy_flat0 + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {/* {country === "JP"
                        ? finalAvg_ofmaxof5min_jpy_flat0 !== null
                          ? Math.round(
                              finalAvg_ofmaxof5min_jpy_flat0.toFixed(3) * 1000
                            )
                          : "N/A"
                        : finalAvg_ofmaxof5min_jpy_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_jpy_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                              {finalAvg_ofmaxof5min_jpy_flat0 !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_jpy_flat0.toFixed(3) *
                                      1000
                                  )
                                : "N/A"}
                            </td>
                          </>
                        ) : (
                          <>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_jpy_flat0 !== null
                                  ? finalAvg_ofmaxof5min_jpy_flat0 + "%"
                                  : "N/A") ===
                                highest1hl_thirdtable_future5min_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy_flat0 !== null
                                      ? finalAvg_ofmaxof5min_jpy_flat0 + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy_flat0 !== null
                                      ? finalAvg_ofmaxof5min_jpy_flat0 + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {/* {country === "JP"
                        ? finalAvg_ofmaxof5min_jpy_flat0 !== null
                          ? Math.round(
                              finalAvg_ofmaxof5min_jpy_flat0.toFixed(3) * 1000
                            )
                          : "N/A"
                        : finalAvg_ofmaxof5min_jpy_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_jpy_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                              {finalAvg_ofmaxof5min_jpy_flat0 !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_jpy_flat0.toFixed(3) *
                                      1000
                                  )
                                : "N/A"}
                            </td>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_nzd_flat0 !== null
                                  ? finalAvg_ofmaxof5min_nzd_flat0 + "%"
                                  : "N/A") ===
                                highest1hl_thirdtable_future5min_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd_flat0 !== null
                                      ? finalAvg_ofmaxof5min_nzd_flat0 + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd_flat0 !== null
                                      ? finalAvg_ofmaxof5min_nzd_flat0 + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {country === "JP"
                                ? finalAvg_ofmaxof5min_nzd_flat0 !== null
                                  ? Math.round(
                                      finalAvg_ofmaxof5min_nzd_flat0.toFixed(
                                        3
                                      ) * 1000
                                    )
                                  : "N/A"
                                : finalAvg_ofmaxof5min_nzd_flat0 !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_nzd_flat0.toFixed(5) *
                                      100000
                                  )
                                : "N/A"}
                              {/* {finalAvg_ofmaxof5min_nzd_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_nzd_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                            </td>
                          </>
                        )}

                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_usd_flat0 !== null
                              ? finalAvg_ofmaxof5min_usd_flat0 + "%"
                              : "N/A") ===
                            highest1hl_thirdtable_future5min_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_usd_flat0 !== null
                                  ? finalAvg_ofmaxof5min_usd_flat0 + "%"
                                  : "N/A") ===
                                highest2hl_thirdtable_future5min_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_usd_flat0 !== null
                                  ? finalAvg_ofmaxof5min_usd_flat0 + "%"
                                  : "N/A") ===
                                highest3hl_thirdtable_future5min_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : ""
                          }`}
                        >
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_usd_flat0 !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_usd_flat0.toFixed(3) *
                                    1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_usd_flat0 !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_usd_flat0.toFixed(5) *
                                  100000
                              )
                            : "N/A"}
                          {/* {finalAvg_ofmaxof5min_usd_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_usd_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                        </td>
                      </>
                    ) : (
                      <>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_aud_flat0 !== null
                              ? finalAvg_ofmaxof5min_aud_flat0 + "%"
                              : "N/A") ===
                            highest1hl_thirdtable_future5min_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_aud_flat0 !== null
                                  ? finalAvg_ofmaxof5min_aud_flat0 + "%"
                                  : "N/A") ===
                                highest2hl_thirdtable_future5min_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_aud_flat0 !== null
                                  ? finalAvg_ofmaxof5min_aud_flat0 + "%"
                                  : "N/A") ===
                                highest3hl_thirdtable_future5min_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {/* {finalAvg_ofmaxof5min_aud_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_aud_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_aud_flat0 !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_aud_flat0.toFixed(3) *
                                    1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_aud_flat0 !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_aud_flat0.toFixed(5) *
                                  100000
                              )
                            : "N/A"}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-4 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_cad_flat0 !== null
                              ? finalAvg_ofmaxof5min_cad_flat0 + "%"
                              : "N/A") ===
                            highest1hl_thirdtable_future5min_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_cad_flat0 !== null
                                  ? finalAvg_ofmaxof5min_cad_flat0 + "%"
                                  : "N/A") ===
                                highest2hl_thirdtable_future5min_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_cad_flat0 !== null
                                  ? finalAvg_ofmaxof5min_cad_flat0 + "%"
                                  : "N/A") ===
                                highest3hl_thirdtable_future5min_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {/* {finalAvg_ofmaxof5min_cad_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_cad_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_cad_flat0 !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_cad_flat0.toFixed(3) *
                                    1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_cad_flat0 !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_cad_flat0.toFixed(5) *
                                  100000
                              )
                            : "N/A"}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_chf_flat0 !== null
                              ? finalAvg_ofmaxof5min_chf_flat0 + "%"
                              : "N/A") ===
                            highest1hl_thirdtable_future5min_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_chf_flat0 !== null
                                  ? finalAvg_ofmaxof5min_chf_flat0 + "%"
                                  : "N/A") ===
                                highest2hl_thirdtable_future5min_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_chf_flat0 !== null
                                  ? finalAvg_ofmaxof5min_chf_flat0 + "%"
                                  : "N/A") ===
                                highest3hl_thirdtable_future5min_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {/* {finalAvg_ofmaxof5min_chf_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_chf_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_chf_flat0 !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_chf_flat0.toFixed(3) *
                                    1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_chf_flat0 !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_chf_flat0.toFixed(5) *
                                  100000
                              )
                            : "N/A"}
                        </td>
                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_eur_flat0 !== null
                              ? finalAvg_ofmaxof5min_eur_flat0 + "%"
                              : "N/A") ===
                            highest1hl_thirdtable_future5min_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_eur_flat0 !== null
                                  ? finalAvg_ofmaxof5min_eur_flat0 + "%"
                                  : "N/A") ===
                                highest2hl_thirdtable_future5min_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_eur_flat0 !== null
                                  ? finalAvg_ofmaxof5min_eur_flat0 + "%"
                                  : "N/A") ===
                                highest3hl_thirdtable_future5min_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : null
                          }`}
                        >
                          {/* {finalAvg_ofmaxof5min_eur_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_eur_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_eur_flat0 !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_eur_flat0.toFixed(3) *
                                    1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_eur_flat0 !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_eur_flat0.toFixed(5) *
                                  100000
                              )
                            : "N/A"}
                        </td>

                        {country === "US" || country === "NZ" ? (
                          <>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_nzd_flat0 !== null
                                  ? finalAvg_ofmaxof5min_nzd_flat0 + "%"
                                  : "N/A") ===
                                highest1hl_thirdtable_future5min_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd_flat0 !== null
                                      ? finalAvg_ofmaxof5min_nzd_flat0 + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd_flat0 !== null
                                      ? finalAvg_ofmaxof5min_nzd_flat0 + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {/* {finalAvg_ofmaxof5min_nzd_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_nzd_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                              {country === "JP"
                                ? finalAvg_ofmaxof5min_nzd_flat0 !== null
                                  ? Math.round(
                                      finalAvg_ofmaxof5min_nzd_flat0.toFixed(
                                        3
                                      ) * 1000
                                    )
                                  : "N/A"
                                : finalAvg_ofmaxof5min_nzd_flat0 !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_nzd_flat0.toFixed(5) *
                                      100000
                                  )
                                : "N/A"}
                            </td>

                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_jpy_flat0 !== null
                                  ? finalAvg_ofmaxof5min_jpy_flat0 + "%"
                                  : "N/A") ===
                                highest1hl_thirdtable_future5min_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy_flat0 !== null
                                      ? finalAvg_ofmaxof5min_jpy_flat0 + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy_flat0 !== null
                                      ? finalAvg_ofmaxof5min_jpy_flat0 + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {finalAvg_ofmaxof5min_jpy_flat0 !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_jpy_flat0.toFixed(3) *
                                      1000
                                  )
                                : "N/A"}
                              {/* {country === "JP"
                        ? finalAvg_ofmaxof5min_jpy_flat0 !== null
                          ? Math.round(
                              finalAvg_ofmaxof5min_jpy_flat0.toFixed(3) * 1000
                            )
                          : "N/A"
                        : finalAvg_ofmaxof5min_jpy_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_jpy_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                            </td>
                          </>
                        ) : (
                          <>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_jpy_flat0 !== null
                                  ? finalAvg_ofmaxof5min_jpy_flat0 + "%"
                                  : "N/A") ===
                                highest1hl_thirdtable_future5min_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy_flat0 !== null
                                      ? finalAvg_ofmaxof5min_jpy_flat0 + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_jpy_flat0 !== null
                                      ? finalAvg_ofmaxof5min_jpy_flat0 + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {finalAvg_ofmaxof5min_jpy_flat0 !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_jpy_flat0.toFixed(3) *
                                      1000
                                  )
                                : "N/A"}
                              {/* {country === "JP"
                        ? finalAvg_ofmaxof5min_jpy_flat0 !== null
                          ? Math.round(
                              finalAvg_ofmaxof5min_jpy_flat0.toFixed(3) * 1000
                            )
                          : "N/A"
                        : finalAvg_ofmaxof5min_jpy_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_jpy_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                            </td>
                            <td
                              className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                                (finalAvg_ofmaxof5min_nzd_flat0 !== null
                                  ? finalAvg_ofmaxof5min_nzd_flat0 + "%"
                                  : "N/A") ===
                                highest1hl_thirdtable_future5min_flat0
                                  ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd_flat0 !== null
                                      ? finalAvg_ofmaxof5min_nzd_flat0 + "%"
                                      : "N/A") ===
                                    highest2hl_thirdtable_future5min_flat0
                                  ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                                  : (finalAvg_ofmaxof5min_nzd_flat0 !== null
                                      ? finalAvg_ofmaxof5min_nzd_flat0 + "%"
                                      : "N/A") ===
                                    highest3hl_thirdtable_future5min_flat0
                                  ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                                  : null
                              }`}
                            >
                              {/* {finalAvg_ofmaxof5min_nzd_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_nzd_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                              {country === "JP"
                                ? finalAvg_ofmaxof5min_nzd_flat0 !== null
                                  ? Math.round(
                                      finalAvg_ofmaxof5min_nzd_flat0.toFixed(
                                        3
                                      ) * 1000
                                    )
                                  : "N/A"
                                : finalAvg_ofmaxof5min_nzd_flat0 !== null
                                ? Math.round(
                                    finalAvg_ofmaxof5min_nzd_flat0.toFixed(5) *
                                      100000
                                  )
                                : "N/A"}
                            </td>
                          </>
                        )}

                        <td
                          className={`text-[15px] py-2 border border-r-2 border-[#F6F6F6] ${
                            (finalAvg_ofmaxof5min_usd_flat0 !== null
                              ? finalAvg_ofmaxof5min_usd_flat0 + "%"
                              : "N/A") ===
                            highest1hl_thirdtable_future5min_flat0
                              ? "bg-[#4EA8D2]   text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_usd_flat0 !== null
                                  ? finalAvg_ofmaxof5min_usd_flat0 + "%"
                                  : "N/A") ===
                                highest2hl_thirdtable_future5min_flat0
                              ? "bg-[#77C9EF] text-[#240d3a] font-semibold"
                              : (finalAvg_ofmaxof5min_usd_flat0 !== null
                                  ? finalAvg_ofmaxof5min_usd_flat0 + "%"
                                  : "N/A") ===
                                highest3hl_thirdtable_future5min_flat0
                              ? "bg-[#A9ECFF] text-[#240d3a] font-semibold"
                              : ""
                          }`}
                        >
                          {/* {finalAvg_ofmaxof5min_usd_flat0 !== null
                        ? Math.round(
                            finalAvg_ofmaxof5min_usd_flat0.toFixed(5) * 100000
                          )
                        : "N/A"} */}
                          {country === "JP"
                            ? finalAvg_ofmaxof5min_usd_flat0 !== null
                              ? Math.round(
                                  finalAvg_ofmaxof5min_usd_flat0.toFixed(3) *
                                    1000
                                )
                              : "N/A"
                            : finalAvg_ofmaxof5min_usd_flat0 !== null
                            ? Math.round(
                                finalAvg_ofmaxof5min_usd_flat0.toFixed(5) *
                                  100000
                              )
                            : "N/A"}
                        </td>
                      </>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* <---today work--->16.05 */}

          {Loading_3rdtable ? (
            <div className="mt-5">
              <div className="font-semibold m-2 font-xl text-center flex justify-center items-center">
                Wait !! Correlation and Average Movement Tables are Loading ....
              </div>

              <div className="flex items-center justify-center  w-screen ">
                <RingLoader
                  height="80"
                  width="80"
                  color="#94A3B8"
                  ariaLabel="bars-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                  className=" flex items-center justify-center  mt-10 w-[100%]"
                />
              </div>
            </div>
          ) : (
            <>
              <div className="m-3  py-2 px-3  mt-4 flex ">
                <div className="relative inline-block ml-[2%] ">
                  {/* Icon */}

                  {showTooltip2 && (
                    <div className="fixed inset-0  backdrop-blur-[1px] z-10"></div>
                  )}
                  {/* Tooltip */}
                  {showTooltip2 && (
                    <div
                      ref={tooltipRef}
                      className="w-[250px] left-[160px] md:w-[514px] border-white rounded-[8px] bg-white absolute bottom-[155%] md:left-[454px] lg:left-[502px] transform -translate-x-1/2 z-30  text-[#240d3a] text-sm p-4  shadow-lg"
                    >
                      <div className="bg-[#f7f7f7] p-3 ">
                        <h1 className="m-1 text-[170E32] font-bold text-[18px]">
                          Non-Zero Events Definition:{" "}
                          <span className="text-[#5a2989] text-[14px]">
                            Actual release values differing from the estimated
                            value, and from the previous release value when
                            equal to the estimated value.{" "}
                          </span>
                        </h1>
                        <h1 className="mt-4 m-1 text-[170E32] font-bold text-[18px]">
                          Flat Events Definition:{" "}
                          <span className="text-[#5a2989] text-[14px]">
                            Actual release values are same as the estimated
                            value and the previous release value.{" "}
                          </span>
                        </h1>
                        <div className="sm:flex-col flex-col md:flex-col lg:flex-col xl:flex-col flex mt-[5%] sm:mt-[5%] md:mt-[5%] lg:mt-[0%] xl:mt-[0%]">
                          <div>
                            <h1 className="font-bold text-[#240d3a] text-[18px] mt-3 mx-[4px]">
                              Summary Color Key :{" "}
                            </h1>
                          </div>
                          <div className="mt-2">
                            <div className="flex items-center my-2">
                              <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                                Highest Average:
                              </h1>
                              <img
                                src={color1}
                                title="color"
                                alt="color"
                                className="ml-4 w-[25px] h-[27px]"
                              />
                              {/* <span className="font-bold ml-2">,</span> */}
                            </div>
                            <div className="flex items-center my-2">
                              <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                                {" "}
                                2nd Highest Average:
                              </h1>
                              <img
                                src={color2}
                                title="color"
                                alt="color"
                                className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                              />
                              {/* <span className="font-bold ml-2">,</span> */}
                            </div>
                            <div className="flex items-center my-2">
                              <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                                {" "}
                                3rd Highest Average:
                              </h1>
                              <img
                                src={color3}
                                title="color"
                                alt="color"
                                className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                              />
                              {/* <span className="ml-[8px]">,</span> */}
                            </div>
                          </div>
                        </div>

                        <div className="sm:flex-col flex-col md:flex-col lg:flex-col xl:flex-col flex mt-[5%] sm:mt-[5%] md:mt-[5%] lg:mt-[0%] xl:mt-[0%]">
                          <div>
                            <h1 className="font-bold text-[#240d3a] text-[18px] mt-3 mx-[4px]">
                              Table Color Key :{" "}
                            </h1>
                          </div>
                          <div className="mt-2">
                            <div className="flex items-center my-2">
                              <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                                {"Positive values :"}
                              </h1>
                              <img
                                src={color7}
                                title="color"
                                alt="color"
                                className="ml-4 w-[25px] h-[27px]"
                              />
                              {/* <span className="font-bold ml-2">,</span> */}
                            </div>
                            <div className="flex items-center my-2">
                              <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                                {" "}
                                {"Flat values:"}
                              </h1>
                              <img
                                src={color8}
                                title="color"
                                alt="color"
                                className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                              />
                              {/* <span className="font-bold ml-2">,</span> */}
                            </div>
                            <div className="flex items-center my-2">
                              <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
                                {" "}
                                {"Negative values:"}
                              </h1>
                              <img
                                src={color9}
                                title="color"
                                alt="color"
                                className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
                              />
                              {/* <span className="ml-[8px]">,</span> */}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Triangle Tip */}
                      <div className="absolute bottom-[-10px] left-[8%] transform -translate-x-1/2 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-white"></div>
                    </div>
                  )}
                </div>
                <h1 className=" ml-1 font-bold text-[20px] text-[#240d3a]">
                  Event Volatility Correlation
                </h1>
                <img
                  src={eye_btn_tooltip}
                  title="Information of Volatility Correlation Table"
                  alt="eye_btn_tooltip"
                  className="w-[24px] h-[27px]  cursor-pointer pb-2"
                  onClick={handleImageClick2}
                />
                :
              </div>

              {/* <------------------second table--------------> */}
              <div className="overflow-auto relative">
                {/* <div className="  mx-[3%] overflow-x-auto overflow-y-auto  max-h-[91vh] "> */}
                <div
                  className={`mx-[3%] overflow-x-auto overflow-y-auto relative ${
                    optionValue === "last 6"
                      ? "max-h-[91vh]"
                      : optionValue === "last 12"
                      ? "max-h-[130vh]"
                      : optionValue === "last 24"
                      ? "max-h-[214vh]"
                      : ""
                  }`}
                >
                  <table
                    className={` ${styles.tableuser} min-w-full  overflow-x-scroll m-auto  font-semibold `}
                  >
                    <thead className="bg-[#D2C2F0]   text-[#240d3a]  sticky top-0 z-5 text-[14px] font-semibold border-b-[12px] border-solid border-[#F6F6F6] rounded-[8px]  z-[99]">
                      <tr>
                        <th
                          className="bg-[#5a2989] h-[79.96] min-h-[79.96] border-r-2 border-r-white "
                          colSpan={11}
                        ></th>
                        <th
                          className="text-[18px] bg-[#5a2989] h-[79.96] min-h-[79.96] border-r-2 border-r-white  text-white"
                          colSpan={7}
                        >
                          {`Close price - Open Price ${
                            timeclickedurl_state === 1
                              ? "(1min)"
                              : timeclickedurl_state === 2
                              ? "(2min)"
                              : timeclickedurl_state === 5
                              ? "(5min)"
                              : timeclickedurl_state === 15
                              ? "(15min)"
                              : "(1min)"
                          }`}
                        </th>
                        <th
                          className="text-[18px] bg-[#5a2989] h-[79.96] min-h-[79.96] border-r-2 border-r-white  text-white"
                          colSpan={7}
                        >
                          {`Close price - Open Price (Post Release) ${
                            timeclickedurl_state === 1
                              ? "(1min)"
                              : timeclickedurl_state === 2
                              ? "(2min)"
                              : timeclickedurl_state === 5
                              ? "(5min)"
                              : timeclickedurl_state === 15
                              ? "(15min)"
                              : "(1min)"
                          }`}
                        </th>
                      </tr>
                      <tr className="h-[96px]">
                        <th className="sticky top-0 py-2 px-2">S. No</th>
                        <th className="sticky top-0 py-2 px-2">Date</th>
                        <th className="sticky top-0 py-2 px-2">Time(GMT)</th>
                        <th className="sticky top-0 py-2 px-2  min-w-[200px] w-[200px]">
                          Event count before this time
                        </th>
                        <th className="sticky top-0 py-2 px-2  min-w-[150px] w-[150px]">
                          Event count at this time
                        </th>

                        <th className="sticky top-0 py-2 px-2">Previous</th>

                        <th className="sticky top-0 py-2 px-2">Actual</th>
                        <th className="sticky top-0 py-2 px-2">Estimate</th>
                        <th className="sticky top-0 py-2 px-2  min-w-[97px] ">
                          Act - Prev
                        </th>
                        <th className="sticky top-0 py-2 px-2  border-r-4 border-[#F6F6F6] min-w-[98px] ">
                          Act - Est
                        </th>
                        <th className="sticky top-0 py-2 px-2  border-r-4 bg-[#b38dd3] bg-opacity-[56%] border-[#F6F6F6] min-w-[100px] ">
                          Final movement direction
                        </th>

                        {headers.map((header) => (
                          <th
                            key={header.id}
                            className="sticky top-0 py-2 px-2 bg-[#D2C2F0]   text-[#240d3a]"
                          >
                            {header.name}
                            <br />
                            {/* (C-O)
                                     <br /> */}
                            movement
                          </th>
                        ))}
                        {headers.map((header) => (
                          <th
                            key={header.id}
                            className="sticky top-0 py-2 px-2 bg-[#D2C2F0]   text-[#240d3a]"
                          >
                            {header.name}
                            <br />
                            {/* (C-O)
                                     <br /> */}
                            movement
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="bg-[#F6F6F6]  z-0 text-[#240d3a] font-bold text-[14px] relative">
                      {eventHistory.map((item, index) => {
                        const itemDate = item.date
                          .split(".")
                          .reverse()
                          .join(".");
                        let itemTime = item.time;

                        // if (selectedTime === 5) {
                        //   itemTime = roundDownToNearestMultipleOf5(item.time);
                        // } else if (selectedTime === 15) {
                        //   itemTime = roundDownToNearestMultipleOf15(item.time);
                        // } else if (selectedTime === 60) {
                        //   itemTime = roundDownToNearestMultipleOf1Hour(
                        //     item.time
                        //   );
                        // } else {
                        //   itemTime = moment(item.time, "HH:mm:ss")
                        //     .add(1, "minutes")
                        //     .format("HH:mm:ss");
                        // }

                        const usdEntry = usddata.find((entry) => {
                          return (
                            entry.date === itemDate && entry.time === itemTime
                          );
                        });

                        const jpyEntry = jpydata.find(
                          (entry) =>
                            entry.date === itemDate && entry.time === itemTime
                        );
                        const gbpnzdEntry = gbpnzddata.find(
                          (entry) =>
                            entry.date === itemDate && entry.time === itemTime
                        );
                        const eurgbpEntry = eurgbpdata.find(
                          (entry) =>
                            entry.date === itemDate && entry.time === itemTime
                        );
                        const gbpchfEntry = gbpchfdata.find(
                          (entry) =>
                            entry.date === itemDate && entry.time === itemTime
                        );
                        const gbpaudEntry = gbpauddata.find(
                          (entry) =>
                            entry.date === itemDate && entry.time === itemTime
                        );
                        const gbpcadEntry = gbpcaddata.find(
                          (entry) =>
                            entry.date === itemDate && entry.time === itemTime
                        );

                        const usdOpen = usdEntry ? usdEntry.Open : "N/A";
                        const usdClose = usdEntry ? usdEntry.Close : "N/A";
                        const usdLow = usdEntry ? usdEntry.Low : "N/A";
                        const usdHigh = usdEntry ? usdEntry.High : "N/A";

                        const diff =
                          usdOpen !== "N/A" && usdClose !== "N/A"
                            ? usdClose - usdOpen
                            : "N/A";

                        const diff2 =
                          usdOpen !== "N/A" && usdLow !== "N/A"
                            ? usdLow - usdOpen
                            : "N/A";
                        const diff3 =
                          usdOpen !== "N/A" && usdHigh !== "N/A"
                            ? usdHigh - usdOpen
                            : "N/A";

                        const jpyOpen = jpyEntry ? jpyEntry.Open : "N/A";
                        const jpyClose = jpyEntry ? jpyEntry.Close : "N/A";
                        const jpyLow = jpyEntry ? jpyEntry.Low : "N/A";
                        const jpyHigh = jpyEntry ? jpyEntry.High : "N/A";

                        const jpydiff =
                          jpyOpen !== "N/A" && jpyClose !== "N/A"
                            ? jpyClose - jpyOpen
                            : "N/A";
                        const jpydiff2 =
                          jpyOpen !== "N/A" && jpyLow !== "N/A"
                            ? jpyLow - jpyOpen
                            : "N/A";
                        const jpydiff3 =
                          jpyOpen !== "N/A" && jpyHigh !== "N/A"
                            ? jpyHigh - jpyOpen
                            : "N/A";

                        const nzdOpen = gbpnzdEntry ? gbpnzdEntry.Open : "N/A";
                        const nzdClose = gbpnzdEntry
                          ? gbpnzdEntry.Close
                          : "N/A";
                        const nzdLow = gbpnzdEntry ? gbpnzdEntry.Low : "N/A";
                        const nzdHigh = gbpnzdEntry ? gbpnzdEntry.High : "N/A";

                        const diffnzdgbp =
                          nzdOpen !== "N/A" && nzdClose !== "N/A"
                            ? nzdClose - nzdOpen
                            : "N/A";

                        const diff2nzdgbp =
                          nzdOpen !== "N/A" && nzdLow !== "N/A"
                            ? nzdLow - nzdOpen
                            : "N/A";
                        const diff3nzdgbp =
                          nzdOpen !== "N/A" && nzdHigh !== "N/A"
                            ? nzdHigh - nzdOpen
                            : "N/A";

                        const eurgbpOpen = eurgbpEntry
                          ? eurgbpEntry.Open
                          : "N/A";
                        const eurgbpClose = eurgbpEntry
                          ? eurgbpEntry.Close
                          : "N/A";
                        const eurgbpLow = eurgbpEntry ? eurgbpEntry.Low : "N/A";
                        const eurgbpHigh = eurgbpEntry
                          ? eurgbpEntry.High
                          : "N/A";

                        const diffeurgbp =
                          eurgbpOpen !== "N/A" && eurgbpClose !== "N/A"
                            ? eurgbpClose - eurgbpOpen
                            : "N/A";

                        const diff2eurgbp =
                          eurgbpOpen !== "N/A" && eurgbpLow !== "N/A"
                            ? eurgbpLow - eurgbpOpen
                            : "N/A";
                        const diff3eurgbp =
                          eurgbpOpen !== "N/A" && eurgbpHigh !== "N/A"
                            ? eurgbpHigh - eurgbpOpen
                            : "N/A";

                        const gbpchfOpen = gbpchfEntry
                          ? gbpchfEntry.Open
                          : "N/A";
                        const gbpchfClose = gbpchfEntry
                          ? gbpchfEntry.Close
                          : "N/A";
                        const gbpchfLow = gbpchfEntry ? gbpchfEntry.Low : "N/A";
                        const gbpchfHigh = gbpchfEntry
                          ? gbpchfEntry.High
                          : "N/A";

                        const diffgbpchf =
                          gbpchfOpen !== "N/A" && gbpchfClose !== "N/A"
                            ? gbpchfClose - gbpchfOpen
                            : "N/A";

                        const diff2gbpchf =
                          gbpchfOpen !== "N/A" && gbpchfLow !== "N/A"
                            ? gbpchfLow - gbpchfOpen
                            : "N/A";
                        const diff3gbpchf =
                          gbpchfOpen !== "N/A" && gbpchfHigh !== "N/A"
                            ? gbpchfHigh - gbpchfOpen
                            : "N/A";

                        const gbpaudOpen = gbpaudEntry
                          ? gbpaudEntry.Open
                          : "N/A";
                        const gbpaudClose = gbpaudEntry
                          ? gbpaudEntry.Close
                          : "N/A";
                        const gbpaudLow = gbpaudEntry ? gbpaudEntry.Low : "N/A";
                        const gbpaudHigh = gbpaudEntry
                          ? gbpaudEntry.High
                          : "N/A";

                        const diffgbpaud =
                          gbpaudOpen !== "N/A" && gbpaudClose !== "N/A"
                            ? gbpaudClose - gbpaudOpen
                            : "N/A";

                        const diff2gbpaud =
                          gbpaudOpen !== "N/A" && gbpaudLow !== "N/A"
                            ? gbpaudLow - gbpaudOpen
                            : "N/A";
                        const diff3gbpaud =
                          gbpaudOpen !== "N/A" && gbpaudHigh !== "N/A"
                            ? gbpaudHigh - gbpaudOpen
                            : "N/A";

                        const gbpcadOpen = gbpcadEntry
                          ? gbpcadEntry.Open
                          : "N/A";
                        const gbpcadClose = gbpcadEntry
                          ? gbpcadEntry.Close
                          : "N/A";
                        const gbpcadLow = gbpcadEntry ? gbpcadEntry.Low : "N/A";
                        const gbpcadHigh = gbpcadEntry
                          ? gbpcadEntry.High
                          : "N/A";

                        const diffgbpcad =
                          gbpcadOpen !== "N/A" && gbpcadClose !== "N/A"
                            ? gbpcadClose - gbpcadOpen
                            : "N/A";

                        const diff2gbpcad =
                          gbpcadOpen !== "N/A" && gbpcadLow !== "N/A"
                            ? gbpcadLow - gbpcadOpen
                            : "N/A";
                        const diff3gbpcad =
                          gbpcadOpen !== "N/A" && gbpcadHigh !== "N/A"
                            ? gbpcadHigh - gbpcadOpen
                            : "N/A";

                        // <----------------------------------------code of 2nd table------------------------->

                        const comparedataactminusest =
                          item.actual - item.estimate === 0 ||
                          item.estimate === null ||
                          item.estimate === ""
                            ? item.actual - item.previous > 0
                              ? "+"
                              : item.actual - item.previous === 0
                              ? ""
                              : "-"
                            : item.actual - item.estimate > 0
                            ? "+"
                            : item.actual - item.estimate === 0
                            ? ""
                            : "-";

                        const compareddatagbpusdcomove =
                          typeof diff === "number"
                            ? (
                                country === "JP"
                                  ? diff.toFixed(3) === "0.000" ||
                                    diff.toFixed(3) === "-0.000"
                                  : diff.toFixed(5) === "0.00000" ||
                                    diff.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diff === "number" && diff > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpcousd =
                          comparedataactminusest === "-" &&
                          compareddatagbpusdcomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpusdcomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpusdcomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpusdcomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpusdcomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpusdcomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpusdcomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpusdcomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpusdcomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpusdcomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpusdcomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpusd.push(finalmovemntgbpcousd);

                        const compareddatagbpjpycomove =
                          typeof jpydiff === "number"
                            ? jpydiff.toFixed(3) === "0.000" ||
                              jpydiff.toFixed(3) === "-0.000"
                              ? ""
                              : typeof jpydiff === "number" && jpydiff > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpjpyco =
                          comparedataactminusest === "-" &&
                          compareddatagbpjpycomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpjpycomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpjpycomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpjpycomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpjpycomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpjpycomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpjpycomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpjpycomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpjpycomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpjpycomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpjpycomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpjpy.push(finalmovemntgbpjpyco);

                        const compareddatagbpnzdcomove =
                          typeof diffnzdgbp === "number"
                            ? (
                                country === "JP"
                                  ? diffnzdgbp.toFixed(3) === "0.000" ||
                                    diffnzdgbp.toFixed(3) === "-0.000"
                                  : diffnzdgbp.toFixed(5) === "0.00000" ||
                                    diffnzdgbp.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diffnzdgbp === "number" && diffnzdgbp > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpnzdco =
                          comparedataactminusest === "-" &&
                          compareddatagbpnzdcomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpnzdcomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpnzdcomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpnzdcomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpnzdcomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpnzdcomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpnzdcomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpnzdcomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpnzdcomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpnzdcomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpnzdcomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpnzd.push(finalmovemntgbpnzdco);

                        const compareddatagbpeurcomove =
                          typeof diffeurgbp === "number"
                            ? (
                                country === "JP"
                                  ? diffeurgbp.toFixed(3) === "0.000" ||
                                    diffeurgbp.toFixed(3) === "-0.000"
                                  : diffeurgbp.toFixed(5) === "0.00000" ||
                                    diffeurgbp.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diffeurgbp === "number" && diffeurgbp > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpeurco =
                          comparedataactminusest === "-" &&
                          compareddatagbpeurcomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpeurcomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpeurcomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpeurcomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpeurcomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpeurcomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpeurcomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpeurcomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpeurcomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpeurcomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpeurcomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpeur.push(finalmovemntgbpeurco);

                        const compareddatagbpchfcomove =
                          typeof diffgbpchf === "number"
                            ? (
                                country === "JP"
                                  ? diffgbpchf.toFixed(3) === "0.000" ||
                                    diffgbpchf.toFixed(3) === "-0.000"
                                  : diffgbpchf.toFixed(5) === "0.00000" ||
                                    diffgbpchf.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diffgbpchf === "number" && diffgbpchf > 0
                              ? "+"
                              : "-"
                            : "N/A";
                        const finalmovemntgbpchfco =
                          comparedataactminusest === "-" &&
                          compareddatagbpchfcomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpchfcomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpchfcomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpchfcomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpchfcomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpchfcomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpchfcomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpchfcomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpchfcomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpchfcomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpchfcomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpchf.push(finalmovemntgbpchfco);

                        const compareddatagbpaudcomove =
                          typeof diffgbpaud === "number"
                            ? (
                                country === "JP"
                                  ? diffgbpaud.toFixed(3) === "0.000" ||
                                    diffgbpaud.toFixed(3) === "-0.000"
                                  : diffgbpaud.toFixed(5) === "0.00000" ||
                                    diffgbpaud.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diffgbpaud === "number" && diffgbpaud > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpaudco =
                          comparedataactminusest === "-" &&
                          compareddatagbpaudcomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpaudcomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpaudcomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpaudcomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpaudcomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpaudcomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpaudcomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpaudcomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpaudcomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpaudcomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpaudcomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpaud.push(finalmovemntgbpaudco);

                        const compareddatagbpcadcomove =
                          typeof diffgbpcad === "number"
                            ? (
                                country === "JP"
                                  ? diffgbpcad.toFixed(3) === "0.000" ||
                                    diffgbpcad.toFixed(3) === "-0.000"
                                  : diffgbpcad.toFixed(5) === "0.00000" ||
                                    diffgbpcad.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diffgbpcad === "number" && diffgbpcad > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpcadco =
                          comparedataactminusest === "-" &&
                          compareddatagbpcadcomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpcadcomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpcadcomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpcadcomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpcadcomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpcadcomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpcadcomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpcadcomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpcadcomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpcadcomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpcadcomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpcad.push(finalmovemntgbpcadco);

                        // <------------------------hlo am the second block here for LO========================>
                        const compareddatagbpusdlomove =
                          typeof diff2 === "number"
                            ? (
                                country === "JP"
                                  ? diff2.toFixed(3) === "0.000" ||
                                    diff2.toFixed(3) === "-0.000"
                                  : diff2.toFixed(5) === "0.00000" ||
                                    diff2.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diff2 === "number" && diff2 > 0
                              ? "+"
                              : "-"
                            : "N/A";
                        const finalmovemntgbplousd =
                          comparedataactminusest === "-" &&
                          compareddatagbpusdlomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpusdlomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpusdlomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpusdlomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpusdlomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpusdlomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpusdlomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpusdlomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpusdlomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpusdlomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpusdlomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpusdlo.push(finalmovemntgbplousd);

                        const compareddatagbpjpylomove =
                          typeof jpydiff2 === "number"
                            ? jpydiff2.toFixed(3) === "0.000" ||
                              jpydiff2.toFixed(3) === "-0.000"
                              ? ""
                              : typeof jpydiff2 === "number" && jpydiff2 > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpjpylo =
                          comparedataactminusest === "-" &&
                          compareddatagbpjpylomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpjpylomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpjpylomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpjpylomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpjpylomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpjpylomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpjpylomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpjpylomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpjpylomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpjpylomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpjpylomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpjpylo.push(finalmovemntgbpjpylo);

                        const compareddatagbpnzdlomove =
                          typeof diff2nzdgbp === "number"
                            ? (
                                country === "JP"
                                  ? diff2nzdgbp.toFixed(3) === "0.000" ||
                                    diff2nzdgbp.toFixed(3) === "-0.000"
                                  : diff2nzdgbp.toFixed(5) === "0.00000" ||
                                    diff2nzdgbp.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diff2nzdgbp === "number" &&
                                diff2nzdgbp > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpnzdlo =
                          comparedataactminusest === "-" &&
                          compareddatagbpnzdlomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpnzdlomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpnzdlomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpnzdlomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpnzdlomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpnzdlomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpnzdlomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpnzdlomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpnzdlomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpnzdlomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpnzdlomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpnzdlo.push(finalmovemntgbpnzdlo);

                        const compareddatagbpeurlomove =
                          typeof diff2eurgbp === "number"
                            ? (
                                country === "JP"
                                  ? diff2eurgbp.toFixed(3) === "0.000" ||
                                    diff2eurgbp.toFixed(3) === "-0.000"
                                  : diff2eurgbp.toFixed(5) === "0.00000" ||
                                    diff2eurgbp.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diff2eurgbp === "number" &&
                                diff2eurgbp > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpeurlo =
                          comparedataactminusest === "-" &&
                          compareddatagbpeurlomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpeurlomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpeurlomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpeurlomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpeurlomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpeurlomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpeurlomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpeurlomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpeurlomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpeurlomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpeurlomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpeurlo.push(finalmovemntgbpeurlo);

                        const compareddatagbpchflomove =
                          typeof diff2gbpchf === "number"
                            ? (
                                country === "JP"
                                  ? diff2gbpchf.toFixed(3) === "0.000" ||
                                    diff2gbpchf.toFixed(3) === "-0.000"
                                  : diff2gbpchf.toFixed(5) === "0.00000" ||
                                    diff2gbpchf.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diff2gbpchf === "number" &&
                                diff2gbpchf > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpchflo =
                          comparedataactminusest === "-" &&
                          compareddatagbpchflomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpchflomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpchflomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpchflomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpchflomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpchflomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpchflomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpchflomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpchflomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpchflomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpchflomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpchflo.push(finalmovemntgbpchflo);

                        const compareddatagbpaudlomove =
                          typeof diff2gbpaud === "number"
                            ? (
                                country === "JP"
                                  ? diff2gbpaud.toFixed(3) === "0.000" ||
                                    diff2gbpaud.toFixed(3) === "-0.000"
                                  : diff2gbpaud.toFixed(5) === "0.00000" ||
                                    diff2gbpaud.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diff2gbpaud === "number" &&
                                diff2gbpaud > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpaudlo =
                          comparedataactminusest === "-" &&
                          compareddatagbpaudlomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpaudlomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpaudlomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpaudlomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpaudlomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpaudlomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpaudlomove === "-"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpaudlomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpaudlomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpaudlomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpaudlo.push(finalmovemntgbpaudlo);

                        const compareddatagbpcadlomove =
                          typeof diff2gbpcad === "number"
                            ? (
                                country === "JP"
                                  ? diff2gbpcad.toFixed(3) === "0.000" ||
                                    diff2gbpcad.toFixed(3) === "-0.000"
                                  : diff2gbpcad.toFixed(5) === "0.00000" ||
                                    diff2gbpcad.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diff2gbpcad === "number" &&
                                diff2gbpcad > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpcadlo =
                          comparedataactminusest === "-" &&
                          compareddatagbpcadlomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpcadlomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpcadlomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpcadlomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpcadlomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpcadlomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpcadlomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpcadlomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpcadlomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpcadlomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpcadlomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpcadlo.push(finalmovemntgbpcadlo);

                        // <----------------------hlo am 3rd block here for HO---------------->
                        const compareddatagbpusdhomove =
                          typeof diff3 === "number"
                            ? (
                                country === "JP"
                                  ? diff3.toFixed(3) === "0.000" ||
                                    diff3.toFixed(3) === "-0.000"
                                  : diff3.toFixed(5) === "0.00000" ||
                                    diff3.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diff3 === "number" && diff3 > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbphousd =
                          comparedataactminusest === "-" &&
                          compareddatagbpusdhomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpusdhomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpusdhomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpusdhomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpusdhomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpusdhomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpusdhomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpusdhomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpusdhomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpusdhomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpusdhomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpusdho.push(finalmovemntgbphousd);

                        const compareddatagbpjpyhomove =
                          typeof jpydiff3 === "number"
                            ? jpydiff3.toFixed(3) === "0.000" ||
                              jpydiff3.toFixed(3) === "-0.000"
                              ? ""
                              : typeof jpydiff3 === "number" && jpydiff3 > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpjpyho =
                          comparedataactminusest === "-" &&
                          compareddatagbpjpyhomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpjpyhomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpjpyhomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpjpyhomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpjpyhomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpjpyhomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpjpyhomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpjpyhomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpjpyhomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpjpyhomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpjpyhomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpjpyho.push(finalmovemntgbpjpyho);

                        const compareddatagbpnzdhomove =
                          typeof diff3nzdgbp === "number"
                            ? (
                                country === "JP"
                                  ? diff3nzdgbp.toFixed(3) === "0.000" ||
                                    diff3nzdgbp.toFixed(3) === "-0.000"
                                  : diff3nzdgbp.toFixed(5) === "0.00000" ||
                                    diff3nzdgbp.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diff3nzdgbp === "number" &&
                                diff3nzdgbp > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpnzdho =
                          comparedataactminusest === "-" &&
                          compareddatagbpnzdhomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpnzdhomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpnzdhomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpnzdhomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpnzdhomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpnzdhomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpnzdhomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpnzdhomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpnzdhomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpnzdhomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpnzdhomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpnzdho.push(finalmovemntgbpnzdho);

                        const compareddatagbpeurhomove =
                          typeof diff3eurgbp === "number"
                            ? (
                                country === "JP"
                                  ? diff3eurgbp.toFixed(3) === "0.000" ||
                                    diff3eurgbp.toFixed(3) === "-0.000"
                                  : diff3eurgbp.toFixed(5) === "0.00000" ||
                                    diff3eurgbp.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diff3eurgbp === "number" &&
                                diff3eurgbp > 0
                              ? "+"
                              : "-"
                            : "N/A";
                        const finalmovemntgbpeurho =
                          comparedataactminusest === "-" &&
                          compareddatagbpeurhomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpeurhomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpeurhomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpeurhomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpeurhomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpeurhomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpeurhomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpeurhomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpeurhomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpeurhomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpeurhomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpeurho.push(finalmovemntgbpeurho);

                        const compareddatagbpchfhomove =
                          typeof diff3gbpchf === "number"
                            ? (
                                country === "JP"
                                  ? diff3gbpchf.toFixed(3) === "0.000" ||
                                    diff3gbpchf.toFixed(3) === "-0.000"
                                  : diff3gbpchf.toFixed(5) === "0.00000" ||
                                    diff3gbpchf.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diff3gbpchf === "number" &&
                                diff3gbpchf > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpchfho =
                          comparedataactminusest === "-" &&
                          compareddatagbpchfhomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpchfhomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpchfhomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpchfhomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpchfhomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpchfhomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpchfhomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpchfhomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpchfhomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpchfhomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpchfhomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpchfho.push(finalmovemntgbpchfho);

                        const compareddatagbpaudhomove =
                          typeof diff3gbpaud === "number"
                            ? (
                                country === "JP"
                                  ? diff3gbpaud.toFixed(3) === "0.000" ||
                                    diff3gbpaud.toFixed(3) === "-0.000"
                                  : diff3gbpaud.toFixed(5) === "0.00000" ||
                                    diff3gbpaud.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diff3gbpaud === "number" &&
                                diff3gbpaud > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpaudho =
                          comparedataactminusest === "-" &&
                          compareddatagbpaudhomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpaudhomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpaudhomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpaudhomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpaudhomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpaudhomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpaudhomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpaudhomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpaudhomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpaudhomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpaudhomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpaudho.push(finalmovemntgbpaudho);

                        const compareddatagbpcadhomove =
                          typeof diff3gbpcad === "number"
                            ? (
                                country === "JP"
                                  ? diff3gbpcad.toFixed(3) === "0.000" ||
                                    diff3gbpcad.toFixed(3) === "-0.000"
                                  : diff3gbpcad.toFixed(5) === "0.00000" ||
                                    diff3gbpcad.toFixed(5) === "-0.00000"
                              )
                              ? ""
                              : typeof diff3gbpcad === "number" &&
                                diff3gbpcad > 0
                              ? "+"
                              : "-"
                            : "N/A";

                        const finalmovemntgbpcadho =
                          comparedataactminusest === "-" &&
                          compareddatagbpcadhomove === "-"
                            ? "+"
                            : comparedataactminusest === "" &&
                              compareddatagbpcadhomove === "-"
                            ? "--"
                            : comparedataactminusest === "-" &&
                              compareddatagbpcadhomove === ""
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpcadhomove === "+"
                            ? "-"
                            : comparedataactminusest === "" &&
                              compareddatagbpcadhomove === "+"
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpcadhomove === ""
                            ? "+"
                            : comparedataactminusest === "+" &&
                              compareddatagbpcadhomove === "-"
                            ? "-"
                            : comparedataactminusest === "-" &&
                              compareddatagbpcadhomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpcadhomove === ""
                            ? "++"
                            : comparedataactminusest === "+" &&
                              compareddatagbpcadhomove === "N/A"
                            ? "N/A"
                            : comparedataactminusest === "" &&
                              compareddatagbpcadhomove === "N/A"
                            ? "N/A"
                            : "+";

                        arraygbpcadho.push(finalmovemntgbpcadho);

                        const itemDatecheck = item.date.split(" ")[0];

                        // Filtering impacthighlow array to find the matching data
                        const matchingData = impacthighlow.find((data) =>
                          data.startsWith(itemDatecheck)
                        );

                        const normalizeDate = (dateStr) => {
                          return dateStr.split(" ")[0];
                        };

                        const filterImpactData = (date) => {
                          const normalizedDate = normalizeDate(date);

                          return impacthighlowbeforethis.filter((impact) => {
                            const impactDate = impact.split(":")[0];

                            return impactDate === normalizedDate;
                          });
                        };

                        const impactData = filterImpactData(item.date);

                        return (
                          <>
                            <tr
                              key={index}
                              className=" cursor-pointer  text-center bg-white  border-y-[16px] border-solid border-[#F6F6F6] relative"
                            >
                              <td className="py-2 min-w-[81px]">
                                {index + 1}.
                              </td>
                              <td className="py-2 ">{item.date}</td>
                              <td className="py-2 ">{item.time.slice(0, 5)}</td>

                              {run_modalloader ? (
                                <td>
                                  {" "}
                                  <span className="loader1 text-[#1c72ca] text-center min-w-[200px] w-[200px]">
                                    Loading...
                                  </span>
                                </td>
                              ) : (
                                <>
                                  <td
                                    className="py-2  text-[13px] min-w-[200px] w-[200px] relative cursor-pointer"
                                    onClick={() =>
                                      handleShowModalbeforetime_2nd_table(
                                        item.date
                                      )
                                    }
                                  >
                                    {impactData.length > 0 ? (
                                      impactData.map((impact, i) => {
                                        const impactParts = impact.split(" ");
                                        // Remove the first element (date and time)
                                        const formattedImpact = impactParts
                                          .slice(1)
                                          .join(" ");

                                        return (
                                          <span
                                            key={i}
                                            className="font-bold block"
                                          >
                                            {formattedImpact}
                                          </span>
                                        );
                                      })
                                    ) : (
                                      <span className="font-bold">No Data</span>
                                    )}
                                  </td>

                                  <dialog
                                    id="my_modal_2_2nd_table"
                                    onClick={() => {
                                      autoClickButton_2nd_table();
                                    }}
                                    className={` ${styles.addmodalDirection_eventhistory_2ndTable} modal p-6 absolute max-h-[60vh] top-[200%] sm:top-[200%] md:top-[200%] lg:top-[147%] xl:top-[147%] shadow-[#ba9696] shadow-opacity-10 shadow-lg rounded-lg`}
                                  >
                                    <form
                                      method="dialog"
                                      className="modal- w-[300px] relative top-[-10px] bg-white right-[-6px] text-right"
                                    >
                                      <div className="modal-box relative top-[3px]">
                                        <div
                                          onClick={() => {
                                            autoClickButton_2nd_table();
                                          }}
                                        >
                                          <button id="aashima_id_2nd_table">
                                            <img
                                              alt="img"
                                              src={crossicon}
                                              className="w-[20px] h-[20px]"
                                            ></img>
                                          </button>
                                        </div>
                                        <div>
                                          {filteredModalData.length > 0 ? (
                                            <>
                                              {/* High Impact */}
                                              {filteredModalData.some(
                                                (data) =>
                                                  data.impact.toLowerCase() ===
                                                  "high"
                                              ) && (
                                                <div className="text-center flex items-center justify-center">
                                                  <h3 className="font-bold text-lg mt-4 mb-4 border-red-300 py-2 px-4 rounded-xl border-2 bg-red-300 w-[193px]">
                                                    High Impact :-
                                                  </h3>
                                                </div>
                                              )}
                                              {filteredModalData.map(
                                                (data, index) => {
                                                  if (
                                                    data.impact.toLowerCase() ===
                                                    "high"
                                                  ) {
                                                    return (
                                                      <div
                                                        key={index}
                                                        className="text-start pl-[20px] my-4"
                                                      >
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Date:
                                                          </span>{" "}
                                                          {data.date}
                                                        </p>
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Time:{" "}
                                                          </span>
                                                          {data.time}
                                                        </p>
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Country:{" "}
                                                          </span>
                                                          {data.country}
                                                        </p>
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Event:{" "}
                                                          </span>
                                                          {data.event}
                                                        </p>
                                                        <hr />
                                                      </div>
                                                    );
                                                  }
                                                  return null;
                                                }
                                              )}

                                              {/* Medium Impact */}
                                              {filteredModalData.some(
                                                (data) =>
                                                  data.impact.toLowerCase() ===
                                                  "medium"
                                              ) && (
                                                <div className="text-center flex items-center justify-center">
                                                  <h3 className="font-bold text-lg mt-4 mb-4 border-red-300 py-2 px-4 rounded-xl border-2 bg-red-300">
                                                    Medium Impact :-
                                                  </h3>
                                                </div>
                                              )}
                                              {filteredModalData.map(
                                                (data, index) => {
                                                  if (
                                                    data.impact.toLowerCase() ===
                                                    "medium"
                                                  ) {
                                                    return (
                                                      <div
                                                        key={index}
                                                        className="text-start pl-[20px] my-4"
                                                      >
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Date:
                                                          </span>{" "}
                                                          {data.date}
                                                        </p>
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Time:{" "}
                                                          </span>
                                                          {data.time}
                                                        </p>
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Country:
                                                          </span>{" "}
                                                          {data.country}
                                                        </p>
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Event:
                                                          </span>{" "}
                                                          {data.event}
                                                        </p>
                                                        <hr />
                                                      </div>
                                                    );
                                                  }
                                                  return null;
                                                }
                                              )}
                                            </>
                                          ) : (
                                            <p className="text-center mt-4">
                                              No Data
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    </form>
                                  </dialog>
                                </>
                              )}

                              {run_modalloader ? (
                                <td>
                                  <span className="loader1 text-[#1c72ca] text-center min-w-[150px] w-[150px]">
                                    Loading...
                                  </span>
                                </td>
                              ) : (
                                <>
                                  {" "}
                                  <td
                                    className=" py-2 px-4  min-w-[140px] relative cursor-pointer"
                                    onClick={() =>
                                      handleShowModalontime_2nd_table(item.date)
                                    }
                                  >
                                    {matchingData && (
                                      <span className="font-bold  text-[13px]">
                                        {matchingData.includes(": ")
                                          ? matchingData.substring(
                                              matchingData.indexOf(": ") + 2
                                            )
                                          : matchingData}
                                      </span>
                                    )}
                                  </td>
                                  <dialog
                                    id="my_modal_3_2nd_table"
                                    onClick={() => {
                                      autoClickButton1_2nd_table();
                                    }}
                                    className={` ${styles.addmodalDirection_eventhistory_2ndTable} modal p-6 absolute max-h-[60vh] top-[200%] sm:top-[200%] md:top-[200%] lg:top-[147%] xl:top-[147%] shadow-[#ba9696] shadow-opacity-10 shadow-lg rounded-lg `}
                                  >
                                    <form
                                      method="dialog"
                                      className="modal- w-[300px] relative top-[-10px] right-[-6px] text-right"
                                    >
                                      <div className="modal-box relative top-[6px]">
                                        <div
                                          onClick={() => {
                                            autoClickButton1_2nd_table();
                                          }}
                                        >
                                          <button id="closemod11__2nd_table">
                                            <img
                                              alt="img"
                                              src={crossicon}
                                              className="w-[20px] h-[20px]"
                                            ></img>
                                          </button>
                                        </div>
                                        <div>
                                          {filteredModalDataontime.length >
                                          0 ? (
                                            <>
                                              {/* High Impact */}
                                              {filteredModalDataontime.some(
                                                (data) =>
                                                  data.impact.toLowerCase() ===
                                                  "high"
                                              ) && (
                                                <div className="text-center flex items-center justify-center">
                                                  <h3 className="font-bold text-lg mt-4 mb-4 border-red-300 py-2 px-4 rounded-xl border-2 bg-red-300 w-[193px]">
                                                    High Impact :-
                                                  </h3>
                                                </div>
                                              )}
                                              {filteredModalDataontime.map(
                                                (data, index) => {
                                                  if (
                                                    data.impact.toLowerCase() ===
                                                    "high"
                                                  ) {
                                                    return (
                                                      <div
                                                        key={index}
                                                        className="text-start pl-[20px] my-4"
                                                      >
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Date:
                                                          </span>{" "}
                                                          {data.date}
                                                        </p>
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Time:{" "}
                                                          </span>
                                                          {data.time}
                                                        </p>
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Country:{" "}
                                                          </span>
                                                          {data.country}
                                                        </p>
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Event:{" "}
                                                          </span>
                                                          {data.event}
                                                        </p>
                                                        <hr />
                                                      </div>
                                                    );
                                                  }
                                                  return null;
                                                }
                                              )}

                                              {/* Medium Impact */}
                                              {filteredModalDataontime.some(
                                                (data) =>
                                                  data.impact.toLowerCase() ===
                                                  "medium"
                                              ) && (
                                                <div className="text-center flex items-center justify-center">
                                                  <h3 className="font-bold text-lg mt-4 mb-4 border-red-300 py-2 px-4 rounded-xl border-2 bg-red-300">
                                                    Medium Impact :-
                                                  </h3>
                                                </div>
                                              )}
                                              {filteredModalDataontime.map(
                                                (data, index) => {
                                                  if (
                                                    data.impact.toLowerCase() ===
                                                    "medium"
                                                  ) {
                                                    return (
                                                      <div
                                                        key={index}
                                                        className="text-start pl-[20px] my-4"
                                                      >
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Date:
                                                          </span>{" "}
                                                          {data.date}
                                                        </p>
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Time:{" "}
                                                          </span>
                                                          {data.time}
                                                        </p>
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Country:
                                                          </span>{" "}
                                                          {data.country}
                                                        </p>
                                                        <p>
                                                          <span className="font-semibold pr-2 text-[#240d3a]">
                                                            Event:
                                                          </span>{" "}
                                                          {data.event}
                                                        </p>
                                                        <hr />
                                                      </div>
                                                    );
                                                  }
                                                  return null;
                                                }
                                              )}
                                            </>
                                          ) : (
                                            <p className="text-center mt-4">
                                              No Data
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    </form>
                                  </dialog>
                                </>
                              )}

                              <td className="py-2">{item.previous || ""}</td>
                              <td className="py-2">{item.actual || ""}</td>
                              <td className="py-2">{item.estimate || ""}</td>

                              <td
                                className={`py-2 text-[#240d3a] font-semibold border-r-2 border-[#F6F6F6] ${
                                  item.previous === null || item.previous === ""
                                    ? "bg-[#E5E7EB]" // N/A case:
                                    : item.actual - item.previous > 0
                                    ? "bg-[#5de98e]"
                                    : item.actual - item.previous === 0
                                    ? "bg-[#f1d500]"
                                    : "bg-[#ff8e8ef2]"
                                }`}
                              >
                                {item.previous === null ||
                                item.previous === "" ? (
                                  ""
                                ) : (
                                  <>
                                    {item.actual - item.previous > 0
                                      ? "+"
                                      : item.actual - item.previous === 0
                                      ? ""
                                      : "-"}
                                  </>
                                )}
                              </td>

                              <td
                                className={`py-2  text-[#240d3a] font-semibold   border-r-4 border-[#F6F6F6] ${
                                  item.estimate === null || item.estimate === ""
                                    ? "bg-[#E5E7EB]" // N/A case:
                                    : item.actual - item.estimate > 0
                                    ? "bg-[#5de98e]"
                                    : item.actual - item.estimate === 0
                                    ? "bg-[#f1d500]"
                                    : "bg-[#ff8e8ef2]"
                                }`}
                              >
                                {item.estimate === null ||
                                item.estimate === "" ? (
                                  ""
                                ) : (
                                  <>
                                    {item.actual - item.estimate > 0
                                      ? "+"
                                      : item.actual - item.estimate === 0
                                      ? ""
                                      : "-"}
                                  </>
                                )}
                              </td>

                              {/* <---------final------> */}
                              <td
                                className={`py-2 border border-r-4 border-[#F6F6F6] text-[#240d3a] font-semibold ${
                                  item.actual - item.estimate === 0 ||
                                  item.estimate === null ||
                                  item.estimate === ""
                                    ? item.actual - item.previous > 0
                                      ? "bg-[#5de98e]"
                                      : item.actual - item.previous === 0
                                      ? "bg-[#f1d500]"
                                      : "bg-[#ff8e8ef2]"
                                    : item.actual - item.estimate > 0
                                    ? "bg-[#5de98e]"
                                    : item.actual - item.estimate === 0 ||
                                      item.estimate === null ||
                                      item.estimate === ""
                                    ? "bg-[#f1d500]"
                                    : "bg-[#ff8e8ef2]"
                                }`}
                              >
                                {item.actual - item.estimate === 0 ||
                                item.estimate === null ||
                                item.estimate === ""
                                  ? item.actual - item.previous > 0
                                    ? "+"
                                    : item.actual - item.previous === 0
                                    ? ""
                                    : "-"
                                  : item.actual - item.estimate > 0
                                  ? "+"
                                  : item.actual - item.estimate === 0
                                  ? ""
                                  : "-"}
                              </td>

                              {/* <----ashi 1st block ---> */}

                              {country === "AU" ? (
                                <>
                                  <td
                                    className={`py-2   border-r-4 border-[#F6F6F6] ${
                                      typeof diffgbpcad === "number"
                                        ? (
                                            country === "JP"
                                              ? diffgbpcad.toFixed(3) ===
                                                  "0.000" ||
                                                diffgbpcad.toFixed(3) ===
                                                  "-0.000"
                                              : diffgbpcad.toFixed(5) ===
                                                  "0.00000" ||
                                                diffgbpcad.toFixed(5) ===
                                                  "-0.00000"
                                          )
                                          ? "bg-[#f7dc14]"
                                          : typeof diffgbpcad === "number" &&
                                            diffgbpcad > 0
                                          ? "bg-[#7fe9a4]"
                                          : "bg-[#f3b2b2]"
                                        : "bg-[#E5E7EB]"
                                    }`}
                                  >
                                    {typeof diffgbpcad === "number"
                                      ? (
                                          country === "JP"
                                            ? diffgbpcad.toFixed(3) ===
                                                "0.000" ||
                                              diffgbpcad.toFixed(3) === "-0.000"
                                            : diffgbpcad.toFixed(5) ===
                                                "0.00000" ||
                                              diffgbpcad.toFixed(5) ===
                                                "-0.00000"
                                        )
                                        ? ""
                                        : typeof diffgbpcad === "number" &&
                                          diffgbpcad > 0
                                        ? "+"
                                        : "-"
                                      : "N/A"}
                                  </td>

                                  <td
                                    className={`py-2 border  min-w-[91.95px] ${
                                      typeof diffgbpchf === "number"
                                        ? (
                                            country === "JP"
                                              ? diffgbpchf.toFixed(3) ===
                                                  "0.000" ||
                                                diffgbpchf.toFixed(3) ===
                                                  "-0.000"
                                              : diffgbpchf.toFixed(5) ===
                                                  "0.00000" ||
                                                diffgbpchf.toFixed(5) ===
                                                  "-0.00000"
                                          )
                                          ? "bg-[#f7dc14]"
                                          : typeof diffgbpchf === "number" &&
                                            diffgbpchf > 0
                                          ? "bg-[#7fe9a4]"
                                          : "bg-[#f3b2b2]"
                                        : "bg-[#E5E7EB]"
                                    }`}
                                  >
                                    {typeof diffgbpchf === "number"
                                      ? (
                                          country === "JP"
                                            ? diffgbpchf.toFixed(3) ===
                                                "0.000" ||
                                              diffgbpchf.toFixed(3) === "-0.000"
                                            : diffgbpchf.toFixed(5) ===
                                                "0.00000" ||
                                              diffgbpchf.toFixed(5) ===
                                                "-0.00000"
                                        )
                                        ? ""
                                        : typeof diffgbpchf === "number" &&
                                          diffgbpchf > 0
                                        ? "+"
                                        : "-"
                                      : "N/A"}
                                  </td>

                                  <td
                                    className={`py-2 border  min-w-[91.95px] ${
                                      typeof diffeurgbp === "number"
                                        ? (
                                            country === "JP"
                                              ? diffeurgbp.toFixed(3) ===
                                                  "0.000" ||
                                                diffeurgbp.toFixed(3) ===
                                                  "-0.000"
                                              : diffeurgbp.toFixed(5) ===
                                                  "0.00000" ||
                                                diffeurgbp.toFixed(5) ===
                                                  "-0.00000"
                                          )
                                          ? "bg-[#f7dc14]"
                                          : typeof diffeurgbp === "number" &&
                                            diffeurgbp > 0
                                          ? "bg-[#7fe9a4]"
                                          : "bg-[#f3b2b2]"
                                        : "bg-[#E5E7EB]"
                                    }`}
                                  >
                                    {typeof diffeurgbp === "number"
                                      ? (
                                          country === "JP"
                                            ? diffeurgbp.toFixed(3) ===
                                                "0.000" ||
                                              diffeurgbp.toFixed(3) === "-0.000"
                                            : diffeurgbp.toFixed(5) ===
                                                "0.00000" ||
                                              diffeurgbp.toFixed(5) ===
                                                "-0.00000"
                                        )
                                        ? ""
                                        : typeof diffeurgbp === "number" &&
                                          diffeurgbp > 0
                                        ? "+"
                                        : "-"
                                      : "N/A"}
                                  </td>
                                  <td
                                    className={`py-2 border  min-w-[91.95px] ${
                                      typeof diffgbpaud === "number"
                                        ? (
                                            country === "JP"
                                              ? diffgbpaud.toFixed(3) ===
                                                  "0.000" ||
                                                diffgbpaud.toFixed(3) ===
                                                  "-0.000"
                                              : diffgbpaud.toFixed(5) ===
                                                  "0.00000" ||
                                                diffgbpaud.toFixed(5) ===
                                                  "-0.00000"
                                          )
                                          ? "bg-[#f7dc14]"
                                          : typeof diffgbpaud === "number" &&
                                            diffgbpaud > 0
                                          ? "bg-[#7fe9a4]"
                                          : "bg-[#f3b2b2]"
                                        : "bg-[#E5E7EB]"
                                    }`}
                                  >
                                    {typeof diffgbpaud === "number"
                                      ? (
                                          country === "JP"
                                            ? diffgbpaud.toFixed(3) ===
                                                "0.000" ||
                                              diffgbpaud.toFixed(3) === "-0.000"
                                            : diffgbpaud.toFixed(5) ===
                                                "0.00000" ||
                                              diffgbpaud.toFixed(5) ===
                                                "-0.00000"
                                        )
                                        ? ""
                                        : typeof diffgbpaud === "number" &&
                                          diffgbpaud > 0
                                        ? "+"
                                        : "-"
                                      : "N/A"}
                                  </td>

                                  {country === "US" || country === "NZ" ? (
                                    <>
                                      <td
                                        className={`py-2 border min-w-[91.95px] ${
                                          typeof diffnzdgbp === "number"
                                            ? (
                                                country === "JP"
                                                  ? diffnzdgbp.toFixed(3) ===
                                                      "0.000" ||
                                                    diffnzdgbp.toFixed(3) ===
                                                      "-0.000"
                                                  : diffnzdgbp.toFixed(5) ===
                                                      "0.00000" ||
                                                    diffnzdgbp.toFixed(5) ===
                                                      "-0.00000"
                                              )
                                              ? "bg-[#f7dc14]"
                                              : typeof diffnzdgbp ===
                                                  "number" && diffnzdgbp > 0
                                              ? "bg-[#7fe9a4]"
                                              : "bg-[#f3b2b2]"
                                            : "bg-[#E5E7EB]"
                                        }`}
                                      >
                                        {typeof diffnzdgbp === "number"
                                          ? (
                                              country === "JP"
                                                ? diffnzdgbp.toFixed(3) ===
                                                    "0.000" ||
                                                  diffnzdgbp.toFixed(3) ===
                                                    "-0.000"
                                                : diffnzdgbp.toFixed(5) ===
                                                    "0.00000" ||
                                                  diffnzdgbp.toFixed(5) ===
                                                    "-0.00000"
                                            )
                                            ? ""
                                            : typeof diffnzdgbp === "number" &&
                                              diffnzdgbp > 0
                                            ? "+"
                                            : "-"
                                          : "N/A"}
                                      </td>

                                      <td
                                        className={`py-2 border min-w-[91.95px] ${
                                          typeof jpydiff === "number"
                                            ? jpydiff.toFixed(3) === "0.000" ||
                                              jpydiff.toFixed(3) === "-0.000"
                                              ? "bg-[#f7dc14]"
                                              : typeof jpydiff === "number" &&
                                                jpydiff > 0
                                              ? "bg-[#7fe9a4]"
                                              : "bg-[#f3b2b2]"
                                            : "bg-[#E5E7EB]"
                                        }`}
                                      >
                                        {typeof jpydiff === "number"
                                          ? jpydiff.toFixed(3) === "0.000" ||
                                            jpydiff.toFixed(3) === "-0.000"
                                            ? ""
                                            : typeof jpydiff === "number" &&
                                              jpydiff > 0
                                            ? "+"
                                            : "-"
                                          : "N/A"}
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      <td
                                        className={`py-2 border min-w-[91.95px] ${
                                          typeof jpydiff === "number"
                                            ? jpydiff.toFixed(3) === "0.000" ||
                                              jpydiff.toFixed(3) === "-0.000"
                                              ? "bg-[#f7dc14]"
                                              : typeof jpydiff === "number" &&
                                                jpydiff > 0
                                              ? "bg-[#7fe9a4]"
                                              : "bg-[#f3b2b2]"
                                            : "bg-[#E5E7EB]"
                                        }`}
                                      >
                                        {typeof jpydiff === "number"
                                          ? jpydiff.toFixed(3) === "0.000" ||
                                            jpydiff.toFixed(3) === "-0.000"
                                            ? ""
                                            : typeof jpydiff === "number" &&
                                              jpydiff > 0
                                            ? "+"
                                            : "-"
                                          : "N/A"}
                                      </td>

                                      <td
                                        className={`py-2 border min-w-[91.95px] ${
                                          typeof diffnzdgbp === "number"
                                            ? (
                                                country === "JP"
                                                  ? diffnzdgbp.toFixed(3) ===
                                                      "0.000" ||
                                                    diffnzdgbp.toFixed(3) ===
                                                      "-0.000"
                                                  : diffnzdgbp.toFixed(5) ===
                                                      "0.00000" ||
                                                    diffnzdgbp.toFixed(5) ===
                                                      "-0.00000"
                                              )
                                              ? "bg-[#f7dc14]"
                                              : typeof diffnzdgbp ===
                                                  "number" && diffnzdgbp > 0
                                              ? "bg-[#7fe9a4]"
                                              : "bg-[#f3b2b2]"
                                            : "bg-[#E5E7EB]"
                                        }`}
                                      >
                                        {typeof diffnzdgbp === "number"
                                          ? (
                                              country === "JP"
                                                ? diffnzdgbp.toFixed(3) ===
                                                    "0.000" ||
                                                  diffnzdgbp.toFixed(3) ===
                                                    "-0.000"
                                                : diffnzdgbp.toFixed(5) ===
                                                    "0.00000" ||
                                                  diffnzdgbp.toFixed(5) ===
                                                    "-0.00000"
                                            )
                                            ? ""
                                            : typeof diffnzdgbp === "number" &&
                                              diffnzdgbp > 0
                                            ? "+"
                                            : "-"
                                          : "N/A"}
                                      </td>
                                    </>
                                  )}

                                  <td
                                    className={`py-2 border min-w-[91.95px] ${
                                      typeof diff === "number"
                                        ? (
                                            country === "JP"
                                              ? diff.toFixed(3) === "0.000" ||
                                                diff.toFixed(3) === "-0.000"
                                              : diff.toFixed(5) === "0.00000" ||
                                                diff.toFixed(5) === "-0.00000"
                                          )
                                          ? "bg-[#f7dc14]"
                                          : typeof diff === "number" && diff > 0
                                          ? "bg-[#7fe9a4]"
                                          : "bg-[#f3b2b2]"
                                        : "bg-[#E5E7EB]"
                                    }`}
                                  >
                                    {typeof diff === "number"
                                      ? (
                                          country === "JP"
                                            ? diff.toFixed(3) === "0.000" ||
                                              diff.toFixed(3) === "-0.000"
                                            : diff.toFixed(5) === "0.00000" ||
                                              diff.toFixed(5) === "-0.00000"
                                        )
                                        ? ""
                                        : typeof diff === "number" && diff > 0
                                        ? "+"
                                        : "-"
                                      : "N/A"}
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td
                                    className={`py-2 border  min-w-[91.95px] ${
                                      typeof diffgbpaud === "number"
                                        ? (
                                            country === "JP"
                                              ? diffgbpaud.toFixed(3) ===
                                                  "0.000" ||
                                                diffgbpaud.toFixed(3) ===
                                                  "-0.000"
                                              : diffgbpaud.toFixed(5) ===
                                                  "0.00000" ||
                                                diffgbpaud.toFixed(5) ===
                                                  "-0.00000"
                                          )
                                          ? "bg-[#f7dc14]"
                                          : typeof diffgbpaud === "number" &&
                                            diffgbpaud > 0
                                          ? "bg-[#7fe9a4]"
                                          : "bg-[#f3b2b2]"
                                        : "bg-[#E5E7EB]"
                                    }`}
                                  >
                                    {typeof diffgbpaud === "number"
                                      ? (
                                          country === "JP"
                                            ? diffgbpaud.toFixed(3) ===
                                                "0.000" ||
                                              diffgbpaud.toFixed(3) === "-0.000"
                                            : diffgbpaud.toFixed(5) ===
                                                "0.00000" ||
                                              diffgbpaud.toFixed(5) ===
                                                "-0.00000"
                                        )
                                        ? ""
                                        : typeof diffgbpaud === "number" &&
                                          diffgbpaud > 0
                                        ? "+"
                                        : "-"
                                      : "N/A"}
                                  </td>
                                  <td
                                    className={`py-2    ${
                                      typeof diffgbpcad === "number"
                                        ? (
                                            country === "JP"
                                              ? diffgbpcad.toFixed(3) ===
                                                  "0.000" ||
                                                diffgbpcad.toFixed(3) ===
                                                  "-0.000"
                                              : diffgbpcad.toFixed(5) ===
                                                  "0.00000" ||
                                                diffgbpcad.toFixed(5) ===
                                                  "-0.00000"
                                          )
                                          ? "bg-[#f7dc14]"
                                          : typeof diffgbpcad === "number" &&
                                            diffgbpcad > 0
                                          ? "bg-[#7fe9a4]"
                                          : "bg-[#f3b2b2]"
                                        : "bg-[#E5E7EB]"
                                    }`}
                                  >
                                    {typeof diffgbpcad === "number"
                                      ? (
                                          country === "JP"
                                            ? diffgbpcad.toFixed(3) ===
                                                "0.000" ||
                                              diffgbpcad.toFixed(3) === "-0.000"
                                            : diffgbpcad.toFixed(5) ===
                                                "0.00000" ||
                                              diffgbpcad.toFixed(5) ===
                                                "-0.00000"
                                        )
                                        ? ""
                                        : typeof diffgbpcad === "number" &&
                                          diffgbpcad > 0
                                        ? "+"
                                        : "-"
                                      : "N/A"}
                                  </td>

                                  <td
                                    className={`py-2 border  min-w-[91.95px] ${
                                      typeof diffgbpchf === "number"
                                        ? (
                                            country === "JP"
                                              ? diffgbpchf.toFixed(3) ===
                                                  "0.000" ||
                                                diffgbpchf.toFixed(3) ===
                                                  "-0.000"
                                              : diffgbpchf.toFixed(5) ===
                                                  "0.00000" ||
                                                diffgbpchf.toFixed(5) ===
                                                  "-0.00000"
                                          )
                                          ? "bg-[#f7dc14]"
                                          : typeof diffgbpchf === "number" &&
                                            diffgbpchf > 0
                                          ? "bg-[#7fe9a4]"
                                          : "bg-[#f3b2b2]"
                                        : "bg-[#E5E7EB]"
                                    }`}
                                  >
                                    {typeof diffgbpchf === "number"
                                      ? (
                                          country === "JP"
                                            ? diffgbpchf.toFixed(3) ===
                                                "0.000" ||
                                              diffgbpchf.toFixed(3) === "-0.000"
                                            : diffgbpchf.toFixed(5) ===
                                                "0.00000" ||
                                              diffgbpchf.toFixed(5) ===
                                                "-0.00000"
                                        )
                                        ? ""
                                        : typeof diffgbpchf === "number" &&
                                          diffgbpchf > 0
                                        ? "+"
                                        : "-"
                                      : "N/A"}
                                  </td>

                                  <td
                                    className={`py-2 border  min-w-[91.95px] ${
                                      typeof diffeurgbp === "number"
                                        ? (
                                            country === "JP"
                                              ? diffeurgbp.toFixed(3) ===
                                                  "0.000" ||
                                                diffeurgbp.toFixed(3) ===
                                                  "-0.000"
                                              : diffeurgbp.toFixed(5) ===
                                                  "0.00000" ||
                                                diffeurgbp.toFixed(5) ===
                                                  "-0.00000"
                                          )
                                          ? "bg-[#f7dc14]"
                                          : typeof diffeurgbp === "number" &&
                                            diffeurgbp > 0
                                          ? "bg-[#7fe9a4]"
                                          : "bg-[#f3b2b2]"
                                        : "bg-[#E5E7EB]"
                                    }`}
                                  >
                                    {typeof diffeurgbp === "number"
                                      ? (
                                          country === "JP"
                                            ? diffeurgbp.toFixed(3) ===
                                                "0.000" ||
                                              diffeurgbp.toFixed(3) === "-0.000"
                                            : diffeurgbp.toFixed(5) ===
                                                "0.00000" ||
                                              diffeurgbp.toFixed(5) ===
                                                "-0.00000"
                                        )
                                        ? ""
                                        : typeof diffeurgbp === "number" &&
                                          diffeurgbp > 0
                                        ? "+"
                                        : "-"
                                      : "N/A"}
                                  </td>

                                  {country === "US" || country === "NZ" ? (
                                    <>
                                      <td
                                        className={`py-2 border min-w-[91.95px] ${
                                          typeof diffnzdgbp === "number"
                                            ? (
                                                country === "JP"
                                                  ? diffnzdgbp.toFixed(3) ===
                                                      "0.000" ||
                                                    diffnzdgbp.toFixed(3) ===
                                                      "-0.000"
                                                  : diffnzdgbp.toFixed(5) ===
                                                      "0.00000" ||
                                                    diffnzdgbp.toFixed(5) ===
                                                      "-0.00000"
                                              )
                                              ? "bg-[#f7dc14]"
                                              : typeof diffnzdgbp ===
                                                  "number" && diffnzdgbp > 0
                                              ? "bg-[#7fe9a4]"
                                              : "bg-[#f3b2b2]"
                                            : "bg-[#E5E7EB]"
                                        }`}
                                      >
                                        {typeof diffnzdgbp === "number"
                                          ? (
                                              country === "JP"
                                                ? diffnzdgbp.toFixed(3) ===
                                                    "0.000" ||
                                                  diffnzdgbp.toFixed(3) ===
                                                    "-0.000"
                                                : diffnzdgbp.toFixed(5) ===
                                                    "0.00000" ||
                                                  diffnzdgbp.toFixed(5) ===
                                                    "-0.00000"
                                            )
                                            ? ""
                                            : typeof diffnzdgbp === "number" &&
                                              diffnzdgbp > 0
                                            ? "+"
                                            : "-"
                                          : "N/A"}
                                      </td>

                                      <td
                                        className={`py-2 border min-w-[91.95px] ${
                                          typeof jpydiff === "number"
                                            ? jpydiff.toFixed(3) === "0.000" ||
                                              jpydiff.toFixed(3) === "-0.000"
                                              ? "bg-[#f7dc14]"
                                              : typeof jpydiff === "number" &&
                                                jpydiff > 0
                                              ? "bg-[#7fe9a4]"
                                              : "bg-[#f3b2b2]"
                                            : "bg-[#E5E7EB]"
                                        }`}
                                      >
                                        {typeof jpydiff === "number"
                                          ? jpydiff.toFixed(3) === "0.000" ||
                                            jpydiff.toFixed(3) === "-0.000"
                                            ? ""
                                            : typeof jpydiff === "number" &&
                                              jpydiff > 0
                                            ? "+"
                                            : "-"
                                          : "N/A"}
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      <td
                                        className={`py-2 border min-w-[91.95px] ${
                                          typeof jpydiff === "number"
                                            ? jpydiff.toFixed(3) === "0.000" ||
                                              jpydiff.toFixed(3) === "-0.000"
                                              ? "bg-[#f7dc14]"
                                              : typeof jpydiff === "number" &&
                                                jpydiff > 0
                                              ? "bg-[#7fe9a4]"
                                              : "bg-[#f3b2b2]"
                                            : "bg-[#E5E7EB]"
                                        }`}
                                      >
                                        {typeof jpydiff === "number"
                                          ? jpydiff.toFixed(3) === "0.000" ||
                                            jpydiff.toFixed(3) === "-0.000"
                                            ? ""
                                            : typeof jpydiff === "number" &&
                                              jpydiff > 0
                                            ? "+"
                                            : "-"
                                          : "N/A"}
                                      </td>

                                      <td
                                        className={`py-2 border min-w-[91.95px] ${
                                          typeof diffnzdgbp === "number"
                                            ? (
                                                country === "JP"
                                                  ? diffnzdgbp.toFixed(3) ===
                                                      "0.000" ||
                                                    diffnzdgbp.toFixed(3) ===
                                                      "-0.000"
                                                  : diffnzdgbp.toFixed(5) ===
                                                      "0.00000" ||
                                                    diffnzdgbp.toFixed(5) ===
                                                      "-0.00000"
                                              )
                                              ? "bg-[#f7dc14]"
                                              : typeof diffnzdgbp ===
                                                  "number" && diffnzdgbp > 0
                                              ? "bg-[#7fe9a4]"
                                              : "bg-[#f3b2b2]"
                                            : "bg-[#E5E7EB]"
                                        }`}
                                      >
                                        {typeof diffnzdgbp === "number"
                                          ? (
                                              country === "JP"
                                                ? diffnzdgbp.toFixed(3) ===
                                                    "0.000" ||
                                                  diffnzdgbp.toFixed(3) ===
                                                    "-0.000"
                                                : diffnzdgbp.toFixed(5) ===
                                                    "0.00000" ||
                                                  diffnzdgbp.toFixed(5) ===
                                                    "-0.00000"
                                            )
                                            ? ""
                                            : typeof diffnzdgbp === "number" &&
                                              diffnzdgbp > 0
                                            ? "+"
                                            : "-"
                                          : "N/A"}
                                      </td>
                                    </>
                                  )}

                                  <td
                                    className={`py-2 border min-w-[91.95px] ${
                                      typeof diff === "number"
                                        ? (
                                            country === "JP"
                                              ? diff.toFixed(3) === "0.000" ||
                                                diff.toFixed(3) === "-0.000"
                                              : diff.toFixed(5) === "0.00000" ||
                                                diff.toFixed(5) === "-0.00000"
                                          )
                                          ? "bg-[#f7dc14]"
                                          : typeof diff === "number" && diff > 0
                                          ? "bg-[#7fe9a4]"
                                          : "bg-[#f3b2b2]"
                                        : "bg-[#E5E7EB]"
                                    }`}
                                  >
                                    {typeof diff === "number"
                                      ? (
                                          country === "JP"
                                            ? diff.toFixed(3) === "0.000" ||
                                              diff.toFixed(3) === "-0.000"
                                            : diff.toFixed(5) === "0.00000" ||
                                              diff.toFixed(5) === "-0.00000"
                                        )
                                        ? ""
                                        : typeof diff === "number" && diff > 0
                                        ? "+"
                                        : "-"
                                      : "N/A"}
                                  </td>
                                </>
                              )}

                              {/* <--anindita---> */}
                              {/* <------2nd block starts from here------> */}
                              {country === "AU" ? (
                                <>
                                  <td
                                    className={`py-2    ${renderTableRows_avg_colorcode2_2ndTable(
                                      maxCloseOpen_caddata_3rdcol_2ndtable,
                                      item.date
                                    )} border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {/* {typeof diffgbpcad === "number"
                                      ? (
                                          country === "JP"
                                            ? diffgbpcad.toFixed(3) ===
                                                "0.000" ||
                                              diffgbpcad.toFixed(3) === "-0.000"
                                            : diffgbpcad.toFixed(5) ===
                                                "0.00000" ||
                                              diffgbpcad.toFixed(5) ===
                                                "-0.00000"
                                        )
                                        ? ""
                                        : typeof diffgbpcad === "number" &&
                                          diffgbpcad > 0
                                        ? "+"
                                        : "-"
                                      : "N/A"} */}
                                    {renderTableRows_avg2_2ndTable(
                                      maxCloseOpen_caddata_3rdcol_2ndtable,
                                      item.date
                                    )}
                                  </td>

                                  <td
                                    className={`py-2    ${renderTableRows_avg_colorcode2_2ndTable(
                                      renderTableRows_avg2_2ndTable,
                                      item.date
                                    )} border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {renderTableRows_avg2_2ndTable(
                                      maxCloseOpen_chfdata_3rdcol_2ndtable,
                                      item.date
                                    )}
                                  </td>

                                  <td
                                    className={`py-2  ${renderTableRows_avg_colorcode2_2ndTable(
                                      maxCloseOpen_eurdata_3rdcol_2ndtable,
                                      item.date
                                    )} border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {renderTableRows_avg2_2ndTable(
                                      maxCloseOpen_eurdata_3rdcol_2ndtable,
                                      item.date
                                    )}
                                  </td>
                                  <td
                                    className={`py-2  ${renderTableRows_avg_colorcode2_2ndTable(
                                      maxCloseOpen_auddata_3rdcol_2ndtable,
                                      item.date
                                    )}  border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {renderTableRows_avg2_2ndTable(
                                      maxCloseOpen_auddata_3rdcol_2ndtable,
                                      item.date
                                    )}
                                  </td>
                                  {country === "US" || country === "NZ" ? (
                                    <>
                                      <td
                                        className={`py-2 ${renderTableRows_avg_colorcode2_2ndTable(
                                          maxCloseOpen_nzddata_3rdcol_2ndtable,
                                          item.date
                                        )}  border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                      >
                                        {/* <vivek--></vivek--> */}
                                        {renderTableRows_avg2_2ndTable(
                                          maxCloseOpen_nzddata_3rdcol_2ndtable,
                                          item.date
                                        )}
                                      </td>
                                      <td
                                        className={`py-2 ${renderTableRows_avg_colorcode2_2ndTable(
                                          maxCloseOpen_jpydata_3rdcol_2ndtable,
                                          item.date
                                        )} border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                      >
                                        {renderTableRows_avg2_2ndTable(
                                          maxCloseOpen_jpydata_3rdcol_2ndtable,
                                          item.date
                                        )}
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      <td
                                        className={`py-2    ${renderTableRows_avg_colorcode2_2ndTable(
                                          maxCloseOpen_jpydata_3rdcol_2ndtable,
                                          item.date
                                        )} border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                      >
                                        {renderTableRows_avg2_2ndTable(
                                          maxCloseOpen_jpydata_3rdcol_2ndtable,
                                          item.date
                                        )}
                                      </td>

                                      <td
                                        className={`py-2  ${renderTableRows_avg_colorcode2_2ndTable(
                                          maxCloseOpen_nzddata_3rdcol_2ndtable,
                                          item.date
                                        )} border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                      >
                                        {/* <vivek--></vivek--> */}
                                        {renderTableRows_avg2_2ndTable(
                                          maxCloseOpen_nzddata_3rdcol_2ndtable,
                                          item.date
                                        )}
                                      </td>
                                    </>
                                  )}

                                  <td
                                    className={`py-2  ${renderTableRows_avg_colorcode2_2ndTable(
                                      maxCloseOpen_usddata_3rdcol_2ndtable,
                                      item.date
                                    )} border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {renderTableRows_avg2_2ndTable(
                                      maxCloseOpen_usddata_3rdcol_2ndtable,
                                      item.date
                                    )}
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td
                                    className={`py-2  ${renderTableRows_avg_colorcode2_2ndTable(
                                      maxCloseOpen_auddata_3rdcol_2ndtable,
                                      item.date
                                    )} border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {renderTableRows_avg2_2ndTable(
                                      maxCloseOpen_auddata_3rdcol_2ndtable,
                                      item.date
                                    )}
                                  </td>

                                  <td
                                    className={`py-2  ${renderTableRows_avg_colorcode2_2ndTable(
                                      maxCloseOpen_caddata_3rdcol_2ndtable,
                                      item.date
                                    )}  border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {renderTableRows_avg2_2ndTable(
                                      maxCloseOpen_caddata_3rdcol_2ndtable,
                                      item.date
                                    )}
                                  </td>

                                  <td
                                    className={`py-2   ${renderTableRows_avg_colorcode2_2ndTable(
                                      maxCloseOpen_chfdata_3rdcol_2ndtable,
                                      item.date
                                    )} border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {renderTableRows_avg2_2ndTable(
                                      maxCloseOpen_chfdata_3rdcol_2ndtable,
                                      item.date
                                    )}
                                  </td>

                                  <td
                                    className={`py-2   ${renderTableRows_avg_colorcode2_2ndTable(
                                      maxCloseOpen_eurdata_3rdcol_2ndtable,
                                      item.date
                                    )} border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {renderTableRows_avg2_2ndTable(
                                      maxCloseOpen_eurdata_3rdcol_2ndtable,
                                      item.date
                                    )}
                                  </td>
                                  {country === "US" || country === "NZ" ? (
                                    <>
                                      <td
                                        className={`py-2   ${renderTableRows_avg_colorcode2_2ndTable(
                                          maxCloseOpen_nzddata_3rdcol_2ndtable,
                                          item.date
                                        )} border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                      >
                                        {renderTableRows_avg2_2ndTable(
                                          maxCloseOpen_nzddata_3rdcol_2ndtable,
                                          item.date
                                        )}
                                      </td>
                                      <td
                                        className={`py-2  ${renderTableRows_avg_colorcode2_2ndTable(
                                          maxCloseOpen_jpydata_3rdcol_2ndtable,
                                          item.date
                                        )} border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                      >
                                        {renderTableRows_avg2_2ndTable(
                                          maxCloseOpen_jpydata_3rdcol_2ndtable,
                                          item.date
                                        )}
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      <td
                                        className={`py-2  ${renderTableRows_avg_colorcode2_2ndTable(
                                          maxCloseOpen_jpydata_3rdcol_2ndtable,
                                          item.date
                                        )}  border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                      >
                                        {renderTableRows_avg2_2ndTable(
                                          maxCloseOpen_jpydata_3rdcol_2ndtable,
                                          item.date
                                        )}
                                      </td>

                                      <td
                                        className={`py-2 ${renderTableRows_avg_colorcode2_2ndTable(
                                          maxCloseOpen_nzddata_3rdcol_2ndtable,
                                          item.date
                                        )} border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                      >
                                        {renderTableRows_avg2_2ndTable(
                                          maxCloseOpen_nzddata_3rdcol_2ndtable,
                                          item.date
                                        )}
                                      </td>
                                    </>
                                  )}

                                  <td
                                    className={`py-2   ${renderTableRows_avg_colorcode2_2ndTable(
                                      maxCloseOpen_usddata_3rdcol_2ndtable,
                                      item.date
                                    )}  border border-r-2 border-[#F6F6F6] min-w-[91.95px]`}
                                  >
                                    {renderTableRows_avg2_2ndTable(
                                      maxCloseOpen_usddata_3rdcol_2ndtable,
                                      item.date
                                    )}
                                  </td>
                                </>
                              )}
                            </tr>
                          </>
                        );
                      })}

                      <tr className="bg-[#dccafe5e] text-center">
                        <td
                          className="py-2  font-bold   min-w-[80.8px]"
                          colSpan={4}
                        >
                          % data missing
                        </td>
                        {/* <td className="py-2 "></td>
                                 <td className="py-2 "></td> */}
                        {/* <td className="py-2 "></td> */}
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>

                        {country === "AU" ? (
                          <>
                            <td className="py-2 ">
                              {countemp(arraygbpcad).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countemp(arraygbpchf).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countemp(arraygbpeur).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countemp(arraygbpaud).toFixed(2)}%
                            </td>

                            {country === "US" || country === "NZ" ? (
                              <>
                                <td className="py-2 ">
                                  {countemp(arraygbpnzd).toFixed(2)}%
                                </td>
                                <td className="py-2 ">
                                  {countemp(arraygbpjpy).toFixed(2)}%
                                </td>
                              </>
                            ) : (
                              <>
                                {" "}
                                <td className="py-2 ">
                                  {countemp(arraygbpjpy).toFixed(2)}%
                                </td>
                                <td className="py-2 ">
                                  {countemp(arraygbpnzd).toFixed(2)}%
                                </td>
                              </>
                            )}

                            <td className="py-2 ">
                              {countemp(arraygbpusd).toFixed(2)}%
                            </td>
                          </>
                        ) : (
                          <>
                            <td className="py-2 ">
                              {countemp(arraygbpaud).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countemp(arraygbpcad).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countemp(arraygbpchf).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countemp(arraygbpeur).toFixed(2)}%
                            </td>
                            {country === "US" || country === "NZ" ? (
                              <>
                                <td className="py-2 ">
                                  {countemp(arraygbpnzd).toFixed(2)}%
                                </td>
                                <td className="py-2 ">
                                  {countemp(arraygbpjpy).toFixed(2)}%
                                </td>
                              </>
                            ) : (
                              <>
                                {" "}
                                <td className="py-2 ">
                                  {countemp(arraygbpjpy).toFixed(2)}%
                                </td>
                                <td className="py-2 ">
                                  {countemp(arraygbpnzd).toFixed(2)}%
                                </td>
                              </>
                            )}
                            <td className="py-2 ">
                              {countemp(arraygbpusd).toFixed(2)}%
                            </td>
                          </>
                        )}
                      </tr>
                      <tr className="bg-[#dccafe5e] text-center">
                        <td className="py-2 font-bold " colSpan={4}>
                          Non- Zero event (Positive currency correlation)
                        </td>
                        {/* <td className="py-2 "></td>
                                 <td className="py-2 "></td> */}
                        {/* <td className="py-2 "></td> */}
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>

                        <td className="py-2 "></td>

                        {country === "AU" ? (
                          <>
                            <td className="py-2 ">
                              {countPositive(arraygbpcad).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countPositive(arraygbpchf).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countPositive(arraygbpeur).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countPositive(arraygbpaud).toFixed(2)}%
                            </td>
                            {country === "US" || country === "NZ" ? (
                              <>
                                <td className="py-2 ">
                                  {countPositive(arraygbpnzd).toFixed(2)}%
                                </td>
                                <td className="py-2 ">
                                  {countPositive(arraygbpjpy).toFixed(2)}%
                                </td>
                              </>
                            ) : (
                              <>
                                {" "}
                                <td className="py-2 ">
                                  {countPositive(arraygbpjpy).toFixed(2)}%
                                </td>
                                <td className="py-2 ">
                                  {countPositive(arraygbpnzd).toFixed(2)}%
                                </td>
                              </>
                            )}

                            <td className="py-2 ">
                              {countPositive(arraygbpusd).toFixed(2)}%
                            </td>
                          </>
                        ) : (
                          <>
                            <td className="py-2 ">
                              {countPositive(arraygbpaud).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countPositive(arraygbpcad).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countPositive(arraygbpchf).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countPositive(arraygbpeur).toFixed(2)}%
                            </td>
                            {country === "US" || country === "NZ" ? (
                              <>
                                <td className="py-2 ">
                                  {countPositive(arraygbpnzd).toFixed(2)}%
                                </td>
                                <td className="py-2 ">
                                  {countPositive(arraygbpjpy).toFixed(2)}%
                                </td>
                              </>
                            ) : (
                              <>
                                {" "}
                                <td className="py-2 ">
                                  {countPositive(arraygbpjpy).toFixed(2)}%
                                </td>
                                <td className="py-2 ">
                                  {countPositive(arraygbpnzd).toFixed(2)}%
                                </td>
                              </>
                            )}
                            <td className="py-2 ">
                              {countPositive(arraygbpusd).toFixed(2)}%
                            </td>
                          </>
                        )}
                      </tr>
                      <tr className="bg-[#dccafe5e] text-center">
                        <td className="py-2 font-bold " colSpan={4}>
                          Non- Zero event (Negative currency correlation)
                        </td>
                        {/* <td className="py-2 "></td>
                                 <td className="py-2 "></td>
                                 <td className="py-2 "></td> */}
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>

                        <td className="py-2 "></td>
                        {country === "AU" ? (
                          <>
                            <td className="py-2 ">
                              {countNegative(arraygbpcad).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countNegative(arraygbpchf).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countNegative(arraygbpeur).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countNegative(arraygbpaud).toFixed(2)}%
                            </td>
                            {country === "US" || country === "NZ" ? (
                              <>
                                <td className="py-2 ">
                                  {countNegative(arraygbpnzd).toFixed(2)}%
                                </td>
                                <td className="py-2 ">
                                  {countNegative(arraygbpjpy).toFixed(2)}%
                                </td>
                              </>
                            ) : (
                              <>
                                {" "}
                                <td className="py-2 ">
                                  {countNegative(arraygbpjpy).toFixed(2)}%
                                </td>
                                <td className="py-2 ">
                                  {countNegative(arraygbpnzd).toFixed(2)}%
                                </td>
                              </>
                            )}

                            <td className="py-2 ">
                              {countNegative(arraygbpusd).toFixed(2)}%
                            </td>
                          </>
                        ) : (
                          <>
                            <td className="py-2 ">
                              {countNegative(arraygbpaud).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countNegative(arraygbpcad).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countNegative(arraygbpchf).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countNegative(arraygbpeur).toFixed(2)}%
                            </td>
                            {country === "US" || country === "NZ" ? (
                              <>
                                <td className="py-2 ">
                                  {countNegative(arraygbpnzd).toFixed(2)}%
                                </td>
                                <td className="py-2 ">
                                  {countNegative(arraygbpjpy).toFixed(2)}%
                                </td>
                              </>
                            ) : (
                              <>
                                {" "}
                                <td className="py-2 ">
                                  {countNegative(arraygbpjpy).toFixed(2)}%
                                </td>
                                <td className="py-2 ">
                                  {countNegative(arraygbpnzd).toFixed(2)}%
                                </td>
                              </>
                            )}
                            <td className="py-2 ">
                              {countNegative(arraygbpusd).toFixed(2)}%
                            </td>
                          </>
                        )}
                      </tr>
                      <tr className="bg-[#dccafe5e] text-center">
                        <td className="py-2 font-bold " colSpan={4}>
                          Flat event (Positive currency correlation)
                        </td>
                        {/* <td className="py-2 "></td>
                                 <td className="py-2 "></td>
                                 <td className="py-2 "></td> */}
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>

                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        {country === "AU" ? (
                          <>
                            <td className="py-2 ">
                              {countPositivePositive(arraygbpcad).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countPositivePositive(arraygbpchf).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countPositivePositive(arraygbpeur).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countPositivePositive(arraygbpaud).toFixed(2)}%
                            </td>
                            {country === "US" || country === "NZ" ? (
                              <>
                                <td className="py-2 ">
                                  {countPositivePositive(arraygbpnzd).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                                <td className="py-2 ">
                                  {countPositivePositive(arraygbpjpy).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                              </>
                            ) : (
                              <>
                                {" "}
                                <td className="py-2 ">
                                  {countPositivePositive(arraygbpjpy).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                                <td className="py-2 ">
                                  {countPositivePositive(arraygbpnzd).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                              </>
                            )}

                            <td className="py-2 ">
                              {countPositivePositive(arraygbpusd).toFixed(2)}%
                            </td>
                          </>
                        ) : (
                          <>
                            <td className="py-2 ">
                              {countPositivePositive(arraygbpaud).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countPositivePositive(arraygbpcad).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countPositivePositive(arraygbpchf).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countPositivePositive(arraygbpeur).toFixed(2)}%
                            </td>
                            {country === "US" || country === "NZ" ? (
                              <>
                                <td className="py-2 ">
                                  {countPositivePositive(arraygbpnzd).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                                <td className="py-2 ">
                                  {countPositivePositive(arraygbpjpy).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                              </>
                            ) : (
                              <>
                                {" "}
                                <td className="py-2 ">
                                  {countPositivePositive(arraygbpjpy).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                                <td className="py-2 ">
                                  {countPositivePositive(arraygbpnzd).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                              </>
                            )}
                            <td className="py-2 ">
                              {countPositivePositive(arraygbpusd).toFixed(2)}%
                            </td>
                          </>
                        )}
                      </tr>
                      <tr className="bg-[#dccafe5e] text-center">
                        <td className="py-2 font-bold" colSpan={4}>
                          Flat event (Negative currency correlation)
                        </td>
                        {/* <td className="py-2 "></td>
                                 <td className="py-2 "></td>
                                 <td className="py-2 "></td> */}
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>

                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        {country === "AU" ? (
                          <>
                            <td className="py-2 ">
                              {countNegativeNegative(arraygbpcad).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countNegativeNegative(arraygbpchf).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countNegativeNegative(arraygbpeur).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countNegativeNegative(arraygbpaud).toFixed(2)}%
                            </td>

                            {country === "US" || country === "NZ" ? (
                              <>
                                <td className="py-2 ">
                                  {countNegativeNegative(arraygbpnzd).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                                <td className="py-2 ">
                                  {countNegativeNegative(arraygbpjpy).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                              </>
                            ) : (
                              <>
                                {" "}
                                <td className="py-2 ">
                                  {countNegativeNegative(arraygbpjpy).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                                <td className="py-2 ">
                                  {countNegativeNegative(arraygbpnzd).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                              </>
                            )}

                            <td className="py-2 ">
                              {countNegativeNegative(arraygbpusd).toFixed(2)}%
                            </td>
                          </>
                        ) : (
                          <>
                            <td className="py-2 ">
                              {countNegativeNegative(arraygbpaud).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countNegativeNegative(arraygbpcad).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countNegativeNegative(arraygbpchf).toFixed(2)}%
                            </td>
                            <td className="py-2 ">
                              {countNegativeNegative(arraygbpeur).toFixed(2)}%
                            </td>

                            {country === "US" || country === "NZ" ? (
                              <>
                                <td className="py-2 ">
                                  {countNegativeNegative(arraygbpnzd).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                                <td className="py-2 ">
                                  {countNegativeNegative(arraygbpjpy).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                              </>
                            ) : (
                              <>
                                {" "}
                                <td className="py-2 ">
                                  {countNegativeNegative(arraygbpjpy).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                                <td className="py-2 ">
                                  {countNegativeNegative(arraygbpnzd).toFixed(
                                    2
                                  )}
                                  %
                                </td>
                              </>
                            )}
                            <td className="py-2 ">
                              {countNegativeNegative(arraygbpusd).toFixed(2)}%
                            </td>
                          </>
                        )}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      ) : // <----------if no data available in backend ( 400 error)---------------->
      !Loading && errorMessage ? (
        <div className="font-semibold m-10 text-xl text-center flex justify-center items-center">
          <p className="error ">{errorMessage}</p>
          <span className="error pl-2 font-bold">{eventname_forerror} ...</span>
          <button
            className={`px-2  mx-4 py-2 text-sm font-medium text-white rounded-md focus:outline-none focus-visible:ring focus-visible:ring-gray-500 focus-visible:ring-opacity-75  bg-slate-500 hover:bg-gray-800
                    `}
            value="Go Back "
            onClick={handlegoback}
          >
            Go Back
          </button>
        </div>
      ) : (
        <div>
          <div className="font-semibold m-6 font-xl text-center flex justify-center items-center ">
            Wait !! Data is in Progress .....
          </div>
          <div className="flex items-center justify-center  w-screen ">
            <Bars
              height="80"
              width="80"
              color="#94A3B8"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              className="loader"
            />
          </div>
        </div>
      )}

      {/* { !Loading && errorMessage && <div className="font-semibold m-6 font-xl text-center flex justify-center items-center h-[50%]"> <p className="error ">{errorMessage}</p> </div>} */}
      <div>
        {modalShow && (
          <div
            id="popup-modal"
            className="fixed top-0 right-0 bottom-0 left-0 flex justify-center items-center bg-black bg-opacity-15 z-[999]"
            onClick={() => setModalshow(!modalShow)}
          >
            <div className="relative p-4 w-full max-w-md">
              <div className="relative bg-white rounded-lg shadow">
                {/* <button
                  type="button"
                  className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg  w-8 h-8 inline-flex justify-center items-center"
                  data-modal-hide="popup-modal"
                  onClick={() => setModalshow(!modalShow)}
                >
                  <svg
                    className="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                      onClick={() => setModalshow(!modalShow)}
                    />
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button> */}

                <img
                  src={logout_eye_btn}
                  alt="logout_eye_btn"
                  className="h-[33px] w-[33px] absolute top-[12%] left-[47%]"
                />
                <div className="p-4 md:p-5 text-center z-[999]">
                  {/* <div className="flex justify-center items-center mt-5">
                                   <CiCircleInfo size={40} color='grayZ'/>
                                </div> */}

                  <h3 className="mb-5 mt-[15%] text-lg font-bold text-[#240D3A]">
                    Are you sure you want to refresh the page? This action will
                    clear all locally stored data.
                  </h3>
                  <div className="flex items-center justify-center">
                    <button
                      data-modal-hide="popup-modal"
                      type="button"
                      className="text-[#240D3A]  bg-[#ecebeb] mt-3 font-medium rounded-lg  inline-flex items-center justify-center px-3 py-2 w-[20%]"
                      onClick={handleRefresh}
                    >
                      Yes
                    </button>
                    <button
                      data-modal-hide="popup-modal"
                      type="button"
                      className="ml-4 text-white  bg-[#240D3A] mt-3 font-medium rounded-lg  inline-flex items-center justify-center px-3 py-2 w-[20%]"
                      onClick={() => setModalshow(!modalShow)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default EventshistoryUser_AfterRelease;
